import background0 from './0.webp';
import background1 from './1.webp';
import background2 from './2.webp';
import background3 from './3.webp';
import background4 from './4.webp';
import background5 from './5.webp';
import background6 from './6.webp';
import background7 from './7.webp';
import background8 from './8.webp';
import background9 from './9.webp';
import background10 from './10.webp';
import background11 from './11.webp';
import background12 from './12.webp';
import background13 from './13.webp';
import background14 from './14.webp';
import background15 from './15.webp';
import background16 from './16.webp';
import background17 from './17.webp';
import background18 from './18.webp';
import background19 from './19.webp';
import background20 from './20.webp';
import background21 from './21.webp';
import background22 from './22.webp';
import background23 from './23.webp';
import background24 from './24.webp';
import background25 from './25.webp';
import background26 from './26.webp';
import background27 from './27.webp';
import background28 from './28.webp';
import background29 from './29.webp';
import background30 from './30.webp';
import background31 from './31.webp';
import background32 from './32.webp';
import background33 from './33.webp';
import background34 from './34.webp';
import background35 from './35.webp';
import background36 from './36.webp';
import background37 from './37.webp';
import background38 from './38.webp';
import background39 from './39.webp';
import background40 from './40.webp';
import background41 from './41.webp';
import background42 from './42.webp';
import background43 from './43.webp';
import background44 from './44.webp';
import background45 from './45.webp';
import background46 from './46.webp';
import background47 from './47.webp';
import background48 from './48.webp';
import background49 from './49.webp';
import background50 from './50.webp';
import background51 from './51.webp';
import background52 from './52.webp';
import background53 from './53.webp';
import background54 from './54.webp';
import background55 from './55.webp';
import background56 from './56.webp';
import background57 from './57.webp';
import background58 from './58.webp';
import background59 from './59.webp';
import background60 from './60.webp';
import background61 from './61.webp';
import background62 from './62.webp';
import background63 from './63.webp';
import background64 from './64.webp';
import background65 from './65.webp';
import background66 from './66.webp';
import background67 from './67.webp';
import background68 from './68.webp';
import background69 from './69.webp';
import background70 from './70.webp';
import background71 from './71.webp';
import background72 from './72.webp';
import background73 from './73.webp';
import background74 from './74.webp';
import background75 from './75.webp';
import background76 from './76.webp';
import background77 from './77.webp';
import background78 from './78.webp';
import background79 from './79.webp';
import background80 from './80.webp';
import background81 from './81.webp';
import background82 from './82.webp';
import background83 from './83.webp';
import background84 from './84.webp';
import background85 from './85.webp';
import background86 from './86.webp';
import background87 from './87.webp';
import background88 from './88.webp';
import background89 from './89.webp';
import background90 from './90.webp';
import background91 from './91.webp';
import background92 from './92.webp';
import background93 from './93.webp';
import background94 from './94.webp';
import background95 from './95.webp';
import background96 from './96.webp';
import background97 from './97.webp';
import background98 from './98.webp';
import background99 from './99.webp';
import background100 from './100.webp';
import background101 from './101.webp';
import background102 from './102.webp';
import background103 from './103.webp';
import background104 from './104.webp';
import background105 from './105.webp';
import background106 from './106.webp';
import background107 from './107.webp';
import background108 from './108.webp';
import background109 from './109.webp';
import background110 from './110.webp';
import background111 from './111.webp';
import background112 from './112.webp';
import background113 from './113.webp';
import background114 from './114.webp';
import background115 from './115.webp';
import background116 from './116.webp';
import background117 from './117.webp';
import background118 from './118.webp';
import background119 from './119.webp';

const emojiInfoMapType = {
  '😀': {
    emoji: '😀',
    backgroundImage: background0,
    backgroundPosition: [-1, -3],
  },
  '😃': {
    emoji: '😃',
    backgroundImage: background0,
    backgroundPosition: [-4, -3],
  },
  '😄': {
    emoji: '😄',
    backgroundImage: background0,
    backgroundPosition: [0, -4],
  },
  '😁': {
    emoji: '😁',
    backgroundImage: background0,
    backgroundPosition: [-2, -3],
  },
  '😆': {
    emoji: '😆',
    backgroundImage: background0,
    backgroundPosition: [-2, -4],
  },
  '🥹': {
    emoji: '🥹',
    backgroundImage: background1,
    backgroundPosition: [-4, -3],
  },
  '😅': {
    emoji: '😅',
    backgroundImage: background0,
    backgroundPosition: [-1, -4],
  },
  '😂': {
    emoji: '😂',
    backgroundImage: background0,
    backgroundPosition: [-3, -3],
  },
  '🤣': {
    emoji: '🤣',
    backgroundImage: background2,
    backgroundPosition: [-4, 0],
  },
  '🥲': {
    emoji: '🥲',
    backgroundImage: background1,
    backgroundPosition: [-2, -1],
  },
  '☺️': {
    emoji: '☺️',
    backgroundImage: background3,
    backgroundPosition: [-3, 0],
  },
  '😊': {
    emoji: '😊',
    backgroundImage: background4,
    backgroundPosition: [-1, 0],
  },
  '😇': {
    emoji: '😇',
    backgroundImage: background0,
    backgroundPosition: [-3, -4],
  },
  '🙂': {
    emoji: '🙂',
    backgroundImage: background5,
    backgroundPosition: [0, -2],
  },
  '🙃': {
    emoji: '🙃',
    backgroundImage: background5,
    backgroundPosition: [-1, -2],
  },
  '😉': {
    emoji: '😉',
    backgroundImage: background4,
    backgroundPosition: [0, 0],
  },
  '😌': {
    emoji: '😌',
    backgroundImage: background4,
    backgroundPosition: [-3, 0],
  },
  '😍': {
    emoji: '😍',
    backgroundImage: background4,
    backgroundPosition: [-4, 0],
  },
  '🥰': {
    emoji: '🥰',
    backgroundImage: background1,
    backgroundPosition: [0, -1],
  },
  '😘': {
    emoji: '😘',
    backgroundImage: background4,
    backgroundPosition: [0, -3],
  },
  '😗': {
    emoji: '😗',
    backgroundImage: background4,
    backgroundPosition: [-4, -2],
  },
  '😙': {
    emoji: '😙',
    backgroundImage: background4,
    backgroundPosition: [-1, -3],
  },
  '😚': {
    emoji: '😚',
    backgroundImage: background4,
    backgroundPosition: [-2, -3],
  },
  '😋': {
    emoji: '😋',
    backgroundImage: background4,
    backgroundPosition: [-2, 0],
  },
  '😛': {
    emoji: '😛',
    backgroundImage: background4,
    backgroundPosition: [-3, -3],
  },
  '😝': {
    emoji: '😝',
    backgroundImage: background4,
    backgroundPosition: [0, -4],
  },
  '😜': {
    emoji: '😜',
    backgroundImage: background4,
    backgroundPosition: [-4, -3],
  },
  '🤪': {
    emoji: '🤪',
    backgroundImage: background6,
    backgroundPosition: [-3, 0],
  },
  '🤨': {
    emoji: '🤨',
    backgroundImage: background6,
    backgroundPosition: [-1, 0],
  },
  '🧐': {
    emoji: '🧐',
    backgroundImage: background7,
    backgroundPosition: [-1, -1],
  },
  '🤓': {
    emoji: '🤓',
    backgroundImage: background8,
    backgroundPosition: [-3, -4],
  },
  '😎': {
    emoji: '😎',
    backgroundImage: background4,
    backgroundPosition: [0, -1],
  },
  '🥸': {
    emoji: '🥸',
    backgroundImage: background1,
    backgroundPosition: [-3, -3],
  },
  '🤩': {
    emoji: '🤩',
    backgroundImage: background6,
    backgroundPosition: [-2, 0],
  },
  '🥳': {
    emoji: '🥳',
    backgroundImage: background1,
    backgroundPosition: [-3, -1],
  },
  '😏': {
    emoji: '😏',
    backgroundImage: background4,
    backgroundPosition: [-1, -1],
  },
  '😒': {
    emoji: '😒',
    backgroundImage: background4,
    backgroundPosition: [-4, -1],
  },
  '😞': {
    emoji: '😞',
    backgroundImage: background4,
    backgroundPosition: [-1, -4],
  },
  '😔': {
    emoji: '😔',
    backgroundImage: background4,
    backgroundPosition: [-1, -2],
  },
  '😟': {
    emoji: '😟',
    backgroundImage: background4,
    backgroundPosition: [-2, -4],
  },
  '😕': {
    emoji: '😕',
    backgroundImage: background4,
    backgroundPosition: [-2, -2],
  },
  '🙁': {
    emoji: '🙁',
    backgroundImage: background5,
    backgroundPosition: [-4, -1],
  },
  '☹️': {
    emoji: '☹️',
    backgroundImage: background3,
    backgroundPosition: [-2, 0],
  },
  '😣': {
    emoji: '😣',
    backgroundImage: background9,
    backgroundPosition: [-1, 0],
  },
  '😖': {
    emoji: '😖',
    backgroundImage: background4,
    backgroundPosition: [-3, -2],
  },
  '😫': {
    emoji: '😫',
    backgroundImage: background9,
    backgroundPosition: [-4, -1],
  },
  '😩': {
    emoji: '😩',
    backgroundImage: background9,
    backgroundPosition: [-2, -1],
  },
  '🥺': {
    emoji: '🥺',
    backgroundImage: background1,
    backgroundPosition: [0, -4],
  },
  '😢': {
    emoji: '😢',
    backgroundImage: background9,
    backgroundPosition: [0, 0],
  },
  '😭': {
    emoji: '😭',
    backgroundImage: background9,
    backgroundPosition: [-1, -2],
  },
  '😤': {
    emoji: '😤',
    backgroundImage: background9,
    backgroundPosition: [-2, 0],
  },
  '😠': {
    emoji: '😠',
    backgroundImage: background4,
    backgroundPosition: [-3, -4],
  },
  '😡': {
    emoji: '😡',
    backgroundImage: background4,
    backgroundPosition: [-4, -4],
  },
  '🤬': {
    emoji: '🤬',
    backgroundImage: background6,
    backgroundPosition: [0, -1],
  },
  '🤯': {
    emoji: '🤯',
    backgroundImage: background6,
    backgroundPosition: [-3, -1],
  },
  '😳': {
    emoji: '😳',
    backgroundImage: background9,
    backgroundPosition: [-3, -3],
  },
  '🥵': {
    emoji: '🥵',
    backgroundImage: background1,
    backgroundPosition: [0, -2],
  },
  '🥶': {
    emoji: '🥶',
    backgroundImage: background1,
    backgroundPosition: [-1, -2],
  },
  '😶‍🌫️': {
    emoji: '😶‍🌫️',
    backgroundImage: background9,
    backgroundPosition: [-3, -4],
  },
  '😱': {
    emoji: '😱',
    backgroundImage: background9,
    backgroundPosition: [-1, -3],
  },
  '😨': {
    emoji: '😨',
    backgroundImage: background9,
    backgroundPosition: [-1, -1],
  },
  '😰': {
    emoji: '😰',
    backgroundImage: background9,
    backgroundPosition: [0, -3],
  },
  '😥': {
    emoji: '😥',
    backgroundImage: background9,
    backgroundPosition: [-3, 0],
  },
  '😓': {
    emoji: '😓',
    backgroundImage: background4,
    backgroundPosition: [0, -2],
  },
  '🤗': {
    emoji: '🤗',
    backgroundImage: background10,
    backgroundPosition: [-2, 0],
  },
  '🤔': {
    emoji: '🤔',
    backgroundImage: background8,
    backgroundPosition: [-4, -4],
  },
  '🫣': {
    emoji: '🫣',
    backgroundImage: background11,
    backgroundPosition: [-3, -2],
  },
  '🤭': {
    emoji: '🤭',
    backgroundImage: background6,
    backgroundPosition: [-1, -1],
  },
  '🫢': {
    emoji: '🫢',
    backgroundImage: background11,
    backgroundPosition: [-2, -2],
  },
  '🫡': {
    emoji: '🫡',
    backgroundImage: background11,
    backgroundPosition: [-1, -2],
  },
  '🤫': {
    emoji: '🤫',
    backgroundImage: background6,
    backgroundPosition: [-4, 0],
  },
  '🫠': {
    emoji: '🫠',
    backgroundImage: background11,
    backgroundPosition: [0, -2],
  },
  '🤥': {
    emoji: '🤥',
    backgroundImage: background2,
    backgroundPosition: [-1, -1],
  },
  '😶': {
    emoji: '😶',
    backgroundImage: background9,
    backgroundPosition: [-2, -4],
  },
  '🫥': {
    emoji: '🫥',
    backgroundImage: background11,
    backgroundPosition: [0, -3],
  },
  '😐': {
    emoji: '😐',
    backgroundImage: background4,
    backgroundPosition: [-2, -1],
  },
  '🫤': {
    emoji: '🫤',
    backgroundImage: background11,
    backgroundPosition: [-4, -2],
  },
  '😑': {
    emoji: '😑',
    backgroundImage: background4,
    backgroundPosition: [-3, -1],
  },
  '😬': {
    emoji: '😬',
    backgroundImage: background9,
    backgroundPosition: [0, -2],
  },
  '🙄': {
    emoji: '🙄',
    backgroundImage: background5,
    backgroundPosition: [-2, -2],
  },
  '😯': {
    emoji: '😯',
    backgroundImage: background9,
    backgroundPosition: [-4, -2],
  },
  '😦': {
    emoji: '😦',
    backgroundImage: background9,
    backgroundPosition: [-4, 0],
  },
  '😧': {
    emoji: '😧',
    backgroundImage: background9,
    backgroundPosition: [0, -1],
  },
  '😮': {
    emoji: '😮',
    backgroundImage: background9,
    backgroundPosition: [-2, -2],
  },
  '😲': {
    emoji: '😲',
    backgroundImage: background9,
    backgroundPosition: [-2, -3],
  },
  '🥱': {
    emoji: '🥱',
    backgroundImage: background1,
    backgroundPosition: [-1, -1],
  },
  '😴': {
    emoji: '😴',
    backgroundImage: background9,
    backgroundPosition: [-4, -3],
  },
  '🤤': {
    emoji: '🤤',
    backgroundImage: background2,
    backgroundPosition: [0, -1],
  },
  '😪': {
    emoji: '😪',
    backgroundImage: background9,
    backgroundPosition: [-3, -1],
  },
  '😮‍💨': {
    emoji: '😮‍💨',
    backgroundImage: background9,
    backgroundPosition: [-3, -2],
  },
  '😵': {
    emoji: '😵',
    backgroundImage: background9,
    backgroundPosition: [0, -4],
  },
  '😵‍💫': {
    emoji: '😵‍💫',
    backgroundImage: background9,
    backgroundPosition: [-1, -4],
  },
  '🤐': {
    emoji: '🤐',
    backgroundImage: background8,
    backgroundPosition: [0, -4],
  },
  '🥴': {
    emoji: '🥴',
    backgroundImage: background1,
    backgroundPosition: [-4, -1],
  },
  '🤢': {
    emoji: '🤢',
    backgroundImage: background2,
    backgroundPosition: [-3, 0],
  },
  '🤮': {
    emoji: '🤮',
    backgroundImage: background6,
    backgroundPosition: [-2, -1],
  },
  '🤧': {
    emoji: '🤧',
    backgroundImage: background6,
    backgroundPosition: [0, 0],
  },
  '😷': {
    emoji: '😷',
    backgroundImage: background9,
    backgroundPosition: [-4, -4],
  },
  '🤒': {
    emoji: '🤒',
    backgroundImage: background8,
    backgroundPosition: [-2, -4],
  },
  '🤕': {
    emoji: '🤕',
    backgroundImage: background10,
    backgroundPosition: [0, 0],
  },
  '🤑': {
    emoji: '🤑',
    backgroundImage: background8,
    backgroundPosition: [-1, -4],
  },
  '🤠': {
    emoji: '🤠',
    backgroundImage: background2,
    backgroundPosition: [-1, 0],
  },
  '😈': {
    emoji: '😈',
    backgroundImage: background0,
    backgroundPosition: [-4, -4],
  },
  '👿': {
    emoji: '👿',
    backgroundImage: background12,
    backgroundPosition: [-2, -3],
  },
  '👹': {
    emoji: '👹',
    backgroundImage: background12,
    backgroundPosition: [-1, -1],
  },
  '👺': {
    emoji: '👺',
    backgroundImage: background12,
    backgroundPosition: [-2, -1],
  },
  '🤡': {
    emoji: '🤡',
    backgroundImage: background2,
    backgroundPosition: [-2, 0],
  },
  '💩': {
    emoji: '💩',
    backgroundImage: background13,
    backgroundPosition: [-2, -4],
  },
  '👻': {
    emoji: '👻',
    backgroundImage: background12,
    backgroundPosition: [-3, -1],
  },
  '💀': {
    emoji: '💀',
    backgroundImage: background12,
    backgroundPosition: [-3, -3],
  },
  '☠️': {
    emoji: '☠️',
    backgroundImage: background14,
    backgroundPosition: [-4, -3],
  },
  '👽': {
    emoji: '👽',
    backgroundImage: background12,
    backgroundPosition: [0, -3],
  },
  '👾': {
    emoji: '👾',
    backgroundImage: background12,
    backgroundPosition: [-1, -3],
  },
  '🤖': {
    emoji: '🤖',
    backgroundImage: background10,
    backgroundPosition: [-1, 0],
  },
  '🎃': {
    emoji: '🎃',
    backgroundImage: background15,
    backgroundPosition: [-2, -3],
  },
  '😺': {
    emoji: '😺',
    backgroundImage: background5,
    backgroundPosition: [-2, 0],
  },
  '😸': {
    emoji: '😸',
    backgroundImage: background5,
    backgroundPosition: [0, 0],
  },
  '😹': {
    emoji: '😹',
    backgroundImage: background5,
    backgroundPosition: [-1, 0],
  },
  '😻': {
    emoji: '😻',
    backgroundImage: background5,
    backgroundPosition: [-3, 0],
  },
  '😼': {
    emoji: '😼',
    backgroundImage: background5,
    backgroundPosition: [-4, 0],
  },
  '😽': {
    emoji: '😽',
    backgroundImage: background5,
    backgroundPosition: [0, -1],
  },
  '🙀': {
    emoji: '🙀',
    backgroundImage: background5,
    backgroundPosition: [-3, -1],
  },
  '😿': {
    emoji: '😿',
    backgroundImage: background5,
    backgroundPosition: [-2, -1],
  },
  '😾': {
    emoji: '😾',
    backgroundImage: background5,
    backgroundPosition: [-1, -1],
  },
  '🫶': {
    emoji: '🫶',
    backgroundImage: background16,
    backgroundPosition: [-4, -4],
  },
  '🤲': {
    emoji: '🤲',
    backgroundImage: background6,
    backgroundPosition: [-1, -4],
  },
  '👐': {
    emoji: '👐',
    backgroundImage: background17,
    backgroundPosition: [-4, -1],
  },
  '🙌': {
    emoji: '🙌',
    backgroundImage: background18,
    backgroundPosition: [-3, -2],
  },
  '👏': {
    emoji: '👏',
    backgroundImage: background17,
    backgroundPosition: [-3, 0],
  },
  '🤝': {
    emoji: '🤝',
    backgroundImage: background19,
    backgroundPosition: [-3, -1],
  },
  '👍': {
    emoji: '👍',
    backgroundImage: background20,
    backgroundPosition: [-1, -3],
  },
  '👎': {
    emoji: '👎',
    backgroundImage: background20,
    backgroundPosition: [-2, -4],
  },
  '👊': {
    emoji: '👊',
    backgroundImage: background21,
    backgroundPosition: [-3, -4],
  },
  '✊': {
    emoji: '✊',
    backgroundImage: background22,
    backgroundPosition: [-4, -1],
  },
  '🤛': {
    emoji: '🤛',
    backgroundImage: background10,
    backgroundPosition: [-1, -4],
  },
  '🤜': {
    emoji: '🤜',
    backgroundImage: background19,
    backgroundPosition: [-2, 0],
  },
  '🤞': {
    emoji: '🤞',
    backgroundImage: background19,
    backgroundPosition: [-4, -2],
  },
  '✌️': {
    emoji: '✌️',
    backgroundImage: background23,
    backgroundPosition: [-1, 0],
  },
  '🫰': {
    emoji: '🫰',
    backgroundImage: background11,
    backgroundPosition: [-3, -3],
  },
  '🤟': {
    emoji: '🤟',
    backgroundImage: background19,
    backgroundPosition: [0, -4],
  },
  '🤘': {
    emoji: '🤘',
    backgroundImage: background10,
    backgroundPosition: [-3, 0],
  },
  '👌': {
    emoji: '👌',
    backgroundImage: background20,
    backgroundPosition: [0, -2],
  },
  '🤌': {
    emoji: '🤌',
    backgroundImage: background8,
    backgroundPosition: [-1, -1],
  },
  '🤏': {
    emoji: '🤏',
    backgroundImage: background8,
    backgroundPosition: [-4, -2],
  },
  '🫳': {
    emoji: '🫳',
    backgroundImage: background16,
    backgroundPosition: [-1, -1],
  },
  '🫴': {
    emoji: '🫴',
    backgroundImage: background16,
    backgroundPosition: [-2, -2],
  },
  '👈': {
    emoji: '👈',
    backgroundImage: background21,
    backgroundPosition: [-1, -2],
  },
  '👉': {
    emoji: '👉',
    backgroundImage: background21,
    backgroundPosition: [-2, -3],
  },
  '👆': {
    emoji: '👆',
    backgroundImage: background24,
    backgroundPosition: [-4, -4],
  },
  '👇': {
    emoji: '👇',
    backgroundImage: background21,
    backgroundPosition: [0, -1],
  },
  '☝️': {
    emoji: '☝️',
    backgroundImage: background14,
    backgroundPosition: [-3, -3],
  },
  '✋': {
    emoji: '✋',
    backgroundImage: background22,
    backgroundPosition: [0, -3],
  },
  '🤚': {
    emoji: '🤚',
    backgroundImage: background10,
    backgroundPosition: [0, -3],
  },
  '🖐️': {
    emoji: '🖐️',
    backgroundImage: background25,
    backgroundPosition: [-2, 0],
  },
  '🖖': {
    emoji: '🖖',
    backgroundImage: background25,
    backgroundPosition: [-4, -1],
  },
  '👋': {
    emoji: '👋',
    backgroundImage: background20,
    backgroundPosition: [-4, 0],
  },
  '🤙': {
    emoji: '🤙',
    backgroundImage: background10,
    backgroundPosition: [-4, -1],
  },
  '🫲': {
    emoji: '🫲',
    backgroundImage: background16,
    backgroundPosition: [0, 0],
  },
  '🫱': {
    emoji: '🫱',
    backgroundImage: background11,
    backgroundPosition: [-4, -4],
  },
  '💪': {
    emoji: '💪',
    backgroundImage: background13,
    backgroundPosition: [-3, -4],
  },
  '🦾': {
    emoji: '🦾',
    backgroundImage: background26,
    backgroundPosition: [-2, -2],
  },
  '🖕': {
    emoji: '🖕',
    backgroundImage: background25,
    backgroundPosition: [-3, 0],
  },
  '✍️': {
    emoji: '✍️',
    backgroundImage: background23,
    backgroundPosition: [-2, -1],
  },
  '🙏': {
    emoji: '🙏',
    backgroundImage: background27,
    backgroundPosition: [0, -1],
  },
  '🫵': {
    emoji: '🫵',
    backgroundImage: background16,
    backgroundPosition: [-3, -3],
  },
  '🦶': {
    emoji: '🦶',
    backgroundImage: background28,
    backgroundPosition: [0, -2],
  },
  '🦵': {
    emoji: '🦵',
    backgroundImage: background28,
    backgroundPosition: [-4, 0],
  },
  '🦿': {
    emoji: '🦿',
    backgroundImage: background26,
    backgroundPosition: [-3, -2],
  },
  '💄': {
    emoji: '💄',
    backgroundImage: background29,
    backgroundPosition: [-1, -2],
  },
  '💋': {
    emoji: '💋',
    backgroundImage: background30,
    backgroundPosition: [-2, -1],
  },
  '👄': {
    emoji: '👄',
    backgroundImage: background24,
    backgroundPosition: [-2, -4],
  },
  '🫦': {
    emoji: '🫦',
    backgroundImage: background11,
    backgroundPosition: [-1, -3],
  },
  '🦷': {
    emoji: '🦷',
    backgroundImage: background28,
    backgroundPosition: [-1, -3],
  },
  '👅': {
    emoji: '👅',
    backgroundImage: background24,
    backgroundPosition: [-3, -4],
  },
  '👂': {
    emoji: '👂',
    backgroundImage: background24,
    backgroundPosition: [0, -2],
  },
  '🦻': {
    emoji: '🦻',
    backgroundImage: background26,
    backgroundPosition: [-4, 0],
  },
  '👃': {
    emoji: '👃',
    backgroundImage: background24,
    backgroundPosition: [-1, -3],
  },
  '👣': {
    emoji: '👣',
    backgroundImage: background31,
    backgroundPosition: [-3, -1],
  },
  '👁️': {
    emoji: '👁️',
    backgroundImage: background24,
    backgroundPosition: [-3, -1],
  },
  '👀': {
    emoji: '👀',
    backgroundImage: background24,
    backgroundPosition: [-2, -1],
  },
  '🫀': {
    emoji: '🫀',
    backgroundImage: background32,
    backgroundPosition: [-4, 0],
  },
  '🫁': {
    emoji: '🫁',
    backgroundImage: background32,
    backgroundPosition: [0, -1],
  },
  '🧠': {
    emoji: '🧠',
    backgroundImage: background33,
    backgroundPosition: [0, -3],
  },
  '🗣️': {
    emoji: '🗣️',
    backgroundImage: background0,
    backgroundPosition: [-1, -1],
  },
  '👤': {
    emoji: '👤',
    backgroundImage: background31,
    backgroundPosition: [-4, -1],
  },
  '👥': {
    emoji: '👥',
    backgroundImage: background31,
    backgroundPosition: [0, -2],
  },
  '🫂': {
    emoji: '🫂',
    backgroundImage: background32,
    backgroundPosition: [-1, -1],
  },
  '👶': {
    emoji: '👶',
    backgroundImage: background34,
    backgroundPosition: [-1, 0],
  },
  '👧': {
    emoji: '👧',
    backgroundImage: background31,
    backgroundPosition: [-2, -3],
  },
  '🧒': {
    emoji: '🧒',
    backgroundImage: background35,
    backgroundPosition: [-4, 0],
  },
  '👦': {
    emoji: '👦',
    backgroundImage: background31,
    backgroundPosition: [-1, -2],
  },
  '👩': {
    emoji: '👩',
    backgroundImage: background36,
    backgroundPosition: [0, -2],
  },
  '🧑': {
    emoji: '🧑',
    backgroundImage: background7,
    backgroundPosition: [-2, -1],
  },
  '👨': {
    emoji: '👨',
    backgroundImage: background31,
    backgroundPosition: [-3, -4],
  },
  '👩‍🦱': {
    emoji: '👩‍🦱',
    backgroundImage: background37,
    backgroundPosition: [-4, -3],
  },
  '🧑‍🦱': {
    emoji: '🧑‍🦱',
    backgroundImage: background38,
    backgroundPosition: [-4, 0],
  },
  '👨‍🦱': {
    emoji: '👨‍🦱',
    backgroundImage: background39,
    backgroundPosition: [0, -2],
  },
  '👩‍🦰': {
    emoji: '👩‍🦰',
    backgroundImage: background37,
    backgroundPosition: [-3, -3],
  },
  '🧑‍🦰': {
    emoji: '🧑‍🦰',
    backgroundImage: background38,
    backgroundPosition: [-3, 0],
  },
  '👨‍🦰': {
    emoji: '👨‍🦰',
    backgroundImage: background39,
    backgroundPosition: [-4, -1],
  },
  '👱‍♀️': {
    emoji: '👱‍♀️',
    backgroundImage: background40,
    backgroundPosition: [-3, -4],
  },
  '👱': {
    emoji: '👱',
    backgroundImage: background40,
    backgroundPosition: [-2, -4],
  },
  '👱‍♂️': {
    emoji: '👱‍♂️',
    backgroundImage: background40,
    backgroundPosition: [-4, -4],
  },
  '👩‍🦳': {
    emoji: '👩‍🦳',
    backgroundImage: background37,
    backgroundPosition: [-1, -4],
  },
  '🧑‍🦳': {
    emoji: '🧑‍🦳',
    backgroundImage: background38,
    backgroundPosition: [-1, -1],
  },
  '👨‍🦳': {
    emoji: '👨‍🦳',
    backgroundImage: background39,
    backgroundPosition: [-2, -2],
  },
  '👩‍🦲': {
    emoji: '👩‍🦲',
    backgroundImage: background37,
    backgroundPosition: [0, -4],
  },
  '🧑‍🦲': {
    emoji: '🧑‍🦲',
    backgroundImage: background38,
    backgroundPosition: [0, -1],
  },
  '👨‍🦲': {
    emoji: '👨‍🦲',
    backgroundImage: background39,
    backgroundPosition: [-1, -2],
  },
  '🧔‍♀️': {
    emoji: '🧔‍♀️',
    backgroundImage: background35,
    backgroundPosition: [-2, -3],
  },
  '🧔': {
    emoji: '🧔',
    backgroundImage: background35,
    backgroundPosition: [-1, -3],
  },
  '🧔‍♂️': {
    emoji: '🧔‍♂️',
    backgroundImage: background35,
    backgroundPosition: [-3, -3],
  },
  '👵': {
    emoji: '👵',
    backgroundImage: background41,
    backgroundPosition: [0, -4],
  },
  '🧓': {
    emoji: '🧓',
    backgroundImage: background35,
    backgroundPosition: [0, -2],
  },
  '👴': {
    emoji: '👴',
    backgroundImage: background41,
    backgroundPosition: [-4, -2],
  },
  '👲': {
    emoji: '👲',
    backgroundImage: background42,
    backgroundPosition: [0, -3],
  },
  '👳‍♀️': {
    emoji: '👳‍♀️',
    backgroundImage: background42,
    backgroundPosition: [-2, -4],
  },
  '👳': {
    emoji: '👳',
    backgroundImage: background42,
    backgroundPosition: [-1, -4],
  },
  '👳‍♂️': {
    emoji: '👳‍♂️',
    backgroundImage: background42,
    backgroundPosition: [-3, -4],
  },
  '🧕': {
    emoji: '🧕',
    backgroundImage: background43,
    backgroundPosition: [-4, -1],
  },
  '👮‍♀️': {
    emoji: '👮‍♀️',
    backgroundImage: background44,
    backgroundPosition: [-4, -1],
  },
  '👮': {
    emoji: '👮',
    backgroundImage: background44,
    backgroundPosition: [-3, -1],
  },
  '👮‍♂️': {
    emoji: '👮‍♂️',
    backgroundImage: background44,
    backgroundPosition: [0, -2],
  },
  '👷‍♀️': {
    emoji: '👷‍♀️',
    backgroundImage: background34,
    backgroundPosition: [-3, -1],
  },
  '👷': {
    emoji: '👷',
    backgroundImage: background34,
    backgroundPosition: [-2, -1],
  },
  '👷‍♂️': {
    emoji: '👷‍♂️',
    backgroundImage: background34,
    backgroundPosition: [-4, -1],
  },
  '💂‍♀️': {
    emoji: '💂‍♀️',
    backgroundImage: background45,
    backgroundPosition: [-3, -2],
  },
  '💂': {
    emoji: '💂',
    backgroundImage: background45,
    backgroundPosition: [-2, -2],
  },
  '💂‍♂️': {
    emoji: '💂‍♂️',
    backgroundImage: background45,
    backgroundPosition: [-4, -2],
  },
  '🕵️‍♀️': {
    emoji: '🕵️‍♀️',
    backgroundImage: background46,
    backgroundPosition: [0, -1],
  },
  '🕵️': {
    emoji: '🕵️',
    backgroundImage: background46,
    backgroundPosition: [-4, 0],
  },
  '🕵️‍♂️': {
    emoji: '🕵️‍♂️',
    backgroundImage: background46,
    backgroundPosition: [-1, -1],
  },
  '👩‍⚕️': {
    emoji: '👩‍⚕️',
    backgroundImage: background36,
    backgroundPosition: [-1, -2],
  },
  '🧑‍⚕️': {
    emoji: '🧑‍⚕️',
    backgroundImage: background7,
    backgroundPosition: [-3, -1],
  },
  '👨‍⚕️': {
    emoji: '👨‍⚕️',
    backgroundImage: background31,
    backgroundPosition: [-4, -4],
  },
  '👩‍🌾': {
    emoji: '👩‍🌾',
    backgroundImage: background36,
    backgroundPosition: [-3, -3],
  },
  '🧑‍🌾': {
    emoji: '🧑‍🌾',
    backgroundImage: background7,
    backgroundPosition: [-1, -2],
  },
  '👨‍🌾': {
    emoji: '👨‍🌾',
    backgroundImage: background47,
    backgroundPosition: [-4, 0],
  },
  '👩‍🍳': {
    emoji: '👩‍🍳',
    backgroundImage: background36,
    backgroundPosition: [-4, -3],
  },
  '🧑‍🍳': {
    emoji: '🧑‍🍳',
    backgroundImage: background7,
    backgroundPosition: [-2, -2],
  },
  '👨‍🍳': {
    emoji: '👨‍🍳',
    backgroundImage: background47,
    backgroundPosition: [0, -1],
  },
  '👩‍🎓': {
    emoji: '👩‍🎓',
    backgroundImage: background36,
    backgroundPosition: [-1, -4],
  },
  '🧑‍🎓': {
    emoji: '🧑‍🎓',
    backgroundImage: background7,
    backgroundPosition: [0, -3],
  },
  '👨‍🎓': {
    emoji: '👨‍🎓',
    backgroundImage: background47,
    backgroundPosition: [-2, -1],
  },
  '👩‍🎤': {
    emoji: '👩‍🎤',
    backgroundImage: background36,
    backgroundPosition: [-2, -4],
  },
  '🧑‍🎤': {
    emoji: '🧑‍🎤',
    backgroundImage: background7,
    backgroundPosition: [-1, -3],
  },
  '👨‍🎤': {
    emoji: '👨‍🎤',
    backgroundImage: background47,
    backgroundPosition: [-3, -1],
  },
  '👩‍🏫': {
    emoji: '👩‍🏫',
    backgroundImage: background36,
    backgroundPosition: [-4, -4],
  },
  '🧑‍🏫': {
    emoji: '🧑‍🏫',
    backgroundImage: background7,
    backgroundPosition: [-3, -3],
  },
  '👨‍🏫': {
    emoji: '👨‍🏫',
    backgroundImage: background47,
    backgroundPosition: [0, -2],
  },
  '👩‍🏭': {
    emoji: '👩‍🏭',
    backgroundImage: background37,
    backgroundPosition: [0, 0],
  },
  '🧑‍🏭': {
    emoji: '🧑‍🏭',
    backgroundImage: background7,
    backgroundPosition: [-4, -3],
  },
  '👨‍🏭': {
    emoji: '👨‍🏭',
    backgroundImage: background47,
    backgroundPosition: [-1, -2],
  },
  '👩‍💻': {
    emoji: '👩‍💻',
    backgroundImage: background37,
    backgroundPosition: [-1, -2],
  },
  '🧑‍💻': {
    emoji: '🧑‍💻',
    backgroundImage: background7,
    backgroundPosition: [0, -4],
  },
  '👨‍💻': {
    emoji: '👨‍💻',
    backgroundImage: background39,
    backgroundPosition: [-2, 0],
  },
  '👩‍💼': {
    emoji: '👩‍💼',
    backgroundImage: background37,
    backgroundPosition: [-2, -2],
  },
  '🧑‍💼': {
    emoji: '🧑‍💼',
    backgroundImage: background7,
    backgroundPosition: [-1, -4],
  },
  '👨‍💼': {
    emoji: '👨‍💼',
    backgroundImage: background39,
    backgroundPosition: [-3, 0],
  },
  '👩‍🔧': {
    emoji: '👩‍🔧',
    backgroundImage: background37,
    backgroundPosition: [-3, -2],
  },
  '🧑‍🔧': {
    emoji: '🧑‍🔧',
    backgroundImage: background7,
    backgroundPosition: [-2, -4],
  },
  '👨‍🔧': {
    emoji: '👨‍🔧',
    backgroundImage: background39,
    backgroundPosition: [-4, 0],
  },
  '👩‍🔬': {
    emoji: '👩‍🔬',
    backgroundImage: background37,
    backgroundPosition: [-4, -2],
  },
  '🧑‍🔬': {
    emoji: '🧑‍🔬',
    backgroundImage: background7,
    backgroundPosition: [-3, -4],
  },
  '👨‍🔬': {
    emoji: '👨‍🔬',
    backgroundImage: background39,
    backgroundPosition: [0, -1],
  },
  '👩‍🎨': {
    emoji: '👩‍🎨',
    backgroundImage: background36,
    backgroundPosition: [-3, -4],
  },
  '🧑‍🎨': {
    emoji: '🧑‍🎨',
    backgroundImage: background7,
    backgroundPosition: [-2, -3],
  },
  '👨‍🎨': {
    emoji: '👨‍🎨',
    backgroundImage: background47,
    backgroundPosition: [-4, -1],
  },
  '👩‍🚒': {
    emoji: '👩‍🚒',
    backgroundImage: background37,
    backgroundPosition: [-1, -3],
  },
  '🧑‍🚒': {
    emoji: '🧑‍🚒',
    backgroundImage: background38,
    backgroundPosition: [0, 0],
  },
  '👨‍🚒': {
    emoji: '👨‍🚒',
    backgroundImage: background39,
    backgroundPosition: [-2, -1],
  },
  '👩‍✈️': {
    emoji: '👩‍✈️',
    backgroundImage: background36,
    backgroundPosition: [-3, -2],
  },
  '🧑‍✈️': {
    emoji: '🧑‍✈️',
    backgroundImage: background7,
    backgroundPosition: [0, -2],
  },
  '👨‍✈️': {
    emoji: '👨‍✈️',
    backgroundImage: background47,
    backgroundPosition: [-1, 0],
  },
  '👩‍🚀': {
    emoji: '👩‍🚀',
    backgroundImage: background37,
    backgroundPosition: [0, -3],
  },
  '🧑‍🚀': {
    emoji: '🧑‍🚀',
    backgroundImage: background7,
    backgroundPosition: [-4, -4],
  },
  '👨‍🚀': {
    emoji: '👨‍🚀',
    backgroundImage: background39,
    backgroundPosition: [-1, -1],
  },
  '👩‍⚖️': {
    emoji: '👩‍⚖️',
    backgroundImage: background36,
    backgroundPosition: [-2, -2],
  },
  '🧑‍⚖️': {
    emoji: '🧑‍⚖️',
    backgroundImage: background7,
    backgroundPosition: [-4, -1],
  },
  '👨‍⚖️': {
    emoji: '👨‍⚖️',
    backgroundImage: background47,
    backgroundPosition: [0, 0],
  },
  '👰‍♀️': {
    emoji: '👰‍♀️',
    backgroundImage: background40,
    backgroundPosition: [0, -1],
  },
  '👰': {
    emoji: '👰',
    backgroundImage: background40,
    backgroundPosition: [-4, 0],
  },
  '👰‍♂️': {
    emoji: '👰‍♂️',
    backgroundImage: background40,
    backgroundPosition: [-1, -1],
  },
  '🤵‍♀️': {
    emoji: '🤵‍♀️',
    backgroundImage: background48,
    backgroundPosition: [0, -3],
  },
  '🤵': {
    emoji: '🤵',
    backgroundImage: background48,
    backgroundPosition: [-4, -2],
  },
  '🤵‍♂️': {
    emoji: '🤵‍♂️',
    backgroundImage: background48,
    backgroundPosition: [-1, -3],
  },
  '👸': {
    emoji: '👸',
    backgroundImage: background12,
    backgroundPosition: [0, 0],
  },
  '🫅': {
    emoji: '🫅',
    backgroundImage: background32,
    backgroundPosition: [-4, -3],
  },
  '🤴': {
    emoji: '🤴',
    backgroundImage: background48,
    backgroundPosition: [-3, -1],
  },
  '🥷': {
    emoji: '🥷',
    backgroundImage: background1,
    backgroundPosition: [-2, -2],
  },
  '🦸‍♀️': {
    emoji: '🦸‍♀️',
    backgroundImage: background28,
    backgroundPosition: [-3, -3],
  },
  '🦸': {
    emoji: '🦸',
    backgroundImage: background28,
    backgroundPosition: [-2, -3],
  },
  '🦸‍♂️': {
    emoji: '🦸‍♂️',
    backgroundImage: background28,
    backgroundPosition: [-4, -3],
  },
  '🦹‍♀️': {
    emoji: '🦹‍♀️',
    backgroundImage: background49,
    backgroundPosition: [-1, -2],
  },
  '🦹': {
    emoji: '🦹',
    backgroundImage: background49,
    backgroundPosition: [0, -2],
  },
  '🦹‍♂️': {
    emoji: '🦹‍♂️',
    backgroundImage: background49,
    backgroundPosition: [-2, -2],
  },
  '🤶': {
    emoji: '🤶',
    backgroundImage: background50,
    backgroundPosition: [-2, -1],
  },
  '🧑‍🎄': {
    emoji: '🧑‍🎄',
    backgroundImage: background7,
    backgroundPosition: [-4, -2],
  },
  '🎅': {
    emoji: '🎅',
    backgroundImage: background15,
    backgroundPosition: [-4, -3],
  },
  '🧙‍♀️': {
    emoji: '🧙‍♀️',
    backgroundImage: background51,
    backgroundPosition: [0, -4],
  },
  '🧙': {
    emoji: '🧙',
    backgroundImage: background51,
    backgroundPosition: [-4, -3],
  },
  '🧙‍♂️': {
    emoji: '🧙‍♂️',
    backgroundImage: background51,
    backgroundPosition: [-1, -4],
  },
  '🧝‍♀️': {
    emoji: '🧝‍♀️',
    backgroundImage: background52,
    backgroundPosition: [-2, -3],
  },
  '🧝': {
    emoji: '🧝',
    backgroundImage: background52,
    backgroundPosition: [-1, -3],
  },
  '🧝‍♂️': {
    emoji: '🧝‍♂️',
    backgroundImage: background52,
    backgroundPosition: [-3, -3],
  },
  '🧌': {
    emoji: '🧌',
    backgroundImage: background53,
    backgroundPosition: [-1, 0],
  },
  '🧛‍♀️': {
    emoji: '🧛‍♀️',
    backgroundImage: background54,
    backgroundPosition: [-1, -1],
  },
  '🧛': {
    emoji: '🧛',
    backgroundImage: background54,
    backgroundPosition: [0, -1],
  },
  '🧛‍♂️': {
    emoji: '🧛‍♂️',
    backgroundImage: background54,
    backgroundPosition: [-2, -1],
  },
  '🧟‍♀️': {
    emoji: '🧟‍♀️',
    backgroundImage: background33,
    backgroundPosition: [-3, -2],
  },
  '🧟': {
    emoji: '🧟',
    backgroundImage: background33,
    backgroundPosition: [-2, -2],
  },
  '🧟‍♂️': {
    emoji: '🧟‍♂️',
    backgroundImage: background33,
    backgroundPosition: [-4, -2],
  },
  '🧞‍♀️': {
    emoji: '🧞‍♀️',
    backgroundImage: background33,
    backgroundPosition: [0, -2],
  },
  '🧞': {
    emoji: '🧞',
    backgroundImage: background33,
    backgroundPosition: [-4, -1],
  },
  '🧞‍♂️': {
    emoji: '🧞‍♂️',
    backgroundImage: background33,
    backgroundPosition: [-1, -2],
  },
  '🧜‍♀️': {
    emoji: '🧜‍♀️',
    backgroundImage: background54,
    backgroundPosition: [-4, -4],
  },
  '🧜': {
    emoji: '🧜',
    backgroundImage: background54,
    backgroundPosition: [-3, -4],
  },
  '🧜‍♂️': {
    emoji: '🧜‍♂️',
    backgroundImage: background52,
    backgroundPosition: [0, 0],
  },
  '🧚‍♀️': {
    emoji: '🧚‍♀️',
    backgroundImage: background55,
    backgroundPosition: [-3, -2],
  },
  '🧚': {
    emoji: '🧚',
    backgroundImage: background55,
    backgroundPosition: [-2, -2],
  },
  '🧚‍♂️': {
    emoji: '🧚‍♂️',
    backgroundImage: background55,
    backgroundPosition: [-4, -2],
  },
  '👼': {
    emoji: '👼',
    backgroundImage: background12,
    backgroundPosition: [-4, -1],
  },
  '🤰': {
    emoji: '🤰',
    backgroundImage: background6,
    backgroundPosition: [-4, -1],
  },
  '🫄': {
    emoji: '🫄',
    backgroundImage: background32,
    backgroundPosition: [-3, -2],
  },
  '🫃': {
    emoji: '🫃',
    backgroundImage: background32,
    backgroundPosition: [-2, -1],
  },
  '🤱': {
    emoji: '🤱',
    backgroundImage: background6,
    backgroundPosition: [0, -3],
  },
  '👩‍🍼': {
    emoji: '👩‍🍼',
    backgroundImage: background36,
    backgroundPosition: [0, -4],
  },
  '🧑‍🍼': {
    emoji: '🧑‍🍼',
    backgroundImage: background7,
    backgroundPosition: [-3, -2],
  },
  '👨‍🍼': {
    emoji: '👨‍🍼',
    backgroundImage: background47,
    backgroundPosition: [-1, -1],
  },
  '🙇‍♀️': {
    emoji: '🙇‍♀️',
    backgroundImage: background56,
    backgroundPosition: [0, 0],
  },
  '🙇': {
    emoji: '🙇',
    backgroundImage: background57,
    backgroundPosition: [-4, -4],
  },
  '🙇‍♂️': {
    emoji: '🙇‍♂️',
    backgroundImage: background56,
    backgroundPosition: [-1, 0],
  },
  '💁‍♀️': {
    emoji: '💁‍♀️',
    backgroundImage: background12,
    backgroundPosition: [0, -4],
  },
  '💁': {
    emoji: '💁',
    backgroundImage: background12,
    backgroundPosition: [-4, -3],
  },
  '💁‍♂️': {
    emoji: '💁‍♂️',
    backgroundImage: background12,
    backgroundPosition: [-1, -4],
  },
  '🙅‍♀️': {
    emoji: '🙅‍♀️',
    backgroundImage: background5,
    backgroundPosition: [-4, -2],
  },
  '🙅': {
    emoji: '🙅',
    backgroundImage: background5,
    backgroundPosition: [-3, -2],
  },
  '🙅‍♂️': {
    emoji: '🙅‍♂️',
    backgroundImage: background5,
    backgroundPosition: [0, -3],
  },
  '🙆‍♀️': {
    emoji: '🙆‍♀️',
    backgroundImage: background57,
    backgroundPosition: [-2, -1],
  },
  '🙆': {
    emoji: '🙆',
    backgroundImage: background57,
    backgroundPosition: [-1, -1],
  },
  '🙆‍♂️': {
    emoji: '🙆‍♂️',
    backgroundImage: background57,
    backgroundPosition: [-3, -1],
  },
  '🙋‍♀️': {
    emoji: '🙋‍♀️',
    backgroundImage: background56,
    backgroundPosition: [-1, -4],
  },
  '🙋': {
    emoji: '🙋',
    backgroundImage: background56,
    backgroundPosition: [0, -4],
  },
  '🙋‍♂️': {
    emoji: '🙋‍♂️',
    backgroundImage: background56,
    backgroundPosition: [-2, -4],
  },
  '🧏‍♀️': {
    emoji: '🧏‍♀️',
    backgroundImage: background58,
    backgroundPosition: [-4, -2],
  },
  '🧏': {
    emoji: '🧏',
    backgroundImage: background58,
    backgroundPosition: [-3, -2],
  },
  '🧏‍♂️': {
    emoji: '🧏‍♂️',
    backgroundImage: background58,
    backgroundPosition: [0, -3],
  },
  '🤦‍♀️': {
    emoji: '🤦‍♀️',
    backgroundImage: background2,
    backgroundPosition: [-3, -1],
  },
  '🤦': {
    emoji: '🤦',
    backgroundImage: background2,
    backgroundPosition: [-2, -1],
  },
  '🤦‍♂️': {
    emoji: '🤦‍♂️',
    backgroundImage: background2,
    backgroundPosition: [-4, -1],
  },
  '🤷‍♀️': {
    emoji: '🤷‍♀️',
    backgroundImage: background50,
    backgroundPosition: [-4, -2],
  },
  '🤷': {
    emoji: '🤷',
    backgroundImage: background50,
    backgroundPosition: [-3, -2],
  },
  '🤷‍♂️': {
    emoji: '🤷‍♂️',
    backgroundImage: background50,
    backgroundPosition: [0, -3],
  },
  '🙎‍♀️': {
    emoji: '🙎‍♀️',
    backgroundImage: background59,
    backgroundPosition: [-3, -2],
  },
  '🙎': {
    emoji: '🙎',
    backgroundImage: background59,
    backgroundPosition: [-2, -2],
  },
  '🙎‍♂️': {
    emoji: '🙎‍♂️',
    backgroundImage: background59,
    backgroundPosition: [-4, -2],
  },
  '🙍‍♀️': {
    emoji: '🙍‍♀️',
    backgroundImage: background18,
    backgroundPosition: [0, -4],
  },
  '🙍': {
    emoji: '🙍',
    backgroundImage: background18,
    backgroundPosition: [-4, -3],
  },
  '🙍‍♂️': {
    emoji: '🙍‍♂️',
    backgroundImage: background18,
    backgroundPosition: [-1, -4],
  },
  '💇‍♀️': {
    emoji: '💇‍♀️',
    backgroundImage: background60,
    backgroundPosition: [-2, -2],
  },
  '💇': {
    emoji: '💇',
    backgroundImage: background60,
    backgroundPosition: [-1, -2],
  },
  '💇‍♂️': {
    emoji: '💇‍♂️',
    backgroundImage: background60,
    backgroundPosition: [-3, -2],
  },
  '💆‍♀️': {
    emoji: '💆‍♀️',
    backgroundImage: background29,
    backgroundPosition: [-4, -3],
  },
  '💆': {
    emoji: '💆',
    backgroundImage: background29,
    backgroundPosition: [-3, -3],
  },
  '💆‍♂️': {
    emoji: '💆‍♂️',
    backgroundImage: background29,
    backgroundPosition: [0, -4],
  },
  '🧖‍♀️': {
    emoji: '🧖‍♀️',
    backgroundImage: background43,
    backgroundPosition: [-1, -3],
  },
  '🧖': {
    emoji: '🧖',
    backgroundImage: background43,
    backgroundPosition: [0, -3],
  },
  '🧖‍♂️': {
    emoji: '🧖‍♂️',
    backgroundImage: background43,
    backgroundPosition: [-2, -3],
  },
  '💅': {
    emoji: '💅',
    backgroundImage: background29,
    backgroundPosition: [-2, -2],
  },
  '🤳': {
    emoji: '🤳',
    backgroundImage: background48,
    backgroundPosition: [-2, 0],
  },
  '💃': {
    emoji: '💃',
    backgroundImage: background29,
    backgroundPosition: [0, -1],
  },
  '🕺': {
    emoji: '🕺',
    backgroundImage: background46,
    backgroundPosition: [-1, -2],
  },
  '👯‍♀️': {
    emoji: '👯‍♀️',
    backgroundImage: background40,
    backgroundPosition: [-2, 0],
  },
  '👯': {
    emoji: '👯',
    backgroundImage: background40,
    backgroundPosition: [-1, 0],
  },
  '👯‍♂️': {
    emoji: '👯‍♂️',
    backgroundImage: background40,
    backgroundPosition: [-3, 0],
  },
  '🕴️': {
    emoji: '🕴️',
    backgroundImage: background61,
    backgroundPosition: [-3, -2],
  },
  '👩‍🦽': {
    emoji: '👩‍🦽',
    backgroundImage: background37,
    backgroundPosition: [-3, -4],
  },
  '🧑‍🦽': {
    emoji: '🧑‍🦽',
    backgroundImage: background38,
    backgroundPosition: [-3, -1],
  },
  '👨‍🦽': {
    emoji: '👨‍🦽',
    backgroundImage: background39,
    backgroundPosition: [-4, -2],
  },
  '👩‍🦼': {
    emoji: '👩‍🦼',
    backgroundImage: background37,
    backgroundPosition: [-2, -4],
  },
  '🧑‍🦼': {
    emoji: '🧑‍🦼',
    backgroundImage: background38,
    backgroundPosition: [-2, -1],
  },
  '👨‍🦼': {
    emoji: '👨‍🦼',
    backgroundImage: background39,
    backgroundPosition: [-3, -2],
  },
  '🚶‍♀️': {
    emoji: '🚶‍♀️',
    backgroundImage: background62,
    backgroundPosition: [-2, -3],
  },
  '🚶': {
    emoji: '🚶',
    backgroundImage: background62,
    backgroundPosition: [-1, -3],
  },
  '🚶‍♂️': {
    emoji: '🚶‍♂️',
    backgroundImage: background62,
    backgroundPosition: [-3, -3],
  },
  '👩‍🦯': {
    emoji: '👩‍🦯',
    backgroundImage: background37,
    backgroundPosition: [-2, -3],
  },
  '🧑‍🦯': {
    emoji: '🧑‍🦯',
    backgroundImage: background38,
    backgroundPosition: [-2, 0],
  },
  '👨‍🦯': {
    emoji: '👨‍🦯',
    backgroundImage: background39,
    backgroundPosition: [-3, -1],
  },
  '🧎‍♀️': {
    emoji: '🧎‍♀️',
    backgroundImage: background53,
    backgroundPosition: [-1, -4],
  },
  '🧎': {
    emoji: '🧎',
    backgroundImage: background53,
    backgroundPosition: [0, -4],
  },
  '🧎‍♂️': {
    emoji: '🧎‍♂️',
    backgroundImage: background53,
    backgroundPosition: [-2, -4],
  },
  '🏃‍♀️': {
    emoji: '🏃‍♀️',
    backgroundImage: background63,
    backgroundPosition: [-2, -2],
  },
  '🏃': {
    emoji: '🏃',
    backgroundImage: background63,
    backgroundPosition: [-1, -2],
  },
  '🏃‍♂️': {
    emoji: '🏃‍♂️',
    backgroundImage: background63,
    backgroundPosition: [-3, -2],
  },
  '🧍‍♀️': {
    emoji: '🧍‍♀️',
    backgroundImage: background53,
    backgroundPosition: [-3, 0],
  },
  '🧍': {
    emoji: '🧍',
    backgroundImage: background53,
    backgroundPosition: [-2, 0],
  },
  '🧍‍♂️': {
    emoji: '🧍‍♂️',
    backgroundImage: background53,
    backgroundPosition: [-4, 0],
  },
  '👫': {
    emoji: '👫',
    backgroundImage: background64,
    backgroundPosition: [0, -3],
  },
  '👭': {
    emoji: '👭',
    backgroundImage: background44,
    backgroundPosition: [-2, 0],
  },
  '👬': {
    emoji: '👬',
    backgroundImage: background64,
    backgroundPosition: [-1, -4],
  },
  '👩‍❤️‍👨': {
    emoji: '👩‍❤️‍👨',
    backgroundImage: background36,
    backgroundPosition: [-4, -2],
  },
  '👩‍❤️‍👩': {
    emoji: '👩‍❤️‍👩',
    backgroundImage: background36,
    backgroundPosition: [0, -3],
  },
  '💑': {
    emoji: '💑',
    backgroundImage: background30,
    backgroundPosition: [-3, -3],
  },
  '👨‍❤️‍👨': {
    emoji: '👨‍❤️‍👨',
    backgroundImage: background47,
    backgroundPosition: [-2, 0],
  },
  '👩‍❤️‍💋‍👨': {
    emoji: '👩‍❤️‍💋‍👨',
    backgroundImage: background36,
    backgroundPosition: [-1, -3],
  },
  '👩‍❤️‍💋‍👩': {
    emoji: '👩‍❤️‍💋‍👩',
    backgroundImage: background36,
    backgroundPosition: [-2, -3],
  },
  '💏': {
    emoji: '💏',
    backgroundImage: background30,
    backgroundPosition: [-1, -2],
  },
  '👨‍❤️‍💋‍👨': {
    emoji: '👨‍❤️‍💋‍👨',
    backgroundImage: background47,
    backgroundPosition: [-3, 0],
  },
  '👨‍👩‍👦': {
    emoji: '👨‍👩‍👦',
    backgroundImage: background47,
    backgroundPosition: [-2, -4],
  },
  '👨‍👩‍👧': {
    emoji: '👨‍👩‍👧',
    backgroundImage: background47,
    backgroundPosition: [-4, -4],
  },
  '👨‍👩‍👧‍👦': {
    emoji: '👨‍👩‍👧‍👦',
    backgroundImage: background39,
    backgroundPosition: [0, 0],
  },
  '👨‍👩‍👦‍👦': {
    emoji: '👨‍👩‍👦‍👦',
    backgroundImage: background47,
    backgroundPosition: [-3, -4],
  },
  '👨‍👩‍👧‍👧': {
    emoji: '👨‍👩‍👧‍👧',
    backgroundImage: background39,
    backgroundPosition: [-1, 0],
  },
  '👩‍👩‍👦': {
    emoji: '👩‍👩‍👦',
    backgroundImage: background37,
    backgroundPosition: [-1, -1],
  },
  '👩‍👩‍👧': {
    emoji: '👩‍👩‍👧',
    backgroundImage: background37,
    backgroundPosition: [-3, -1],
  },
  '👩‍👩‍👧‍👦': {
    emoji: '👩‍👩‍👧‍👦',
    backgroundImage: background37,
    backgroundPosition: [-4, -1],
  },
  '👩‍👩‍👦‍👦': {
    emoji: '👩‍👩‍👦‍👦',
    backgroundImage: background37,
    backgroundPosition: [-2, -1],
  },
  '👩‍👩‍👧‍👧': {
    emoji: '👩‍👩‍👧‍👧',
    backgroundImage: background37,
    backgroundPosition: [0, -2],
  },
  '👨‍👨‍👦': {
    emoji: '👨‍👨‍👦',
    backgroundImage: background47,
    backgroundPosition: [-2, -3],
  },
  '👨‍👨‍👧': {
    emoji: '👨‍👨‍👧',
    backgroundImage: background47,
    backgroundPosition: [-4, -3],
  },
  '👨‍👨‍👧‍👦': {
    emoji: '👨‍👨‍👧‍👦',
    backgroundImage: background47,
    backgroundPosition: [0, -4],
  },
  '👨‍👨‍👦‍👦': {
    emoji: '👨‍👨‍👦‍👦',
    backgroundImage: background47,
    backgroundPosition: [-3, -3],
  },
  '👨‍👨‍👧‍👧': {
    emoji: '👨‍👨‍👧‍👧',
    backgroundImage: background47,
    backgroundPosition: [-1, -4],
  },
  '👩‍👦': {
    emoji: '👩‍👦',
    backgroundImage: background37,
    backgroundPosition: [-1, 0],
  },
  '👩‍👧': {
    emoji: '👩‍👧',
    backgroundImage: background37,
    backgroundPosition: [-3, 0],
  },
  '👩‍👧‍👦': {
    emoji: '👩‍👧‍👦',
    backgroundImage: background37,
    backgroundPosition: [-4, 0],
  },
  '👩‍👦‍👦': {
    emoji: '👩‍👦‍👦',
    backgroundImage: background37,
    backgroundPosition: [-2, 0],
  },
  '👩‍👧‍👧': {
    emoji: '👩‍👧‍👧',
    backgroundImage: background37,
    backgroundPosition: [0, -1],
  },
  '👨‍👦': {
    emoji: '👨‍👦',
    backgroundImage: background47,
    backgroundPosition: [-2, -2],
  },
  '👨‍👧': {
    emoji: '👨‍👧',
    backgroundImage: background47,
    backgroundPosition: [-4, -2],
  },
  '👨‍👧‍👦': {
    emoji: '👨‍👧‍👦',
    backgroundImage: background47,
    backgroundPosition: [0, -3],
  },
  '👨‍👦‍👦': {
    emoji: '👨‍👦‍👦',
    backgroundImage: background47,
    backgroundPosition: [-3, -2],
  },
  '👨‍👧‍👧': {
    emoji: '👨‍👧‍👧',
    backgroundImage: background47,
    backgroundPosition: [-1, -3],
  },
  '🪢': {
    emoji: '🪢',
    backgroundImage: background65,
    backgroundPosition: [-2, -1],
  },
  '🧶': {
    emoji: '🧶',
    backgroundImage: background66,
    backgroundPosition: [-2, -2],
  },
  '🧵': {
    emoji: '🧵',
    backgroundImage: background66,
    backgroundPosition: [-1, -2],
  },
  '🪡': {
    emoji: '🪡',
    backgroundImage: background65,
    backgroundPosition: [-1, -1],
  },
  '🧥': {
    emoji: '🧥',
    backgroundImage: background33,
    backgroundPosition: [0, -4],
  },
  '🥼': {
    emoji: '🥼',
    backgroundImage: background1,
    backgroundPosition: [-2, -4],
  },
  '🦺': {
    emoji: '🦺',
    backgroundImage: background26,
    backgroundPosition: [-3, 0],
  },
  '👚': {
    emoji: '👚',
    backgroundImage: background17,
    backgroundPosition: [-4, -4],
  },
  '👕': {
    emoji: '👕',
    backgroundImage: background17,
    backgroundPosition: [-4, -3],
  },
  '👖': {
    emoji: '👖',
    backgroundImage: background17,
    backgroundPosition: [0, -4],
  },
  '🩲': {
    emoji: '🩲',
    backgroundImage: background66,
    backgroundPosition: [-4, -4],
  },
  '🩳': {
    emoji: '🩳',
    backgroundImage: background67,
    backgroundPosition: [0, 0],
  },
  '👔': {
    emoji: '👔',
    backgroundImage: background17,
    backgroundPosition: [-3, -3],
  },
  '👗': {
    emoji: '👗',
    backgroundImage: background17,
    backgroundPosition: [-1, -4],
  },
  '👙': {
    emoji: '👙',
    backgroundImage: background17,
    backgroundPosition: [-3, -4],
  },
  '🩱': {
    emoji: '🩱',
    backgroundImage: background66,
    backgroundPosition: [-3, -4],
  },
  '👘': {
    emoji: '👘',
    backgroundImage: background17,
    backgroundPosition: [-2, -4],
  },
  '🥻': {
    emoji: '🥻',
    backgroundImage: background1,
    backgroundPosition: [-1, -4],
  },
  '🩴': {
    emoji: '🩴',
    backgroundImage: background67,
    backgroundPosition: [-1, 0],
  },
  '🥿': {
    emoji: '🥿',
    backgroundImage: background68,
    backgroundPosition: [0, 0],
  },
  '👠': {
    emoji: '👠',
    backgroundImage: background31,
    backgroundPosition: [0, -1],
  },
  '👡': {
    emoji: '👡',
    backgroundImage: background31,
    backgroundPosition: [-1, -1],
  },
  '👢': {
    emoji: '👢',
    backgroundImage: background31,
    backgroundPosition: [-2, -1],
  },
  '👞': {
    emoji: '👞',
    backgroundImage: background31,
    backgroundPosition: [-3, 0],
  },
  '👟': {
    emoji: '👟',
    backgroundImage: background31,
    backgroundPosition: [-4, 0],
  },
  '🥾': {
    emoji: '🥾',
    backgroundImage: background1,
    backgroundPosition: [-4, -4],
  },
  '🧦': {
    emoji: '🧦',
    backgroundImage: background33,
    backgroundPosition: [-1, -4],
  },
  '🧤': {
    emoji: '🧤',
    backgroundImage: background33,
    backgroundPosition: [-4, -3],
  },
  '🧣': {
    emoji: '🧣',
    backgroundImage: background33,
    backgroundPosition: [-3, -3],
  },
  '🎩': {
    emoji: '🎩',
    backgroundImage: background69,
    backgroundPosition: [0, -1],
  },
  '🧢': {
    emoji: '🧢',
    backgroundImage: background33,
    backgroundPosition: [-2, -3],
  },
  '👒': {
    emoji: '👒',
    backgroundImage: background17,
    backgroundPosition: [-1, -3],
  },
  '🎓': {
    emoji: '🎓',
    backgroundImage: background70,
    backgroundPosition: [-3, -2],
  },
  '⛑️': {
    emoji: '⛑️',
    backgroundImage: background71,
    backgroundPosition: [-2, -4],
  },
  '🪖': {
    emoji: '🪖',
    backgroundImage: background67,
    backgroundPosition: [0, -4],
  },
  '👑': {
    emoji: '👑',
    backgroundImage: background17,
    backgroundPosition: [0, -3],
  },
  '💍': {
    emoji: '💍',
    backgroundImage: background30,
    backgroundPosition: [-4, -1],
  },
  '👝': {
    emoji: '👝',
    backgroundImage: background31,
    backgroundPosition: [-2, 0],
  },
  '👛': {
    emoji: '👛',
    backgroundImage: background31,
    backgroundPosition: [0, 0],
  },
  '👜': {
    emoji: '👜',
    backgroundImage: background31,
    backgroundPosition: [-1, 0],
  },
  '💼': {
    emoji: '💼',
    backgroundImage: background72,
    backgroundPosition: [-1, -4],
  },
  '🎒': {
    emoji: '🎒',
    backgroundImage: background70,
    backgroundPosition: [-2, -2],
  },
  '🧳': {
    emoji: '🧳',
    backgroundImage: background66,
    backgroundPosition: [-4, -1],
  },
  '👓': {
    emoji: '👓',
    backgroundImage: background17,
    backgroundPosition: [-2, -3],
  },
  '🕶️': {
    emoji: '🕶️',
    backgroundImage: background46,
    backgroundPosition: [-2, -1],
  },
  '🥽': {
    emoji: '🥽',
    backgroundImage: background1,
    backgroundPosition: [-3, -4],
  },
  '🌂': {
    emoji: '🌂',
    backgroundImage: background73,
    backgroundPosition: [0, -3],
  },
  '🐶': {
    emoji: '🐶',
    backgroundImage: background74,
    backgroundPosition: [-1, -4],
  },
  '🐱': {
    emoji: '🐱',
    backgroundImage: background74,
    backgroundPosition: [-1, -3],
  },
  '🐭': {
    emoji: '🐭',
    backgroundImage: background74,
    backgroundPosition: [-2, -2],
  },
  '🐹': {
    emoji: '🐹',
    backgroundImage: background74,
    backgroundPosition: [-4, -4],
  },
  '🐰': {
    emoji: '🐰',
    backgroundImage: background74,
    backgroundPosition: [0, -3],
  },
  '🦊': {
    emoji: '🦊',
    backgroundImage: background68,
    backgroundPosition: [-1, -2],
  },
  '🐻': {
    emoji: '🐻',
    backgroundImage: background24,
    backgroundPosition: [-1, 0],
  },
  '🐼': {
    emoji: '🐼',
    backgroundImage: background24,
    backgroundPosition: [-3, 0],
  },
  '🐻‍❄️': {
    emoji: '🐻‍❄️',
    backgroundImage: background24,
    backgroundPosition: [-2, 0],
  },
  '🐨': {
    emoji: '🐨',
    backgroundImage: background74,
    backgroundPosition: [-2, -1],
  },
  '🐯': {
    emoji: '🐯',
    backgroundImage: background74,
    backgroundPosition: [-4, -2],
  },
  '🦁': {
    emoji: '🦁',
    backgroundImage: background68,
    backgroundPosition: [-2, 0],
  },
  '🐮': {
    emoji: '🐮',
    backgroundImage: background74,
    backgroundPosition: [-3, -2],
  },
  '🐷': {
    emoji: '🐷',
    backgroundImage: background74,
    backgroundPosition: [-2, -4],
  },
  '🐽': {
    emoji: '🐽',
    backgroundImage: background24,
    backgroundPosition: [-4, 0],
  },
  '🐸': {
    emoji: '🐸',
    backgroundImage: background74,
    backgroundPosition: [-3, -4],
  },
  '🐵': {
    emoji: '🐵',
    backgroundImage: background74,
    backgroundPosition: [0, -4],
  },
  '🙈': {
    emoji: '🙈',
    backgroundImage: background56,
    backgroundPosition: [-2, -3],
  },
  '🙉': {
    emoji: '🙉',
    backgroundImage: background56,
    backgroundPosition: [-3, -3],
  },
  '🙊': {
    emoji: '🙊',
    backgroundImage: background56,
    backgroundPosition: [-4, -3],
  },
  '🐒': {
    emoji: '🐒',
    backgroundImage: background75,
    backgroundPosition: [-4, -1],
  },
  '🐔': {
    emoji: '🐔',
    backgroundImage: background75,
    backgroundPosition: [-1, -2],
  },
  '🐧': {
    emoji: '🐧',
    backgroundImage: background74,
    backgroundPosition: [-1, -1],
  },
  '🐦': {
    emoji: '🐦',
    backgroundImage: background74,
    backgroundPosition: [0, -1],
  },
  '🐤': {
    emoji: '🐤',
    backgroundImage: background74,
    backgroundPosition: [-3, 0],
  },
  '🐣': {
    emoji: '🐣',
    backgroundImage: background74,
    backgroundPosition: [-2, 0],
  },
  '🐥': {
    emoji: '🐥',
    backgroundImage: background74,
    backgroundPosition: [-4, 0],
  },
  '🦆': {
    emoji: '🦆',
    backgroundImage: background68,
    backgroundPosition: [-2, -1],
  },
  '🦅': {
    emoji: '🦅',
    backgroundImage: background68,
    backgroundPosition: [-1, -1],
  },
  '🦉': {
    emoji: '🦉',
    backgroundImage: background68,
    backgroundPosition: [0, -2],
  },
  '🦇': {
    emoji: '🦇',
    backgroundImage: background68,
    backgroundPosition: [-3, -1],
  },
  '🐺': {
    emoji: '🐺',
    backgroundImage: background24,
    backgroundPosition: [0, 0],
  },
  '🐗': {
    emoji: '🐗',
    backgroundImage: background75,
    backgroundPosition: [0, -3],
  },
  '🐴': {
    emoji: '🐴',
    backgroundImage: background74,
    backgroundPosition: [-4, -3],
  },
  '🦄': {
    emoji: '🦄',
    backgroundImage: background68,
    backgroundPosition: [0, -1],
  },
  '🐝': {
    emoji: '🐝',
    backgroundImage: background75,
    backgroundPosition: [-1, -4],
  },
  '🪱': {
    emoji: '🪱',
    backgroundImage: background65,
    backgroundPosition: [-4, -3],
  },
  '🐛': {
    emoji: '🐛',
    backgroundImage: background75,
    backgroundPosition: [-4, -3],
  },
  '🦋': {
    emoji: '🦋',
    backgroundImage: background68,
    backgroundPosition: [-2, -2],
  },
  '🐌': {
    emoji: '🐌',
    backgroundImage: background75,
    backgroundPosition: [-3, 0],
  },
  '🐞': {
    emoji: '🐞',
    backgroundImage: background75,
    backgroundPosition: [-2, -4],
  },
  '🐜': {
    emoji: '🐜',
    backgroundImage: background75,
    backgroundPosition: [0, -4],
  },
  '🪰': {
    emoji: '🪰',
    backgroundImage: background65,
    backgroundPosition: [-3, -3],
  },
  '🪲': {
    emoji: '🪲',
    backgroundImage: background65,
    backgroundPosition: [0, -4],
  },
  '🪳': {
    emoji: '🪳',
    backgroundImage: background65,
    backgroundPosition: [-1, -4],
  },
  '🦟': {
    emoji: '🦟',
    backgroundImage: background76,
    backgroundPosition: [-2, -1],
  },
  '🦗': {
    emoji: '🦗',
    backgroundImage: background68,
    backgroundPosition: [-4, -4],
  },
  '🕷️': {
    emoji: '🕷️',
    backgroundImage: background46,
    backgroundPosition: [-3, -1],
  },
  '🕸️': {
    emoji: '🕸️',
    backgroundImage: background46,
    backgroundPosition: [-4, -1],
  },
  '🦂': {
    emoji: '🦂',
    backgroundImage: background68,
    backgroundPosition: [-3, 0],
  },
  '🐢': {
    emoji: '🐢',
    backgroundImage: background74,
    backgroundPosition: [-1, 0],
  },
  '🐍': {
    emoji: '🐍',
    backgroundImage: background75,
    backgroundPosition: [-4, 0],
  },
  '🦎': {
    emoji: '🦎',
    backgroundImage: background68,
    backgroundPosition: [0, -3],
  },
  '🦖': {
    emoji: '🦖',
    backgroundImage: background68,
    backgroundPosition: [-3, -4],
  },
  '🦕': {
    emoji: '🦕',
    backgroundImage: background68,
    backgroundPosition: [-2, -4],
  },
  '🐙': {
    emoji: '🐙',
    backgroundImage: background75,
    backgroundPosition: [-2, -3],
  },
  '🦑': {
    emoji: '🦑',
    backgroundImage: background68,
    backgroundPosition: [-3, -3],
  },
  '🦐': {
    emoji: '🦐',
    backgroundImage: background68,
    backgroundPosition: [-2, -3],
  },
  '🦞': {
    emoji: '🦞',
    backgroundImage: background76,
    backgroundPosition: [-1, -1],
  },
  '🦀': {
    emoji: '🦀',
    backgroundImage: background68,
    backgroundPosition: [-1, 0],
  },
  '🐡': {
    emoji: '🐡',
    backgroundImage: background74,
    backgroundPosition: [0, 0],
  },
  '🐠': {
    emoji: '🐠',
    backgroundImage: background75,
    backgroundPosition: [-4, -4],
  },
  '🐟': {
    emoji: '🐟',
    backgroundImage: background75,
    backgroundPosition: [-3, -4],
  },
  '🐬': {
    emoji: '🐬',
    backgroundImage: background74,
    backgroundPosition: [-1, -2],
  },
  '🐳': {
    emoji: '🐳',
    backgroundImage: background74,
    backgroundPosition: [-3, -3],
  },
  '🐋': {
    emoji: '🐋',
    backgroundImage: background75,
    backgroundPosition: [-2, 0],
  },
  '🦈': {
    emoji: '🦈',
    backgroundImage: background68,
    backgroundPosition: [-4, -1],
  },
  '🦭': {
    emoji: '🦭',
    backgroundImage: background76,
    backgroundPosition: [-1, -4],
  },
  '🐊': {
    emoji: '🐊',
    backgroundImage: background75,
    backgroundPosition: [-1, 0],
  },
  '🐅': {
    emoji: '🐅',
    backgroundImage: background77,
    backgroundPosition: [0, -4],
  },
  '🐆': {
    emoji: '🐆',
    backgroundImage: background77,
    backgroundPosition: [-1, -4],
  },
  '🦓': {
    emoji: '🦓',
    backgroundImage: background68,
    backgroundPosition: [0, -4],
  },
  '🦍': {
    emoji: '🦍',
    backgroundImage: background68,
    backgroundPosition: [-4, -2],
  },
  '🦧': {
    emoji: '🦧',
    backgroundImage: background76,
    backgroundPosition: [0, -3],
  },
  '🦣': {
    emoji: '🦣',
    backgroundImage: background76,
    backgroundPosition: [-1, -2],
  },
  '🐘': {
    emoji: '🐘',
    backgroundImage: background75,
    backgroundPosition: [-1, -3],
  },
  '🦛': {
    emoji: '🦛',
    backgroundImage: background76,
    backgroundPosition: [-3, 0],
  },
  '🦏': {
    emoji: '🦏',
    backgroundImage: background68,
    backgroundPosition: [-1, -3],
  },
  '🐪': {
    emoji: '🐪',
    backgroundImage: background74,
    backgroundPosition: [-4, -1],
  },
  '🐫': {
    emoji: '🐫',
    backgroundImage: background74,
    backgroundPosition: [0, -2],
  },
  '🦒': {
    emoji: '🦒',
    backgroundImage: background68,
    backgroundPosition: [-4, -3],
  },
  '🦘': {
    emoji: '🦘',
    backgroundImage: background76,
    backgroundPosition: [0, 0],
  },
  '🦬': {
    emoji: '🦬',
    backgroundImage: background76,
    backgroundPosition: [0, -4],
  },
  '🐃': {
    emoji: '🐃',
    backgroundImage: background77,
    backgroundPosition: [-3, -3],
  },
  '🐂': {
    emoji: '🐂',
    backgroundImage: background77,
    backgroundPosition: [-2, -3],
  },
  '🐄': {
    emoji: '🐄',
    backgroundImage: background77,
    backgroundPosition: [-4, -3],
  },
  '🐎': {
    emoji: '🐎',
    backgroundImage: background75,
    backgroundPosition: [0, -1],
  },
  '🐖': {
    emoji: '🐖',
    backgroundImage: background75,
    backgroundPosition: [-4, -2],
  },
  '🐏': {
    emoji: '🐏',
    backgroundImage: background75,
    backgroundPosition: [-1, -1],
  },
  '🐑': {
    emoji: '🐑',
    backgroundImage: background75,
    backgroundPosition: [-3, -1],
  },
  '🦙': {
    emoji: '🦙',
    backgroundImage: background76,
    backgroundPosition: [-1, 0],
  },
  '🐐': {
    emoji: '🐐',
    backgroundImage: background75,
    backgroundPosition: [-2, -1],
  },
  '🦌': {
    emoji: '🦌',
    backgroundImage: background68,
    backgroundPosition: [-3, -2],
  },
  '🐕': {
    emoji: '🐕',
    backgroundImage: background75,
    backgroundPosition: [-2, -2],
  },
  '🐩': {
    emoji: '🐩',
    backgroundImage: background74,
    backgroundPosition: [-3, -1],
  },
  '🦮': {
    emoji: '🦮',
    backgroundImage: background76,
    backgroundPosition: [-2, -4],
  },
  '🐕‍🦺': {
    emoji: '🐕‍🦺',
    backgroundImage: background75,
    backgroundPosition: [-3, -2],
  },
  '🐈': {
    emoji: '🐈',
    backgroundImage: background77,
    backgroundPosition: [-3, -4],
  },
  '🐈‍⬛': {
    emoji: '🐈‍⬛',
    backgroundImage: background77,
    backgroundPosition: [-4, -4],
  },
  '🪶': {
    emoji: '🪶',
    backgroundImage: background65,
    backgroundPosition: [-4, -4],
  },
  '🐓': {
    emoji: '🐓',
    backgroundImage: background75,
    backgroundPosition: [0, -2],
  },
  '🦃': {
    emoji: '🦃',
    backgroundImage: background68,
    backgroundPosition: [-4, 0],
  },
  '🦤': {
    emoji: '🦤',
    backgroundImage: background76,
    backgroundPosition: [-2, -2],
  },
  '🦚': {
    emoji: '🦚',
    backgroundImage: background76,
    backgroundPosition: [-2, 0],
  },
  '🦜': {
    emoji: '🦜',
    backgroundImage: background76,
    backgroundPosition: [-4, 0],
  },
  '🦢': {
    emoji: '🦢',
    backgroundImage: background76,
    backgroundPosition: [0, -2],
  },
  '🦩': {
    emoji: '🦩',
    backgroundImage: background76,
    backgroundPosition: [-2, -3],
  },
  '🕊️': {
    emoji: '🕊️',
    backgroundImage: background78,
    backgroundPosition: [-1, 0],
  },
  '🐇': {
    emoji: '🐇',
    backgroundImage: background77,
    backgroundPosition: [-2, -4],
  },
  '🦝': {
    emoji: '🦝',
    backgroundImage: background76,
    backgroundPosition: [0, -1],
  },
  '🦨': {
    emoji: '🦨',
    backgroundImage: background76,
    backgroundPosition: [-1, -3],
  },
  '🦡': {
    emoji: '🦡',
    backgroundImage: background76,
    backgroundPosition: [-4, -1],
  },
  '🦫': {
    emoji: '🦫',
    backgroundImage: background76,
    backgroundPosition: [-4, -3],
  },
  '🦦': {
    emoji: '🦦',
    backgroundImage: background76,
    backgroundPosition: [-4, -2],
  },
  '🦥': {
    emoji: '🦥',
    backgroundImage: background76,
    backgroundPosition: [-3, -2],
  },
  '🐁': {
    emoji: '🐁',
    backgroundImage: background77,
    backgroundPosition: [-1, -3],
  },
  '🐀': {
    emoji: '🐀',
    backgroundImage: background77,
    backgroundPosition: [0, -3],
  },
  '🐿️': {
    emoji: '🐿️',
    backgroundImage: background24,
    backgroundPosition: [-1, -1],
  },
  '🦔': {
    emoji: '🦔',
    backgroundImage: background68,
    backgroundPosition: [-1, -4],
  },
  '🐾': {
    emoji: '🐾',
    backgroundImage: background24,
    backgroundPosition: [0, -1],
  },
  '🐉': {
    emoji: '🐉',
    backgroundImage: background75,
    backgroundPosition: [0, 0],
  },
  '🐲': {
    emoji: '🐲',
    backgroundImage: background74,
    backgroundPosition: [-2, -3],
  },
  '🌵': {
    emoji: '🌵',
    backgroundImage: background79,
    backgroundPosition: [-4, -2],
  },
  '🎄': {
    emoji: '🎄',
    backgroundImage: background15,
    backgroundPosition: [-3, -3],
  },
  '🌲': {
    emoji: '🌲',
    backgroundImage: background79,
    backgroundPosition: [-1, -2],
  },
  '🌳': {
    emoji: '🌳',
    backgroundImage: background79,
    backgroundPosition: [-2, -2],
  },
  '🌴': {
    emoji: '🌴',
    backgroundImage: background79,
    backgroundPosition: [-3, -2],
  },
  '🪵': {
    emoji: '🪵',
    backgroundImage: background65,
    backgroundPosition: [-3, -4],
  },
  '🌱': {
    emoji: '🌱',
    backgroundImage: background79,
    backgroundPosition: [0, -2],
  },
  '🌿': {
    emoji: '🌿',
    backgroundImage: background79,
    backgroundPosition: [-4, -4],
  },
  '☘️': {
    emoji: '☘️',
    backgroundImage: background14,
    backgroundPosition: [-2, -2],
  },
  '🍀': {
    emoji: '🍀',
    backgroundImage: background80,
    backgroundPosition: [0, 0],
  },
  '🎍': {
    emoji: '🎍',
    backgroundImage: background70,
    backgroundPosition: [-2, -1],
  },
  '🪴': {
    emoji: '🪴',
    backgroundImage: background65,
    backgroundPosition: [-2, -4],
  },
  '🎋': {
    emoji: '🎋',
    backgroundImage: background70,
    backgroundPosition: [0, -1],
  },
  '🍃': {
    emoji: '🍃',
    backgroundImage: background80,
    backgroundPosition: [-3, 0],
  },
  '🍂': {
    emoji: '🍂',
    backgroundImage: background80,
    backgroundPosition: [-2, 0],
  },
  '🍁': {
    emoji: '🍁',
    backgroundImage: background80,
    backgroundPosition: [-1, 0],
  },
  '🪺': {
    emoji: '🪺',
    backgroundImage: background32,
    backgroundPosition: [-3, 0],
  },
  '🪹': {
    emoji: '🪹',
    backgroundImage: background32,
    backgroundPosition: [-2, 0],
  },
  '🍄': {
    emoji: '🍄',
    backgroundImage: background80,
    backgroundPosition: [-4, 0],
  },
  '🐚': {
    emoji: '🐚',
    backgroundImage: background75,
    backgroundPosition: [-3, -3],
  },
  '🪸': {
    emoji: '🪸',
    backgroundImage: background32,
    backgroundPosition: [-1, 0],
  },
  '🪨': {
    emoji: '🪨',
    backgroundImage: background65,
    backgroundPosition: [-3, -2],
  },
  '🌾': {
    emoji: '🌾',
    backgroundImage: background79,
    backgroundPosition: [-3, -4],
  },
  '💐': {
    emoji: '💐',
    backgroundImage: background30,
    backgroundPosition: [-2, -3],
  },
  '🌷': {
    emoji: '🌷',
    backgroundImage: background79,
    backgroundPosition: [-1, -3],
  },
  '🌹': {
    emoji: '🌹',
    backgroundImage: background79,
    backgroundPosition: [-3, -3],
  },
  '🥀': {
    emoji: '🥀',
    backgroundImage: background81,
    backgroundPosition: [-3, -1],
  },
  '🪷': {
    emoji: '🪷',
    backgroundImage: background32,
    backgroundPosition: [0, 0],
  },
  '🌺': {
    emoji: '🌺',
    backgroundImage: background79,
    backgroundPosition: [-4, -3],
  },
  '🌸': {
    emoji: '🌸',
    backgroundImage: background79,
    backgroundPosition: [-2, -3],
  },
  '🌼': {
    emoji: '🌼',
    backgroundImage: background79,
    backgroundPosition: [-1, -4],
  },
  '🌻': {
    emoji: '🌻',
    backgroundImage: background79,
    backgroundPosition: [0, -4],
  },
  '🌞': {
    emoji: '🌞',
    backgroundImage: background82,
    backgroundPosition: [-3, -3],
  },
  '🌝': {
    emoji: '🌝',
    backgroundImage: background82,
    backgroundPosition: [-2, -3],
  },
  '🌛': {
    emoji: '🌛',
    backgroundImage: background82,
    backgroundPosition: [0, -3],
  },
  '🌜': {
    emoji: '🌜',
    backgroundImage: background82,
    backgroundPosition: [-1, -3],
  },
  '🌚': {
    emoji: '🌚',
    backgroundImage: background82,
    backgroundPosition: [-4, -2],
  },
  '🌕': {
    emoji: '🌕',
    backgroundImage: background82,
    backgroundPosition: [-4, -1],
  },
  '🌖': {
    emoji: '🌖',
    backgroundImage: background82,
    backgroundPosition: [0, -2],
  },
  '🌗': {
    emoji: '🌗',
    backgroundImage: background82,
    backgroundPosition: [-1, -2],
  },
  '🌘': {
    emoji: '🌘',
    backgroundImage: background82,
    backgroundPosition: [-2, -2],
  },
  '🌑': {
    emoji: '🌑',
    backgroundImage: background82,
    backgroundPosition: [0, -1],
  },
  '🌒': {
    emoji: '🌒',
    backgroundImage: background82,
    backgroundPosition: [-1, -1],
  },
  '🌓': {
    emoji: '🌓',
    backgroundImage: background82,
    backgroundPosition: [-2, -1],
  },
  '🌔': {
    emoji: '🌔',
    backgroundImage: background82,
    backgroundPosition: [-3, -1],
  },
  '🌙': {
    emoji: '🌙',
    backgroundImage: background82,
    backgroundPosition: [-3, -2],
  },
  '🌎': {
    emoji: '🌎',
    backgroundImage: background82,
    backgroundPosition: [-2, 0],
  },
  '🌍': {
    emoji: '🌍',
    backgroundImage: background82,
    backgroundPosition: [-1, 0],
  },
  '🌏': {
    emoji: '🌏',
    backgroundImage: background82,
    backgroundPosition: [-3, 0],
  },
  '🪐': {
    emoji: '🪐',
    backgroundImage: background67,
    backgroundPosition: [-4, -2],
  },
  '💫': {
    emoji: '💫',
    backgroundImage: background72,
    backgroundPosition: [-4, 0],
  },
  '⭐': {
    emoji: '⭐',
    backgroundImage: background83,
    backgroundPosition: [-2, -3],
  },
  '🌟': {
    emoji: '🌟',
    backgroundImage: background82,
    backgroundPosition: [-4, -3],
  },
  '✨': {
    emoji: '✨',
    backgroundImage: background23,
    backgroundPosition: [-4, -2],
  },
  '⚡': {
    emoji: '⚡',
    backgroundImage: background71,
    backgroundPosition: [-4, -1],
  },
  '☄️': {
    emoji: '☄️',
    backgroundImage: background14,
    backgroundPosition: [-2, -1],
  },
  '💥': {
    emoji: '💥',
    backgroundImage: background13,
    backgroundPosition: [-3, -3],
  },
  '🔥': {
    emoji: '🔥',
    backgroundImage: background84,
    backgroundPosition: [0, 0],
  },
  '🌪️': {
    emoji: '🌪️',
    backgroundImage: background79,
    backgroundPosition: [-3, 0],
  },
  '🌈': {
    emoji: '🌈',
    backgroundImage: background73,
    backgroundPosition: [-1, -4],
  },
  '☀️': {
    emoji: '☀️',
    backgroundImage: background14,
    backgroundPosition: [-3, 0],
  },
  '🌤️': {
    emoji: '🌤️',
    backgroundImage: background82,
    backgroundPosition: [-2, -4],
  },
  '⛅': {
    emoji: '⛅',
    backgroundImage: background71,
    backgroundPosition: [-3, -3],
  },
  '🌥️': {
    emoji: '🌥️',
    backgroundImage: background82,
    backgroundPosition: [-3, -4],
  },
  '☁️': {
    emoji: '☁️',
    backgroundImage: background14,
    backgroundPosition: [-4, 0],
  },
  '🌦️': {
    emoji: '🌦️',
    backgroundImage: background82,
    backgroundPosition: [-4, -4],
  },
  '🌧️': {
    emoji: '🌧️',
    backgroundImage: background79,
    backgroundPosition: [0, 0],
  },
  '⛈️': {
    emoji: '⛈️',
    backgroundImage: background71,
    backgroundPosition: [-4, -3],
  },
  '🌩️': {
    emoji: '🌩️',
    backgroundImage: background79,
    backgroundPosition: [-2, 0],
  },
  '🌨️': {
    emoji: '🌨️',
    backgroundImage: background79,
    backgroundPosition: [-1, 0],
  },
  '❄️': {
    emoji: '❄️',
    backgroundImage: background23,
    backgroundPosition: [-2, -3],
  },
  '☃️': {
    emoji: '☃️',
    backgroundImage: background14,
    backgroundPosition: [-1, -1],
  },
  '⛄': {
    emoji: '⛄',
    backgroundImage: background71,
    backgroundPosition: [-2, -3],
  },
  '🌬️': {
    emoji: '🌬️',
    backgroundImage: background79,
    backgroundPosition: [0, -1],
  },
  '💨': {
    emoji: '💨',
    backgroundImage: background13,
    backgroundPosition: [-1, -4],
  },
  '💧': {
    emoji: '💧',
    backgroundImage: background13,
    backgroundPosition: [0, -4],
  },
  '💦': {
    emoji: '💦',
    backgroundImage: background13,
    backgroundPosition: [-4, -3],
  },
  '🫧': {
    emoji: '🫧',
    backgroundImage: background11,
    backgroundPosition: [-2, -3],
  },
  '☔': {
    emoji: '☔',
    backgroundImage: background14,
    backgroundPosition: [0, -2],
  },
  '☂️': {
    emoji: '☂️',
    backgroundImage: background14,
    backgroundPosition: [0, -1],
  },
  '🌊': {
    emoji: '🌊',
    backgroundImage: background73,
    backgroundPosition: [-3, -4],
  },
  '🌫️': {
    emoji: '🌫️',
    backgroundImage: background79,
    backgroundPosition: [-4, 0],
  },
  '🍏': {
    emoji: '🍏',
    backgroundImage: background80,
    backgroundPosition: [0, -3],
  },
  '🍎': {
    emoji: '🍎',
    backgroundImage: background80,
    backgroundPosition: [-4, -2],
  },
  '🍐': {
    emoji: '🍐',
    backgroundImage: background80,
    backgroundPosition: [-1, -3],
  },
  '🍊': {
    emoji: '🍊',
    backgroundImage: background80,
    backgroundPosition: [0, -2],
  },
  '🍋': {
    emoji: '🍋',
    backgroundImage: background80,
    backgroundPosition: [-1, -2],
  },
  '🍌': {
    emoji: '🍌',
    backgroundImage: background80,
    backgroundPosition: [-2, -2],
  },
  '🍉': {
    emoji: '🍉',
    backgroundImage: background80,
    backgroundPosition: [-4, -1],
  },
  '🍇': {
    emoji: '🍇',
    backgroundImage: background80,
    backgroundPosition: [-2, -1],
  },
  '🍓': {
    emoji: '🍓',
    backgroundImage: background80,
    backgroundPosition: [-4, -3],
  },
  '🫐': {
    emoji: '🫐',
    backgroundImage: background11,
    backgroundPosition: [0, 0],
  },
  '🍈': {
    emoji: '🍈',
    backgroundImage: background80,
    backgroundPosition: [-3, -1],
  },
  '🍒': {
    emoji: '🍒',
    backgroundImage: background80,
    backgroundPosition: [-3, -3],
  },
  '🍑': {
    emoji: '🍑',
    backgroundImage: background80,
    backgroundPosition: [-2, -3],
  },
  '🥭': {
    emoji: '🥭',
    backgroundImage: background1,
    backgroundPosition: [-2, 0],
  },
  '🍍': {
    emoji: '🍍',
    backgroundImage: background80,
    backgroundPosition: [-3, -2],
  },
  '🥥': {
    emoji: '🥥',
    backgroundImage: background85,
    backgroundPosition: [-4, -3],
  },
  '🥝': {
    emoji: '🥝',
    backgroundImage: background85,
    backgroundPosition: [-1, -2],
  },
  '🍅': {
    emoji: '🍅',
    backgroundImage: background80,
    backgroundPosition: [0, -1],
  },
  '🍆': {
    emoji: '🍆',
    backgroundImage: background80,
    backgroundPosition: [-1, -1],
  },
  '🥑': {
    emoji: '🥑',
    backgroundImage: background81,
    backgroundPosition: [-4, -4],
  },
  '🥦': {
    emoji: '🥦',
    backgroundImage: background85,
    backgroundPosition: [0, -4],
  },
  '🥬': {
    emoji: '🥬',
    backgroundImage: background1,
    backgroundPosition: [-1, 0],
  },
  '🥒': {
    emoji: '🥒',
    backgroundImage: background85,
    backgroundPosition: [0, 0],
  },
  '🌶️': {
    emoji: '🌶️',
    backgroundImage: background79,
    backgroundPosition: [0, -3],
  },
  '🫑': {
    emoji: '🫑',
    backgroundImage: background11,
    backgroundPosition: [-1, 0],
  },
  '🌽': {
    emoji: '🌽',
    backgroundImage: background79,
    backgroundPosition: [-2, -4],
  },
  '🥕': {
    emoji: '🥕',
    backgroundImage: background85,
    backgroundPosition: [-3, 0],
  },
  '🫒': {
    emoji: '🫒',
    backgroundImage: background11,
    backgroundPosition: [-2, 0],
  },
  '🧄': {
    emoji: '🧄',
    backgroundImage: background26,
    backgroundPosition: [-3, -3],
  },
  '🧅': {
    emoji: '🧅',
    backgroundImage: background26,
    backgroundPosition: [-4, -3],
  },
  '🥔': {
    emoji: '🥔',
    backgroundImage: background85,
    backgroundPosition: [-2, 0],
  },
  '🍠': {
    emoji: '🍠',
    backgroundImage: background86,
    backgroundPosition: [-2, -1],
  },
  '🥐': {
    emoji: '🥐',
    backgroundImage: background81,
    backgroundPosition: [-3, -4],
  },
  '🥯': {
    emoji: '🥯',
    backgroundImage: background1,
    backgroundPosition: [-4, 0],
  },
  '🍞': {
    emoji: '🍞',
    backgroundImage: background86,
    backgroundPosition: [0, -1],
  },
  '🥖': {
    emoji: '🥖',
    backgroundImage: background85,
    backgroundPosition: [-4, 0],
  },
  '🥨': {
    emoji: '🥨',
    backgroundImage: background85,
    backgroundPosition: [-2, -4],
  },
  '🧀': {
    emoji: '🧀',
    backgroundImage: background26,
    backgroundPosition: [-4, -2],
  },
  '🥚': {
    emoji: '🥚',
    backgroundImage: background85,
    backgroundPosition: [-3, -1],
  },
  '🍳': {
    emoji: '🍳',
    backgroundImage: background15,
    backgroundPosition: [-1, 0],
  },
  '🧈': {
    emoji: '🧈',
    backgroundImage: background26,
    backgroundPosition: [-2, -4],
  },
  '🥞': {
    emoji: '🥞',
    backgroundImage: background85,
    backgroundPosition: [-2, -2],
  },
  '🧇': {
    emoji: '🧇',
    backgroundImage: background26,
    backgroundPosition: [-1, -4],
  },
  '🥓': {
    emoji: '🥓',
    backgroundImage: background85,
    backgroundPosition: [-1, 0],
  },
  '🥩': {
    emoji: '🥩',
    backgroundImage: background85,
    backgroundPosition: [-3, -4],
  },
  '🍗': {
    emoji: '🍗',
    backgroundImage: background80,
    backgroundPosition: [-3, -4],
  },
  '🍖': {
    emoji: '🍖',
    backgroundImage: background80,
    backgroundPosition: [-2, -4],
  },
  '🦴': {
    emoji: '🦴',
    backgroundImage: background28,
    backgroundPosition: [-3, 0],
  },
  '🌭': {
    emoji: '🌭',
    backgroundImage: background79,
    backgroundPosition: [-1, -1],
  },
  '🍔': {
    emoji: '🍔',
    backgroundImage: background80,
    backgroundPosition: [0, -4],
  },
  '🍟': {
    emoji: '🍟',
    backgroundImage: background86,
    backgroundPosition: [-1, -1],
  },
  '🍕': {
    emoji: '🍕',
    backgroundImage: background80,
    backgroundPosition: [-1, -4],
  },
  '🫓': {
    emoji: '🫓',
    backgroundImage: background11,
    backgroundPosition: [-3, 0],
  },
  '🥪': {
    emoji: '🥪',
    backgroundImage: background85,
    backgroundPosition: [-4, -4],
  },
  '🥙': {
    emoji: '🥙',
    backgroundImage: background85,
    backgroundPosition: [-2, -1],
  },
  '🧆': {
    emoji: '🧆',
    backgroundImage: background26,
    backgroundPosition: [0, -4],
  },
  '🌮': {
    emoji: '🌮',
    backgroundImage: background79,
    backgroundPosition: [-2, -1],
  },
  '🌯': {
    emoji: '🌯',
    backgroundImage: background79,
    backgroundPosition: [-3, -1],
  },
  '🫔': {
    emoji: '🫔',
    backgroundImage: background11,
    backgroundPosition: [-4, 0],
  },
  '🥗': {
    emoji: '🥗',
    backgroundImage: background85,
    backgroundPosition: [0, -1],
  },
  '🥘': {
    emoji: '🥘',
    backgroundImage: background85,
    backgroundPosition: [-1, -1],
  },
  '🫕': {
    emoji: '🫕',
    backgroundImage: background11,
    backgroundPosition: [0, -1],
  },
  '🥫': {
    emoji: '🥫',
    backgroundImage: background1,
    backgroundPosition: [0, 0],
  },
  '🫙': {
    emoji: '🫙',
    backgroundImage: background11,
    backgroundPosition: [-4, -1],
  },
  '🍝': {
    emoji: '🍝',
    backgroundImage: background86,
    backgroundPosition: [-4, 0],
  },
  '🍜': {
    emoji: '🍜',
    backgroundImage: background86,
    backgroundPosition: [-3, 0],
  },
  '🍲': {
    emoji: '🍲',
    backgroundImage: background15,
    backgroundPosition: [0, 0],
  },
  '🍛': {
    emoji: '🍛',
    backgroundImage: background86,
    backgroundPosition: [-2, 0],
  },
  '🍣': {
    emoji: '🍣',
    backgroundImage: background86,
    backgroundPosition: [0, -2],
  },
  '🍱': {
    emoji: '🍱',
    backgroundImage: background86,
    backgroundPosition: [-4, -4],
  },
  '🥟': {
    emoji: '🥟',
    backgroundImage: background85,
    backgroundPosition: [-3, -2],
  },
  '🦪': {
    emoji: '🦪',
    backgroundImage: background76,
    backgroundPosition: [-3, -3],
  },
  '🍤': {
    emoji: '🍤',
    backgroundImage: background86,
    backgroundPosition: [-1, -2],
  },
  '🍙': {
    emoji: '🍙',
    backgroundImage: background86,
    backgroundPosition: [0, 0],
  },
  '🍚': {
    emoji: '🍚',
    backgroundImage: background86,
    backgroundPosition: [-1, 0],
  },
  '🍘': {
    emoji: '🍘',
    backgroundImage: background80,
    backgroundPosition: [-4, -4],
  },
  '🍥': {
    emoji: '🍥',
    backgroundImage: background86,
    backgroundPosition: [-2, -2],
  },
  '🥠': {
    emoji: '🥠',
    backgroundImage: background85,
    backgroundPosition: [-4, -2],
  },
  '🥮': {
    emoji: '🥮',
    backgroundImage: background1,
    backgroundPosition: [-3, 0],
  },
  '🍢': {
    emoji: '🍢',
    backgroundImage: background86,
    backgroundPosition: [-4, -1],
  },
  '🍡': {
    emoji: '🍡',
    backgroundImage: background86,
    backgroundPosition: [-3, -1],
  },
  '🍧': {
    emoji: '🍧',
    backgroundImage: background86,
    backgroundPosition: [-4, -2],
  },
  '🍨': {
    emoji: '🍨',
    backgroundImage: background86,
    backgroundPosition: [0, -3],
  },
  '🍦': {
    emoji: '🍦',
    backgroundImage: background86,
    backgroundPosition: [-3, -2],
  },
  '🥧': {
    emoji: '🥧',
    backgroundImage: background85,
    backgroundPosition: [-1, -4],
  },
  '🧁': {
    emoji: '🧁',
    backgroundImage: background26,
    backgroundPosition: [0, -3],
  },
  '🍰': {
    emoji: '🍰',
    backgroundImage: background86,
    backgroundPosition: [-3, -4],
  },
  '🎂': {
    emoji: '🎂',
    backgroundImage: background15,
    backgroundPosition: [-1, -3],
  },
  '🍮': {
    emoji: '🍮',
    backgroundImage: background86,
    backgroundPosition: [-1, -4],
  },
  '🍭': {
    emoji: '🍭',
    backgroundImage: background86,
    backgroundPosition: [0, -4],
  },
  '🍬': {
    emoji: '🍬',
    backgroundImage: background86,
    backgroundPosition: [-4, -3],
  },
  '🍫': {
    emoji: '🍫',
    backgroundImage: background86,
    backgroundPosition: [-3, -3],
  },
  '🍿': {
    emoji: '🍿',
    backgroundImage: background15,
    backgroundPosition: [-3, -2],
  },
  '🍩': {
    emoji: '🍩',
    backgroundImage: background86,
    backgroundPosition: [-1, -3],
  },
  '🍪': {
    emoji: '🍪',
    backgroundImage: background86,
    backgroundPosition: [-2, -3],
  },
  '🌰': {
    emoji: '🌰',
    backgroundImage: background79,
    backgroundPosition: [-4, -1],
  },
  '🥜': {
    emoji: '🥜',
    backgroundImage: background85,
    backgroundPosition: [0, -2],
  },
  '🫘': {
    emoji: '🫘',
    backgroundImage: background11,
    backgroundPosition: [-3, -1],
  },
  '🍯': {
    emoji: '🍯',
    backgroundImage: background86,
    backgroundPosition: [-2, -4],
  },
  '🥛': {
    emoji: '🥛',
    backgroundImage: background85,
    backgroundPosition: [-4, -1],
  },
  '🫗': {
    emoji: '🫗',
    backgroundImage: background11,
    backgroundPosition: [-2, -1],
  },
  '🍼': {
    emoji: '🍼',
    backgroundImage: background15,
    backgroundPosition: [0, -2],
  },
  '🫖': {
    emoji: '🫖',
    backgroundImage: background11,
    backgroundPosition: [-1, -1],
  },
  '☕': {
    emoji: '☕',
    backgroundImage: background14,
    backgroundPosition: [-1, -2],
  },
  '🍵': {
    emoji: '🍵',
    backgroundImage: background15,
    backgroundPosition: [-3, 0],
  },
  '🧃': {
    emoji: '🧃',
    backgroundImage: background26,
    backgroundPosition: [-2, -3],
  },
  '🥤': {
    emoji: '🥤',
    backgroundImage: background85,
    backgroundPosition: [-3, -3],
  },
  '🧋': {
    emoji: '🧋',
    backgroundImage: background53,
    backgroundPosition: [0, 0],
  },
  '🍶': {
    emoji: '🍶',
    backgroundImage: background15,
    backgroundPosition: [-4, 0],
  },
  '🍺': {
    emoji: '🍺',
    backgroundImage: background15,
    backgroundPosition: [-3, -1],
  },
  '🍻': {
    emoji: '🍻',
    backgroundImage: background15,
    backgroundPosition: [-4, -1],
  },
  '🥂': {
    emoji: '🥂',
    backgroundImage: background81,
    backgroundPosition: [0, -2],
  },
  '🍷': {
    emoji: '🍷',
    backgroundImage: background15,
    backgroundPosition: [0, -1],
  },
  '🥃': {
    emoji: '🥃',
    backgroundImage: background81,
    backgroundPosition: [-1, -2],
  },
  '🍸': {
    emoji: '🍸',
    backgroundImage: background15,
    backgroundPosition: [-1, -1],
  },
  '🍹': {
    emoji: '🍹',
    backgroundImage: background15,
    backgroundPosition: [-2, -1],
  },
  '🧉': {
    emoji: '🧉',
    backgroundImage: background26,
    backgroundPosition: [-3, -4],
  },
  '🍾': {
    emoji: '🍾',
    backgroundImage: background15,
    backgroundPosition: [-2, -2],
  },
  '🧊': {
    emoji: '🧊',
    backgroundImage: background26,
    backgroundPosition: [-4, -4],
  },
  '🥄': {
    emoji: '🥄',
    backgroundImage: background81,
    backgroundPosition: [-2, -2],
  },
  '🍴': {
    emoji: '🍴',
    backgroundImage: background15,
    backgroundPosition: [-2, 0],
  },
  '🍽️': {
    emoji: '🍽️',
    backgroundImage: background15,
    backgroundPosition: [-1, -2],
  },
  '🥣': {
    emoji: '🥣',
    backgroundImage: background85,
    backgroundPosition: [-2, -3],
  },
  '🥡': {
    emoji: '🥡',
    backgroundImage: background85,
    backgroundPosition: [0, -3],
  },
  '🥢': {
    emoji: '🥢',
    backgroundImage: background85,
    backgroundPosition: [-1, -3],
  },
  '🧂': {
    emoji: '🧂',
    backgroundImage: background26,
    backgroundPosition: [-1, -3],
  },
  '⚽': {
    emoji: '⚽',
    backgroundImage: background71,
    backgroundPosition: [0, -3],
  },
  '🏀': {
    emoji: '🏀',
    backgroundImage: background63,
    backgroundPosition: [-3, 0],
  },
  '🏈': {
    emoji: '🏈',
    backgroundImage: background87,
    backgroundPosition: [0, -1],
  },
  '⚾': {
    emoji: '⚾',
    backgroundImage: background71,
    backgroundPosition: [-1, -3],
  },
  '🥎': {
    emoji: '🥎',
    backgroundImage: background81,
    backgroundPosition: [-1, -4],
  },
  '🎾': {
    emoji: '🎾',
    backgroundImage: background63,
    backgroundPosition: [-1, 0],
  },
  '🏐': {
    emoji: '🏐',
    backgroundImage: background88,
    backgroundPosition: [-4, -2],
  },
  '🏉': {
    emoji: '🏉',
    backgroundImage: background87,
    backgroundPosition: [-1, -1],
  },
  '🥏': {
    emoji: '🥏',
    backgroundImage: background81,
    backgroundPosition: [-2, -4],
  },
  '🎱': {
    emoji: '🎱',
    backgroundImage: background69,
    backgroundPosition: [-3, -2],
  },
  '🪀': {
    emoji: '🪀',
    backgroundImage: background67,
    backgroundPosition: [-2, -1],
  },
  '🏓': {
    emoji: '🏓',
    backgroundImage: background88,
    backgroundPosition: [-2, -3],
  },
  '🏸': {
    emoji: '🏸',
    backgroundImage: background77,
    backgroundPosition: [-2, -1],
  },
  '🏒': {
    emoji: '🏒',
    backgroundImage: background88,
    backgroundPosition: [-1, -3],
  },
  '🏑': {
    emoji: '🏑',
    backgroundImage: background88,
    backgroundPosition: [0, -3],
  },
  '🥍': {
    emoji: '🥍',
    backgroundImage: background81,
    backgroundPosition: [0, -4],
  },
  '🏏': {
    emoji: '🏏',
    backgroundImage: background88,
    backgroundPosition: [-3, -2],
  },
  '🪃': {
    emoji: '🪃',
    backgroundImage: background67,
    backgroundPosition: [0, -2],
  },
  '🥅': {
    emoji: '🥅',
    backgroundImage: background81,
    backgroundPosition: [-3, -2],
  },
  '⛳': {
    emoji: '⛳',
    backgroundImage: background89,
    backgroundPosition: [0, -1],
  },
  '🪁': {
    emoji: '🪁',
    backgroundImage: background67,
    backgroundPosition: [-3, -1],
  },
  '🛝': {
    emoji: '🛝',
    backgroundImage: background90,
    backgroundPosition: [0, -4],
  },
  '🏹': {
    emoji: '🏹',
    backgroundImage: background77,
    backgroundPosition: [-3, -1],
  },
  '🎣': {
    emoji: '🎣',
    backgroundImage: background70,
    backgroundPosition: [-4, -4],
  },
  '🤿': {
    emoji: '🤿',
    backgroundImage: background81,
    backgroundPosition: [-2, -1],
  },
  '🥊': {
    emoji: '🥊',
    backgroundImage: background81,
    backgroundPosition: [-2, -3],
  },
  '🥋': {
    emoji: '🥋',
    backgroundImage: background81,
    backgroundPosition: [-3, -3],
  },
  '🎽': {
    emoji: '🎽',
    backgroundImage: background63,
    backgroundPosition: [0, 0],
  },
  '🛹': {
    emoji: '🛹',
    backgroundImage: background91,
    backgroundPosition: [-4, -2],
  },
  '🛼': {
    emoji: '🛼',
    backgroundImage: background91,
    backgroundPosition: [-2, -3],
  },
  '🛷': {
    emoji: '🛷',
    backgroundImage: background91,
    backgroundPosition: [-2, -2],
  },
  '⛸️': {
    emoji: '⛸️',
    backgroundImage: background89,
    backgroundPosition: [-4, -1],
  },
  '🥌': {
    emoji: '🥌',
    backgroundImage: background81,
    backgroundPosition: [-4, -3],
  },
  '🎿': {
    emoji: '🎿',
    backgroundImage: background63,
    backgroundPosition: [-2, 0],
  },
  '⛷️': {
    emoji: '⛷️',
    backgroundImage: background89,
    backgroundPosition: [-3, -1],
  },
  '🏂': {
    emoji: '🏂',
    backgroundImage: background63,
    backgroundPosition: [0, -1],
  },
  '🪂': {
    emoji: '🪂',
    backgroundImage: background67,
    backgroundPosition: [-4, -1],
  },
  '🏋️‍♀️': {
    emoji: '🏋️‍♀️',
    backgroundImage: background92,
    backgroundPosition: [-1, -3],
  },
  '🏋️': {
    emoji: '🏋️',
    backgroundImage: background92,
    backgroundPosition: [0, -3],
  },
  '🏋️‍♂️': {
    emoji: '🏋️‍♂️',
    backgroundImage: background92,
    backgroundPosition: [-2, -3],
  },
  '🤼‍♀️': {
    emoji: '🤼‍♀️',
    backgroundImage: background93,
    backgroundPosition: [-4, -3],
  },
  '🤼‍♂️': {
    emoji: '🤼‍♂️',
    backgroundImage: background93,
    backgroundPosition: [0, -4],
  },
  '🤸‍♀️': {
    emoji: '🤸‍♀️',
    backgroundImage: background94,
    backgroundPosition: [-2, -1],
  },
  '🤸': {
    emoji: '🤸',
    backgroundImage: background94,
    backgroundPosition: [-1, -1],
  },
  '🤸‍♂️': {
    emoji: '🤸‍♂️',
    backgroundImage: background94,
    backgroundPosition: [-3, -1],
  },
  '⛹️‍♀️': {
    emoji: '⛹️‍♀️',
    backgroundImage: background22,
    backgroundPosition: [-1, 0],
  },
  '⛹️': {
    emoji: '⛹️',
    backgroundImage: background22,
    backgroundPosition: [0, 0],
  },
  '⛹️‍♂️': {
    emoji: '⛹️‍♂️',
    backgroundImage: background22,
    backgroundPosition: [-2, 0],
  },
  '🤺': {
    emoji: '🤺',
    backgroundImage: background93,
    backgroundPosition: [-2, -3],
  },
  '🤾‍♀️': {
    emoji: '🤾‍♀️',
    backgroundImage: background95,
    backgroundPosition: [0, -3],
  },
  '🤾': {
    emoji: '🤾',
    backgroundImage: background95,
    backgroundPosition: [-4, -2],
  },
  '🤾‍♂️': {
    emoji: '🤾‍♂️',
    backgroundImage: background95,
    backgroundPosition: [-1, -3],
  },
  '🏌️‍♀️': {
    emoji: '🏌️‍♀️',
    backgroundImage: background88,
    backgroundPosition: [-4, -1],
  },
  '🏌️': {
    emoji: '🏌️',
    backgroundImage: background88,
    backgroundPosition: [-3, -1],
  },
  '🏌️‍♂️': {
    emoji: '🏌️‍♂️',
    backgroundImage: background88,
    backgroundPosition: [0, -2],
  },
  '🏇': {
    emoji: '🏇',
    backgroundImage: background96,
    backgroundPosition: [-4, -4],
  },
  '🧘‍♀️': {
    emoji: '🧘‍♀️',
    backgroundImage: background51,
    backgroundPosition: [-2, 0],
  },
  '🧘': {
    emoji: '🧘',
    backgroundImage: background51,
    backgroundPosition: [-1, 0],
  },
  '🧘‍♂️': {
    emoji: '🧘‍♂️',
    backgroundImage: background51,
    backgroundPosition: [-3, 0],
  },
  '🏄‍♀️': {
    emoji: '🏄‍♀️',
    backgroundImage: background96,
    backgroundPosition: [0, -1],
  },
  '🏄': {
    emoji: '🏄',
    backgroundImage: background96,
    backgroundPosition: [-4, 0],
  },
  '🏄‍♂️': {
    emoji: '🏄‍♂️',
    backgroundImage: background96,
    backgroundPosition: [-1, -1],
  },
  '🏊‍♀️': {
    emoji: '🏊‍♀️',
    backgroundImage: background87,
    backgroundPosition: [-3, -1],
  },
  '🏊': {
    emoji: '🏊',
    backgroundImage: background87,
    backgroundPosition: [-2, -1],
  },
  '🏊‍♂️': {
    emoji: '🏊‍♂️',
    backgroundImage: background87,
    backgroundPosition: [-4, -1],
  },
  '🤽‍♀️': {
    emoji: '🤽‍♀️',
    backgroundImage: background93,
    backgroundPosition: [-2, -4],
  },
  '🤽': {
    emoji: '🤽',
    backgroundImage: background93,
    backgroundPosition: [-1, -4],
  },
  '🤽‍♂️': {
    emoji: '🤽‍♂️',
    backgroundImage: background93,
    backgroundPosition: [-3, -4],
  },
  '🚣‍♀️': {
    emoji: '🚣‍♀️',
    backgroundImage: background97,
    backgroundPosition: [-2, -4],
  },
  '🚣': {
    emoji: '🚣',
    backgroundImage: background97,
    backgroundPosition: [-1, -4],
  },
  '🚣‍♂️': {
    emoji: '🚣‍♂️',
    backgroundImage: background97,
    backgroundPosition: [-3, -4],
  },
  '🧗‍♀️': {
    emoji: '🧗‍♀️',
    backgroundImage: background98,
    backgroundPosition: [-4, -1],
  },
  '🧗': {
    emoji: '🧗',
    backgroundImage: background98,
    backgroundPosition: [-3, -1],
  },
  '🧗‍♂️': {
    emoji: '🧗‍♂️',
    backgroundImage: background98,
    backgroundPosition: [0, -2],
  },
  '🚵‍♀️': {
    emoji: '🚵‍♀️',
    backgroundImage: background99,
    backgroundPosition: [-4, -4],
  },
  '🚵': {
    emoji: '🚵',
    backgroundImage: background99,
    backgroundPosition: [-3, -4],
  },
  '🚵‍♂️': {
    emoji: '🚵‍♂️',
    backgroundImage: background62,
    backgroundPosition: [0, 0],
  },
  '🚴‍♀️': {
    emoji: '🚴‍♀️',
    backgroundImage: background99,
    backgroundPosition: [-1, -1],
  },
  '🚴': {
    emoji: '🚴',
    backgroundImage: background99,
    backgroundPosition: [0, -1],
  },
  '🚴‍♂️': {
    emoji: '🚴‍♂️',
    backgroundImage: background99,
    backgroundPosition: [-2, -1],
  },
  '🏆': {
    emoji: '🏆',
    backgroundImage: background96,
    backgroundPosition: [-3, -4],
  },
  '🥇': {
    emoji: '🥇',
    backgroundImage: background81,
    backgroundPosition: [-4, -2],
  },
  '🥈': {
    emoji: '🥈',
    backgroundImage: background81,
    backgroundPosition: [0, -3],
  },
  '🥉': {
    emoji: '🥉',
    backgroundImage: background81,
    backgroundPosition: [-1, -3],
  },
  '🏅': {
    emoji: '🏅',
    backgroundImage: background96,
    backgroundPosition: [-2, -4],
  },
  '🎖️': {
    emoji: '🎖️',
    backgroundImage: background70,
    backgroundPosition: [-4, -2],
  },
  '🏵️': {
    emoji: '🏵️',
    backgroundImage: background77,
    backgroundPosition: [0, -1],
  },
  '🎗️': {
    emoji: '🎗️',
    backgroundImage: background70,
    backgroundPosition: [0, -3],
  },
  '🎫': {
    emoji: '🎫',
    backgroundImage: background69,
    backgroundPosition: [-2, -1],
  },
  '🎟️': {
    emoji: '🎟️',
    backgroundImage: background70,
    backgroundPosition: [0, -4],
  },
  '🎪': {
    emoji: '🎪',
    backgroundImage: background69,
    backgroundPosition: [-1, -1],
  },
  '🤹‍♀️': {
    emoji: '🤹‍♀️',
    backgroundImage: background93,
    backgroundPosition: [0, 0],
  },
  '🤹': {
    emoji: '🤹',
    backgroundImage: background94,
    backgroundPosition: [-4, -4],
  },
  '🤹‍♂️': {
    emoji: '🤹‍♂️',
    backgroundImage: background93,
    backgroundPosition: [-1, 0],
  },
  '🎭': {
    emoji: '🎭',
    backgroundImage: background69,
    backgroundPosition: [-4, -1],
  },
  '🩰': {
    emoji: '🩰',
    backgroundImage: background66,
    backgroundPosition: [-2, -4],
  },
  '🎨': {
    emoji: '🎨',
    backgroundImage: background69,
    backgroundPosition: [-4, 0],
  },
  '🎬': {
    emoji: '🎬',
    backgroundImage: background69,
    backgroundPosition: [-3, -1],
  },
  '🎤': {
    emoji: '🎤',
    backgroundImage: background69,
    backgroundPosition: [0, 0],
  },
  '🎧': {
    emoji: '🎧',
    backgroundImage: background69,
    backgroundPosition: [-3, 0],
  },
  '🎼': {
    emoji: '🎼',
    backgroundImage: background69,
    backgroundPosition: [-4, -4],
  },
  '🎹': {
    emoji: '🎹',
    backgroundImage: background69,
    backgroundPosition: [-1, -4],
  },
  '🥁': {
    emoji: '🥁',
    backgroundImage: background81,
    backgroundPosition: [-4, -1],
  },
  '🪘': {
    emoji: '🪘',
    backgroundImage: background67,
    backgroundPosition: [-2, -4],
  },
  '🎷': {
    emoji: '🎷',
    backgroundImage: background69,
    backgroundPosition: [-4, -3],
  },
  '🎺': {
    emoji: '🎺',
    backgroundImage: background69,
    backgroundPosition: [-2, -4],
  },
  '🪗': {
    emoji: '🪗',
    backgroundImage: background67,
    backgroundPosition: [-1, -4],
  },
  '🎸': {
    emoji: '🎸',
    backgroundImage: background69,
    backgroundPosition: [0, -4],
  },
  '🪕': {
    emoji: '🪕',
    backgroundImage: background67,
    backgroundPosition: [-4, -3],
  },
  '🎻': {
    emoji: '🎻',
    backgroundImage: background69,
    backgroundPosition: [-3, -4],
  },
  '🎲': {
    emoji: '🎲',
    backgroundImage: background69,
    backgroundPosition: [-4, -2],
  },
  '♟️': {
    emoji: '♟️',
    backgroundImage: background3,
    backgroundPosition: [-1, -3],
  },
  '🎯': {
    emoji: '🎯',
    backgroundImage: background69,
    backgroundPosition: [-1, -2],
  },
  '🎳': {
    emoji: '🎳',
    backgroundImage: background69,
    backgroundPosition: [0, -3],
  },
  '🎮': {
    emoji: '🎮',
    backgroundImage: background69,
    backgroundPosition: [0, -2],
  },
  '🎰': {
    emoji: '🎰',
    backgroundImage: background69,
    backgroundPosition: [-2, -2],
  },
  '🧩': {
    emoji: '🧩',
    backgroundImage: background33,
    backgroundPosition: [-4, -4],
  },
  '🚗': {
    emoji: '🚗',
    backgroundImage: background97,
    backgroundPosition: [-4, -1],
  },
  '🚕': {
    emoji: '🚕',
    backgroundImage: background97,
    backgroundPosition: [-2, -1],
  },
  '🚙': {
    emoji: '🚙',
    backgroundImage: background97,
    backgroundPosition: [-1, -2],
  },
  '🚌': {
    emoji: '🚌',
    backgroundImage: background27,
    backgroundPosition: [-3, -4],
  },
  '🚎': {
    emoji: '🚎',
    backgroundImage: background97,
    backgroundPosition: [0, 0],
  },
  '🏎️': {
    emoji: '🏎️',
    backgroundImage: background88,
    backgroundPosition: [-2, -2],
  },
  '🚓': {
    emoji: '🚓',
    backgroundImage: background97,
    backgroundPosition: [0, -1],
  },
  '🚑': {
    emoji: '🚑',
    backgroundImage: background97,
    backgroundPosition: [-3, 0],
  },
  '🚒': {
    emoji: '🚒',
    backgroundImage: background97,
    backgroundPosition: [-4, 0],
  },
  '🚐': {
    emoji: '🚐',
    backgroundImage: background97,
    backgroundPosition: [-2, 0],
  },
  '🛻': {
    emoji: '🛻',
    backgroundImage: background91,
    backgroundPosition: [-1, -3],
  },
  '🚚': {
    emoji: '🚚',
    backgroundImage: background97,
    backgroundPosition: [-2, -2],
  },
  '🚛': {
    emoji: '🚛',
    backgroundImage: background97,
    backgroundPosition: [-3, -2],
  },
  '🚜': {
    emoji: '🚜',
    backgroundImage: background97,
    backgroundPosition: [-4, -2],
  },
  '🦯': {
    emoji: '🦯',
    backgroundImage: background76,
    backgroundPosition: [-3, -4],
  },
  '🦽': {
    emoji: '🦽',
    backgroundImage: background26,
    backgroundPosition: [-1, -2],
  },
  '🦼': {
    emoji: '🦼',
    backgroundImage: background26,
    backgroundPosition: [0, -2],
  },
  '🩼': {
    emoji: '🩼',
    backgroundImage: background67,
    backgroundPosition: [-1, -1],
  },
  '🛴': {
    emoji: '🛴',
    backgroundImage: background91,
    backgroundPosition: [-4, -1],
  },
  '🚲': {
    emoji: '🚲',
    backgroundImage: background99,
    backgroundPosition: [-3, 0],
  },
  '🛵': {
    emoji: '🛵',
    backgroundImage: background91,
    backgroundPosition: [0, -2],
  },
  '🏍️': {
    emoji: '🏍️',
    backgroundImage: background88,
    backgroundPosition: [-1, -2],
  },
  '🛺': {
    emoji: '🛺',
    backgroundImage: background91,
    backgroundPosition: [0, -3],
  },
  '🛞': {
    emoji: '🛞',
    backgroundImage: background90,
    backgroundPosition: [-1, -4],
  },
  '🚨': {
    emoji: '🚨',
    backgroundImage: background100,
    backgroundPosition: [-3, -3],
  },
  '🚔': {
    emoji: '🚔',
    backgroundImage: background97,
    backgroundPosition: [-1, -1],
  },
  '🚍': {
    emoji: '🚍',
    backgroundImage: background27,
    backgroundPosition: [-4, -4],
  },
  '🚘': {
    emoji: '🚘',
    backgroundImage: background97,
    backgroundPosition: [0, -2],
  },
  '🚖': {
    emoji: '🚖',
    backgroundImage: background97,
    backgroundPosition: [-3, -1],
  },
  '🚡': {
    emoji: '🚡',
    backgroundImage: background97,
    backgroundPosition: [-4, -3],
  },
  '🚠': {
    emoji: '🚠',
    backgroundImage: background97,
    backgroundPosition: [-3, -3],
  },
  '🚟': {
    emoji: '🚟',
    backgroundImage: background97,
    backgroundPosition: [-2, -3],
  },
  '🚃': {
    emoji: '🚃',
    backgroundImage: background27,
    backgroundPosition: [-4, -2],
  },
  '🚋': {
    emoji: '🚋',
    backgroundImage: background27,
    backgroundPosition: [-2, -4],
  },
  '🚞': {
    emoji: '🚞',
    backgroundImage: background97,
    backgroundPosition: [-1, -3],
  },
  '🚝': {
    emoji: '🚝',
    backgroundImage: background97,
    backgroundPosition: [0, -3],
  },
  '🚄': {
    emoji: '🚄',
    backgroundImage: background27,
    backgroundPosition: [0, -3],
  },
  '🚅': {
    emoji: '🚅',
    backgroundImage: background27,
    backgroundPosition: [-1, -3],
  },
  '🚈': {
    emoji: '🚈',
    backgroundImage: background27,
    backgroundPosition: [-4, -3],
  },
  '🚂': {
    emoji: '🚂',
    backgroundImage: background27,
    backgroundPosition: [-3, -2],
  },
  '🚆': {
    emoji: '🚆',
    backgroundImage: background27,
    backgroundPosition: [-2, -3],
  },
  '🚇': {
    emoji: '🚇',
    backgroundImage: background27,
    backgroundPosition: [-3, -3],
  },
  '🚊': {
    emoji: '🚊',
    backgroundImage: background27,
    backgroundPosition: [-1, -4],
  },
  '🚉': {
    emoji: '🚉',
    backgroundImage: background27,
    backgroundPosition: [0, -4],
  },
  '✈️': {
    emoji: '✈️',
    backgroundImage: background22,
    backgroundPosition: [-2, -1],
  },
  '🛫': {
    emoji: '🛫',
    backgroundImage: background91,
    backgroundPosition: [0, -1],
  },
  '🛬': {
    emoji: '🛬',
    backgroundImage: background91,
    backgroundPosition: [-1, -1],
  },
  '🛩️': {
    emoji: '🛩️',
    backgroundImage: background91,
    backgroundPosition: [-4, 0],
  },
  '💺': {
    emoji: '💺',
    backgroundImage: background72,
    backgroundPosition: [-4, -3],
  },
  '🛰️': {
    emoji: '🛰️',
    backgroundImage: background91,
    backgroundPosition: [-2, -1],
  },
  '🚀': {
    emoji: '🚀',
    backgroundImage: background27,
    backgroundPosition: [-1, -2],
  },
  '🛸': {
    emoji: '🛸',
    backgroundImage: background91,
    backgroundPosition: [-3, -2],
  },
  '🚁': {
    emoji: '🚁',
    backgroundImage: background27,
    backgroundPosition: [-2, -2],
  },
  '🛶': {
    emoji: '🛶',
    backgroundImage: background91,
    backgroundPosition: [-1, -2],
  },
  '⛵': {
    emoji: '⛵',
    backgroundImage: background89,
    backgroundPosition: [-2, -1],
  },
  '🚤': {
    emoji: '🚤',
    backgroundImage: background100,
    backgroundPosition: [-4, -2],
  },
  '🛥️': {
    emoji: '🛥️',
    backgroundImage: background91,
    backgroundPosition: [-3, 0],
  },
  '🛳️': {
    emoji: '🛳️',
    backgroundImage: background91,
    backgroundPosition: [-3, -1],
  },
  '⛴️': {
    emoji: '⛴️',
    backgroundImage: background89,
    backgroundPosition: [-1, -1],
  },
  '🚢': {
    emoji: '🚢',
    backgroundImage: background97,
    backgroundPosition: [0, -4],
  },
  '🛟': {
    emoji: '🛟',
    backgroundImage: background90,
    backgroundPosition: [-2, -4],
  },
  '⚓': {
    emoji: '⚓',
    backgroundImage: background71,
    backgroundPosition: [-1, 0],
  },
  '🪝': {
    emoji: '🪝',
    backgroundImage: background65,
    backgroundPosition: [-2, 0],
  },
  '⛽': {
    emoji: '⛽',
    backgroundImage: background22,
    backgroundPosition: [-4, 0],
  },
  '🚧': {
    emoji: '🚧',
    backgroundImage: background100,
    backgroundPosition: [-2, -3],
  },
  '🚦': {
    emoji: '🚦',
    backgroundImage: background100,
    backgroundPosition: [-1, -3],
  },
  '🚥': {
    emoji: '🚥',
    backgroundImage: background100,
    backgroundPosition: [0, -3],
  },
  '🚏': {
    emoji: '🚏',
    backgroundImage: background97,
    backgroundPosition: [-1, 0],
  },
  '🗺️': {
    emoji: '🗺️',
    backgroundImage: background0,
    backgroundPosition: [0, -2],
  },
  '🗿': {
    emoji: '🗿',
    backgroundImage: background0,
    backgroundPosition: [0, -3],
  },
  '🗽': {
    emoji: '🗽',
    backgroundImage: background0,
    backgroundPosition: [-3, -2],
  },
  '🗼': {
    emoji: '🗼',
    backgroundImage: background0,
    backgroundPosition: [-2, -2],
  },
  '🏰': {
    emoji: '🏰',
    backgroundImage: background101,
    backgroundPosition: [-1, -4],
  },
  '🏯': {
    emoji: '🏯',
    backgroundImage: background101,
    backgroundPosition: [0, -4],
  },
  '🏟️': {
    emoji: '🏟️',
    backgroundImage: background101,
    backgroundPosition: [-4, 0],
  },
  '🎡': {
    emoji: '🎡',
    backgroundImage: background70,
    backgroundPosition: [-2, -4],
  },
  '🎢': {
    emoji: '🎢',
    backgroundImage: background70,
    backgroundPosition: [-3, -4],
  },
  '🎠': {
    emoji: '🎠',
    backgroundImage: background70,
    backgroundPosition: [-1, -4],
  },
  '⛲': {
    emoji: '⛲',
    backgroundImage: background89,
    backgroundPosition: [-4, 0],
  },
  '⛱️': {
    emoji: '⛱️',
    backgroundImage: background89,
    backgroundPosition: [-3, 0],
  },
  '🏖️': {
    emoji: '🏖️',
    backgroundImage: background88,
    backgroundPosition: [0, -4],
  },
  '🏝️': {
    emoji: '🏝️',
    backgroundImage: background101,
    backgroundPosition: [-2, 0],
  },
  '🏜️': {
    emoji: '🏜️',
    backgroundImage: background101,
    backgroundPosition: [-1, 0],
  },
  '🌋': {
    emoji: '🌋',
    backgroundImage: background73,
    backgroundPosition: [-4, -4],
  },
  '⛰️': {
    emoji: '⛰️',
    backgroundImage: background89,
    backgroundPosition: [-2, 0],
  },
  '🏔️': {
    emoji: '🏔️',
    backgroundImage: background88,
    backgroundPosition: [-3, -3],
  },
  '🗻': {
    emoji: '🗻',
    backgroundImage: background0,
    backgroundPosition: [-1, -2],
  },
  '🏕️': {
    emoji: '🏕️',
    backgroundImage: background88,
    backgroundPosition: [-4, -3],
  },
  '⛺': {
    emoji: '⛺',
    backgroundImage: background22,
    backgroundPosition: [-3, 0],
  },
  '🛖': {
    emoji: '🛖',
    backgroundImage: background90,
    backgroundPosition: [-3, -3],
  },
  '🏠': {
    emoji: '🏠',
    backgroundImage: background101,
    backgroundPosition: [0, -1],
  },
  '🏡': {
    emoji: '🏡',
    backgroundImage: background101,
    backgroundPosition: [-1, -1],
  },
  '🏘️': {
    emoji: '🏘️',
    backgroundImage: background88,
    backgroundPosition: [-2, -4],
  },
  '🏚️': {
    emoji: '🏚️',
    backgroundImage: background88,
    backgroundPosition: [-4, -4],
  },
  '🏗️': {
    emoji: '🏗️',
    backgroundImage: background88,
    backgroundPosition: [-1, -4],
  },
  '🏭': {
    emoji: '🏭',
    backgroundImage: background101,
    backgroundPosition: [-3, -3],
  },
  '🏢': {
    emoji: '🏢',
    backgroundImage: background101,
    backgroundPosition: [-2, -1],
  },
  '🏬': {
    emoji: '🏬',
    backgroundImage: background101,
    backgroundPosition: [-2, -3],
  },
  '🏣': {
    emoji: '🏣',
    backgroundImage: background101,
    backgroundPosition: [-3, -1],
  },
  '🏤': {
    emoji: '🏤',
    backgroundImage: background101,
    backgroundPosition: [-4, -1],
  },
  '🏥': {
    emoji: '🏥',
    backgroundImage: background101,
    backgroundPosition: [0, -2],
  },
  '🏦': {
    emoji: '🏦',
    backgroundImage: background101,
    backgroundPosition: [-1, -2],
  },
  '🏨': {
    emoji: '🏨',
    backgroundImage: background101,
    backgroundPosition: [-3, -2],
  },
  '🏪': {
    emoji: '🏪',
    backgroundImage: background101,
    backgroundPosition: [0, -3],
  },
  '🏫': {
    emoji: '🏫',
    backgroundImage: background101,
    backgroundPosition: [-1, -3],
  },
  '🏩': {
    emoji: '🏩',
    backgroundImage: background101,
    backgroundPosition: [-4, -2],
  },
  '💒': {
    emoji: '💒',
    backgroundImage: background30,
    backgroundPosition: [-4, -4],
  },
  '🏛️': {
    emoji: '🏛️',
    backgroundImage: background101,
    backgroundPosition: [0, 0],
  },
  '⛪': {
    emoji: '⛪',
    backgroundImage: background89,
    backgroundPosition: [-1, 0],
  },
  '🕌': {
    emoji: '🕌',
    backgroundImage: background78,
    backgroundPosition: [-3, 0],
  },
  '🕍': {
    emoji: '🕍',
    backgroundImage: background78,
    backgroundPosition: [-4, 0],
  },
  '🛕': {
    emoji: '🛕',
    backgroundImage: background90,
    backgroundPosition: [-2, -3],
  },
  '🕋': {
    emoji: '🕋',
    backgroundImage: background78,
    backgroundPosition: [-2, 0],
  },
  '⛩️': {
    emoji: '⛩️',
    backgroundImage: background89,
    backgroundPosition: [0, 0],
  },
  '🛤️': {
    emoji: '🛤️',
    backgroundImage: background91,
    backgroundPosition: [-2, 0],
  },
  '🛣️': {
    emoji: '🛣️',
    backgroundImage: background91,
    backgroundPosition: [-1, 0],
  },
  '🗾': {
    emoji: '🗾',
    backgroundImage: background0,
    backgroundPosition: [-4, -2],
  },
  '🎑': {
    emoji: '🎑',
    backgroundImage: background70,
    backgroundPosition: [-1, -2],
  },
  '🏞️': {
    emoji: '🏞️',
    backgroundImage: background101,
    backgroundPosition: [-3, 0],
  },
  '🌅': {
    emoji: '🌅',
    backgroundImage: background73,
    backgroundPosition: [-3, -3],
  },
  '🌄': {
    emoji: '🌄',
    backgroundImage: background73,
    backgroundPosition: [-2, -3],
  },
  '🌠': {
    emoji: '🌠',
    backgroundImage: background82,
    backgroundPosition: [0, -4],
  },
  '🎇': {
    emoji: '🎇',
    backgroundImage: background70,
    backgroundPosition: [-1, 0],
  },
  '🎆': {
    emoji: '🎆',
    backgroundImage: background70,
    backgroundPosition: [0, 0],
  },
  '🌇': {
    emoji: '🌇',
    backgroundImage: background73,
    backgroundPosition: [0, -4],
  },
  '🌆': {
    emoji: '🌆',
    backgroundImage: background73,
    backgroundPosition: [-4, -3],
  },
  '🏙️': {
    emoji: '🏙️',
    backgroundImage: background88,
    backgroundPosition: [-3, -4],
  },
  '🌃': {
    emoji: '🌃',
    backgroundImage: background73,
    backgroundPosition: [-1, -3],
  },
  '🌌': {
    emoji: '🌌',
    backgroundImage: background82,
    backgroundPosition: [0, 0],
  },
  '🌉': {
    emoji: '🌉',
    backgroundImage: background73,
    backgroundPosition: [-2, -4],
  },
  '🌁': {
    emoji: '🌁',
    backgroundImage: background73,
    backgroundPosition: [-4, -2],
  },
  '⌚': {
    emoji: '⌚',
    backgroundImage: background102,
    backgroundPosition: [-1, 0],
  },
  '📱': {
    emoji: '📱',
    backgroundImage: background103,
    backgroundPosition: [-4, -4],
  },
  '📲': {
    emoji: '📲',
    backgroundImage: background104,
    backgroundPosition: [0, 0],
  },
  '💻': {
    emoji: '💻',
    backgroundImage: background72,
    backgroundPosition: [0, -4],
  },
  '⌨️': {
    emoji: '⌨️',
    backgroundImage: background102,
    backgroundPosition: [-3, 0],
  },
  '🖥️': {
    emoji: '🖥️',
    backgroundImage: background25,
    backgroundPosition: [-1, -3],
  },
  '🖨️': {
    emoji: '🖨️',
    backgroundImage: background25,
    backgroundPosition: [-2, -3],
  },
  '🖱️': {
    emoji: '🖱️',
    backgroundImage: background25,
    backgroundPosition: [-3, -3],
  },
  '🖲️': {
    emoji: '🖲️',
    backgroundImage: background25,
    backgroundPosition: [-4, -3],
  },
  '🕹️': {
    emoji: '🕹️',
    backgroundImage: background46,
    backgroundPosition: [0, -2],
  },
  '🗜️': {
    emoji: '🗜️',
    backgroundImage: background0,
    backgroundPosition: [-2, 0],
  },
  '💽': {
    emoji: '💽',
    backgroundImage: background72,
    backgroundPosition: [-2, -4],
  },
  '💾': {
    emoji: '💾',
    backgroundImage: background72,
    backgroundPosition: [-3, -4],
  },
  '💿': {
    emoji: '💿',
    backgroundImage: background72,
    backgroundPosition: [-4, -4],
  },
  '📀': {
    emoji: '📀',
    backgroundImage: background105,
    backgroundPosition: [0, 0],
  },
  '📼': {
    emoji: '📼',
    backgroundImage: background104,
    backgroundPosition: [0, -2],
  },
  '📷': {
    emoji: '📷',
    backgroundImage: background104,
    backgroundPosition: [0, -1],
  },
  '📸': {
    emoji: '📸',
    backgroundImage: background104,
    backgroundPosition: [-1, -1],
  },
  '📹': {
    emoji: '📹',
    backgroundImage: background104,
    backgroundPosition: [-2, -1],
  },
  '🎥': {
    emoji: '🎥',
    backgroundImage: background69,
    backgroundPosition: [-1, 0],
  },
  '📽️': {
    emoji: '📽️',
    backgroundImage: background104,
    backgroundPosition: [-1, -2],
  },
  '🎞️': {
    emoji: '🎞️',
    backgroundImage: background70,
    backgroundPosition: [-4, -3],
  },
  '📞': {
    emoji: '📞',
    backgroundImage: background103,
    backgroundPosition: [0, -1],
  },
  '☎️': {
    emoji: '☎️',
    backgroundImage: background14,
    backgroundPosition: [-3, -1],
  },
  '📟': {
    emoji: '📟',
    backgroundImage: background103,
    backgroundPosition: [-1, -1],
  },
  '📠': {
    emoji: '📠',
    backgroundImage: background103,
    backgroundPosition: [-2, -1],
  },
  '📺': {
    emoji: '📺',
    backgroundImage: background104,
    backgroundPosition: [-3, -1],
  },
  '📻': {
    emoji: '📻',
    backgroundImage: background104,
    backgroundPosition: [-4, -1],
  },
  '🎙️': {
    emoji: '🎙️',
    backgroundImage: background70,
    backgroundPosition: [-1, -3],
  },
  '🎚️': {
    emoji: '🎚️',
    backgroundImage: background70,
    backgroundPosition: [-2, -3],
  },
  '🎛️': {
    emoji: '🎛️',
    backgroundImage: background70,
    backgroundPosition: [-3, -3],
  },
  '🧭': {
    emoji: '🧭',
    backgroundImage: background66,
    backgroundPosition: [-3, 0],
  },
  '⏱️': {
    emoji: '⏱️',
    backgroundImage: background102,
    backgroundPosition: [-3, -2],
  },
  '⏲️': {
    emoji: '⏲️',
    backgroundImage: background102,
    backgroundPosition: [-4, -2],
  },
  '⏰': {
    emoji: '⏰',
    backgroundImage: background102,
    backgroundPosition: [-2, -2],
  },
  '🕰️': {
    emoji: '🕰️',
    backgroundImage: background61,
    backgroundPosition: [-1, -1],
  },
  '⌛': {
    emoji: '⌛',
    backgroundImage: background102,
    backgroundPosition: [-2, 0],
  },
  '⏳': {
    emoji: '⏳',
    backgroundImage: background102,
    backgroundPosition: [0, -3],
  },
  '📡': {
    emoji: '📡',
    backgroundImage: background103,
    backgroundPosition: [-3, -1],
  },
  '🔋': {
    emoji: '🔋',
    backgroundImage: background104,
    backgroundPosition: [-4, -4],
  },
  '🪫': {
    emoji: '🪫',
    backgroundImage: background65,
    backgroundPosition: [-1, -3],
  },
  '🔌': {
    emoji: '🔌',
    backgroundImage: background106,
    backgroundPosition: [0, 0],
  },
  '💡': {
    emoji: '💡',
    backgroundImage: background13,
    backgroundPosition: [-4, -2],
  },
  '🔦': {
    emoji: '🔦',
    backgroundImage: background84,
    backgroundPosition: [-1, 0],
  },
  '🕯️': {
    emoji: '🕯️',
    backgroundImage: background61,
    backgroundPosition: [0, -1],
  },
  '🪔': {
    emoji: '🪔',
    backgroundImage: background67,
    backgroundPosition: [-3, -3],
  },
  '🧯': {
    emoji: '🧯',
    backgroundImage: background66,
    backgroundPosition: [0, -1],
  },
  '🛢️': {
    emoji: '🛢️',
    backgroundImage: background91,
    backgroundPosition: [0, 0],
  },
  '💸': {
    emoji: '💸',
    backgroundImage: background72,
    backgroundPosition: [-2, -3],
  },
  '💵': {
    emoji: '💵',
    backgroundImage: background72,
    backgroundPosition: [-4, -2],
  },
  '💴': {
    emoji: '💴',
    backgroundImage: background72,
    backgroundPosition: [-3, -2],
  },
  '💶': {
    emoji: '💶',
    backgroundImage: background72,
    backgroundPosition: [0, -3],
  },
  '💷': {
    emoji: '💷',
    backgroundImage: background72,
    backgroundPosition: [-1, -3],
  },
  '🪙': {
    emoji: '🪙',
    backgroundImage: background67,
    backgroundPosition: [-3, -4],
  },
  '💰': {
    emoji: '💰',
    backgroundImage: background72,
    backgroundPosition: [-4, -1],
  },
  '💳': {
    emoji: '💳',
    backgroundImage: background72,
    backgroundPosition: [-2, -2],
  },
  '🪪': {
    emoji: '🪪',
    backgroundImage: background65,
    backgroundPosition: [0, -3],
  },
  '💎': {
    emoji: '💎',
    backgroundImage: background30,
    backgroundPosition: [0, -2],
  },
  '⚖️': {
    emoji: '⚖️',
    backgroundImage: background71,
    backgroundPosition: [-3, 0],
  },
  '🪜': {
    emoji: '🪜',
    backgroundImage: background65,
    backgroundPosition: [-1, 0],
  },
  '🧰': {
    emoji: '🧰',
    backgroundImage: background66,
    backgroundPosition: [-1, -1],
  },
  '🪛': {
    emoji: '🪛',
    backgroundImage: background65,
    backgroundPosition: [0, 0],
  },
  '🔧': {
    emoji: '🔧',
    backgroundImage: background84,
    backgroundPosition: [-2, 0],
  },
  '🔨': {
    emoji: '🔨',
    backgroundImage: background84,
    backgroundPosition: [-3, 0],
  },
  '⚒️': {
    emoji: '⚒️',
    backgroundImage: background71,
    backgroundPosition: [0, 0],
  },
  '🛠️': {
    emoji: '🛠️',
    backgroundImage: background90,
    backgroundPosition: [-3, -4],
  },
  '⛏️': {
    emoji: '⛏️',
    backgroundImage: background71,
    backgroundPosition: [-1, -4],
  },
  '🪚': {
    emoji: '🪚',
    backgroundImage: background67,
    backgroundPosition: [-4, -4],
  },
  '🔩': {
    emoji: '🔩',
    backgroundImage: background84,
    backgroundPosition: [-4, 0],
  },
  '⚙️': {
    emoji: '⚙️',
    backgroundImage: background71,
    backgroundPosition: [0, -1],
  },
  '🪤': {
    emoji: '🪤',
    backgroundImage: background65,
    backgroundPosition: [-4, -1],
  },
  '🧱': {
    emoji: '🧱',
    backgroundImage: background66,
    backgroundPosition: [-2, -1],
  },
  '⛓️': {
    emoji: '⛓️',
    backgroundImage: background71,
    backgroundPosition: [-3, -4],
  },
  '🧲': {
    emoji: '🧲',
    backgroundImage: background66,
    backgroundPosition: [-3, -1],
  },
  '🔫': {
    emoji: '🔫',
    backgroundImage: background84,
    backgroundPosition: [-1, -1],
  },
  '💣': {
    emoji: '💣',
    backgroundImage: background13,
    backgroundPosition: [-1, -3],
  },
  '🧨': {
    emoji: '🧨',
    backgroundImage: background33,
    backgroundPosition: [-3, -4],
  },
  '🪓': {
    emoji: '🪓',
    backgroundImage: background67,
    backgroundPosition: [-2, -3],
  },
  '🔪': {
    emoji: '🔪',
    backgroundImage: background84,
    backgroundPosition: [0, -1],
  },
  '🗡️': {
    emoji: '🗡️',
    backgroundImage: background0,
    backgroundPosition: [0, -1],
  },
  '⚔️': {
    emoji: '⚔️',
    backgroundImage: background71,
    backgroundPosition: [-2, 0],
  },
  '🛡️': {
    emoji: '🛡️',
    backgroundImage: background90,
    backgroundPosition: [-4, -4],
  },
  '🚬': {
    emoji: '🚬',
    backgroundImage: background100,
    backgroundPosition: [-2, -4],
  },
  '⚰️': {
    emoji: '⚰️',
    backgroundImage: background71,
    backgroundPosition: [-3, -2],
  },
  '🪦': {
    emoji: '🪦',
    backgroundImage: background65,
    backgroundPosition: [-1, -2],
  },
  '⚱️': {
    emoji: '⚱️',
    backgroundImage: background71,
    backgroundPosition: [-4, -2],
  },
  '🏺': {
    emoji: '🏺',
    backgroundImage: background77,
    backgroundPosition: [-4, -1],
  },
  '🔮': {
    emoji: '🔮',
    backgroundImage: background84,
    backgroundPosition: [-4, -1],
  },
  '📿': {
    emoji: '📿',
    backgroundImage: background104,
    backgroundPosition: [-2, -2],
  },
  '🧿': {
    emoji: '🧿',
    backgroundImage: background66,
    backgroundPosition: [-1, -4],
  },
  '🪬': {
    emoji: '🪬',
    backgroundImage: background65,
    backgroundPosition: [-2, -3],
  },
  '💈': {
    emoji: '💈',
    backgroundImage: background30,
    backgroundPosition: [-4, 0],
  },
  '⚗️': {
    emoji: '⚗️',
    backgroundImage: background71,
    backgroundPosition: [-4, 0],
  },
  '🔭': {
    emoji: '🔭',
    backgroundImage: background84,
    backgroundPosition: [-3, -1],
  },
  '🔬': {
    emoji: '🔬',
    backgroundImage: background84,
    backgroundPosition: [-2, -1],
  },
  '🕳️': {
    emoji: '🕳️',
    backgroundImage: background61,
    backgroundPosition: [-2, -1],
  },
  '🩻': {
    emoji: '🩻',
    backgroundImage: background67,
    backgroundPosition: [0, -1],
  },
  '🩹': {
    emoji: '🩹',
    backgroundImage: background67,
    backgroundPosition: [-3, 0],
  },
  '🩺': {
    emoji: '🩺',
    backgroundImage: background67,
    backgroundPosition: [-4, 0],
  },
  '💊': {
    emoji: '💊',
    backgroundImage: background30,
    backgroundPosition: [-1, -1],
  },
  '💉': {
    emoji: '💉',
    backgroundImage: background30,
    backgroundPosition: [0, -1],
  },
  '🩸': {
    emoji: '🩸',
    backgroundImage: background67,
    backgroundPosition: [-2, 0],
  },
  '🧬': {
    emoji: '🧬',
    backgroundImage: background66,
    backgroundPosition: [-2, 0],
  },
  '🦠': {
    emoji: '🦠',
    backgroundImage: background76,
    backgroundPosition: [-3, -1],
  },
  '🧫': {
    emoji: '🧫',
    backgroundImage: background66,
    backgroundPosition: [-1, 0],
  },
  '🧪': {
    emoji: '🧪',
    backgroundImage: background66,
    backgroundPosition: [0, 0],
  },
  '🌡️': {
    emoji: '🌡️',
    backgroundImage: background82,
    backgroundPosition: [-1, -4],
  },
  '🧹': {
    emoji: '🧹',
    backgroundImage: background66,
    backgroundPosition: [0, -3],
  },
  '🪠': {
    emoji: '🪠',
    backgroundImage: background65,
    backgroundPosition: [0, -1],
  },
  '🧺': {
    emoji: '🧺',
    backgroundImage: background66,
    backgroundPosition: [-1, -3],
  },
  '🧻': {
    emoji: '🧻',
    backgroundImage: background66,
    backgroundPosition: [-2, -3],
  },
  '🚽': {
    emoji: '🚽',
    backgroundImage: background107,
    backgroundPosition: [0, -3],
  },
  '🚰': {
    emoji: '🚰',
    backgroundImage: background99,
    backgroundPosition: [-1, 0],
  },
  '🚿': {
    emoji: '🚿',
    backgroundImage: background107,
    backgroundPosition: [-2, -3],
  },
  '🛁': {
    emoji: '🛁',
    backgroundImage: background107,
    backgroundPosition: [-4, -4],
  },
  '🛀': {
    emoji: '🛀',
    backgroundImage: background107,
    backgroundPosition: [-3, -3],
  },
  '🧼': {
    emoji: '🧼',
    backgroundImage: background66,
    backgroundPosition: [-3, -3],
  },
  '🪥': {
    emoji: '🪥',
    backgroundImage: background65,
    backgroundPosition: [0, -2],
  },
  '🪒': {
    emoji: '🪒',
    backgroundImage: background67,
    backgroundPosition: [-1, -3],
  },
  '🧽': {
    emoji: '🧽',
    backgroundImage: background66,
    backgroundPosition: [-4, -3],
  },
  '🪣': {
    emoji: '🪣',
    backgroundImage: background65,
    backgroundPosition: [-3, -1],
  },
  '🧴': {
    emoji: '🧴',
    backgroundImage: background66,
    backgroundPosition: [0, -2],
  },
  '🛎️': {
    emoji: '🛎️',
    backgroundImage: background90,
    backgroundPosition: [-2, -2],
  },
  '🔑': {
    emoji: '🔑',
    backgroundImage: background106,
    backgroundPosition: [0, -1],
  },
  '🗝️': {
    emoji: '🗝️',
    backgroundImage: background0,
    backgroundPosition: [-3, 0],
  },
  '🚪': {
    emoji: '🚪',
    backgroundImage: background100,
    backgroundPosition: [0, -4],
  },
  '🪑': {
    emoji: '🪑',
    backgroundImage: background67,
    backgroundPosition: [0, -3],
  },
  '🛋️': {
    emoji: '🛋️',
    backgroundImage: background90,
    backgroundPosition: [-4, 0],
  },
  '🛏️': {
    emoji: '🛏️',
    backgroundImage: background90,
    backgroundPosition: [-3, -2],
  },
  '🛌': {
    emoji: '🛌',
    backgroundImage: background90,
    backgroundPosition: [0, -1],
  },
  '🧸': {
    emoji: '🧸',
    backgroundImage: background66,
    backgroundPosition: [-4, -2],
  },
  '🪆': {
    emoji: '🪆',
    backgroundImage: background67,
    backgroundPosition: [-3, -2],
  },
  '🖼️': {
    emoji: '🖼️',
    backgroundImage: background25,
    backgroundPosition: [0, -4],
  },
  '🪞': {
    emoji: '🪞',
    backgroundImage: background65,
    backgroundPosition: [-3, 0],
  },
  '🪟': {
    emoji: '🪟',
    backgroundImage: background65,
    backgroundPosition: [-4, 0],
  },
  '🛍️': {
    emoji: '🛍️',
    backgroundImage: background90,
    backgroundPosition: [-1, -2],
  },
  '🛒': {
    emoji: '🛒',
    backgroundImage: background90,
    backgroundPosition: [-1, -3],
  },
  '🎁': {
    emoji: '🎁',
    backgroundImage: background15,
    backgroundPosition: [0, -3],
  },
  '🎈': {
    emoji: '🎈',
    backgroundImage: background70,
    backgroundPosition: [-2, 0],
  },
  '🎏': {
    emoji: '🎏',
    backgroundImage: background70,
    backgroundPosition: [-4, -1],
  },
  '🎀': {
    emoji: '🎀',
    backgroundImage: background15,
    backgroundPosition: [-4, -2],
  },
  '🪄': {
    emoji: '🪄',
    backgroundImage: background67,
    backgroundPosition: [-1, -2],
  },
  '🪅': {
    emoji: '🪅',
    backgroundImage: background67,
    backgroundPosition: [-2, -2],
  },
  '🎊': {
    emoji: '🎊',
    backgroundImage: background70,
    backgroundPosition: [-4, 0],
  },
  '🎉': {
    emoji: '🎉',
    backgroundImage: background70,
    backgroundPosition: [-3, 0],
  },
  '🎎': {
    emoji: '🎎',
    backgroundImage: background70,
    backgroundPosition: [-3, -1],
  },
  '🏮': {
    emoji: '🏮',
    backgroundImage: background101,
    backgroundPosition: [-4, -3],
  },
  '🎐': {
    emoji: '🎐',
    backgroundImage: background70,
    backgroundPosition: [0, -2],
  },
  '🪩': {
    emoji: '🪩',
    backgroundImage: background65,
    backgroundPosition: [-4, -2],
  },
  '🧧': {
    emoji: '🧧',
    backgroundImage: background33,
    backgroundPosition: [-2, -4],
  },
  '✉️': {
    emoji: '✉️',
    backgroundImage: background22,
    backgroundPosition: [-3, -1],
  },
  '📩': {
    emoji: '📩',
    backgroundImage: background103,
    backgroundPosition: [-1, -3],
  },
  '📨': {
    emoji: '📨',
    backgroundImage: background103,
    backgroundPosition: [0, -3],
  },
  '📧': {
    emoji: '📧',
    backgroundImage: background103,
    backgroundPosition: [-4, -2],
  },
  '💌': {
    emoji: '💌',
    backgroundImage: background30,
    backgroundPosition: [-3, -1],
  },
  '📥': {
    emoji: '📥',
    backgroundImage: background103,
    backgroundPosition: [-2, -2],
  },
  '📤': {
    emoji: '📤',
    backgroundImage: background103,
    backgroundPosition: [-1, -2],
  },
  '📦': {
    emoji: '📦',
    backgroundImage: background103,
    backgroundPosition: [-3, -2],
  },
  '🏷️': {
    emoji: '🏷️',
    backgroundImage: background77,
    backgroundPosition: [-1, -1],
  },
  '🪧': {
    emoji: '🪧',
    backgroundImage: background65,
    backgroundPosition: [-2, -2],
  },
  '📪': {
    emoji: '📪',
    backgroundImage: background103,
    backgroundPosition: [-2, -3],
  },
  '📫': {
    emoji: '📫',
    backgroundImage: background103,
    backgroundPosition: [-3, -3],
  },
  '📬': {
    emoji: '📬',
    backgroundImage: background103,
    backgroundPosition: [-4, -3],
  },
  '📭': {
    emoji: '📭',
    backgroundImage: background103,
    backgroundPosition: [0, -4],
  },
  '📮': {
    emoji: '📮',
    backgroundImage: background103,
    backgroundPosition: [-1, -4],
  },
  '📯': {
    emoji: '📯',
    backgroundImage: background103,
    backgroundPosition: [-2, -4],
  },
  '📜': {
    emoji: '📜',
    backgroundImage: background103,
    backgroundPosition: [-3, 0],
  },
  '📃': {
    emoji: '📃',
    backgroundImage: background105,
    backgroundPosition: [-3, 0],
  },
  '📄': {
    emoji: '📄',
    backgroundImage: background105,
    backgroundPosition: [-4, 0],
  },
  '📑': {
    emoji: '📑',
    backgroundImage: background105,
    backgroundPosition: [-2, -3],
  },
  '🧾': {
    emoji: '🧾',
    backgroundImage: background66,
    backgroundPosition: [0, -4],
  },
  '📊': {
    emoji: '📊',
    backgroundImage: background105,
    backgroundPosition: [0, -2],
  },
  '📈': {
    emoji: '📈',
    backgroundImage: background105,
    backgroundPosition: [-3, -1],
  },
  '📉': {
    emoji: '📉',
    backgroundImage: background105,
    backgroundPosition: [-4, -1],
  },
  '🗒️': {
    emoji: '🗒️',
    backgroundImage: background0,
    backgroundPosition: [0, 0],
  },
  '🗓️': {
    emoji: '🗓️',
    backgroundImage: background0,
    backgroundPosition: [-1, 0],
  },
  '📆': {
    emoji: '📆',
    backgroundImage: background105,
    backgroundPosition: [-1, -1],
  },
  '📅': {
    emoji: '📅',
    backgroundImage: background105,
    backgroundPosition: [0, -1],
  },
  '🗑️': {
    emoji: '🗑️',
    backgroundImage: background25,
    backgroundPosition: [-4, -4],
  },
  '📇': {
    emoji: '📇',
    backgroundImage: background105,
    backgroundPosition: [-2, -1],
  },
  '🗃️': {
    emoji: '🗃️',
    backgroundImage: background25,
    backgroundPosition: [-2, -4],
  },
  '🗳️': {
    emoji: '🗳️',
    backgroundImage: background0,
    backgroundPosition: [-4, -1],
  },
  '🗄️': {
    emoji: '🗄️',
    backgroundImage: background25,
    backgroundPosition: [-3, -4],
  },
  '📋': {
    emoji: '📋',
    backgroundImage: background105,
    backgroundPosition: [-1, -2],
  },
  '📁': {
    emoji: '📁',
    backgroundImage: background105,
    backgroundPosition: [-1, 0],
  },
  '📂': {
    emoji: '📂',
    backgroundImage: background105,
    backgroundPosition: [-2, 0],
  },
  '🗂️': {
    emoji: '🗂️',
    backgroundImage: background25,
    backgroundPosition: [-1, -4],
  },
  '🗞️': {
    emoji: '🗞️',
    backgroundImage: background0,
    backgroundPosition: [-4, 0],
  },
  '📰': {
    emoji: '📰',
    backgroundImage: background103,
    backgroundPosition: [-3, -4],
  },
  '📓': {
    emoji: '📓',
    backgroundImage: background105,
    backgroundPosition: [-4, -3],
  },
  '📔': {
    emoji: '📔',
    backgroundImage: background105,
    backgroundPosition: [0, -4],
  },
  '📒': {
    emoji: '📒',
    backgroundImage: background105,
    backgroundPosition: [-3, -3],
  },
  '📕': {
    emoji: '📕',
    backgroundImage: background105,
    backgroundPosition: [-1, -4],
  },
  '📗': {
    emoji: '📗',
    backgroundImage: background105,
    backgroundPosition: [-3, -4],
  },
  '📘': {
    emoji: '📘',
    backgroundImage: background105,
    backgroundPosition: [-4, -4],
  },
  '📙': {
    emoji: '📙',
    backgroundImage: background103,
    backgroundPosition: [0, 0],
  },
  '📚': {
    emoji: '📚',
    backgroundImage: background103,
    backgroundPosition: [-1, 0],
  },
  '📖': {
    emoji: '📖',
    backgroundImage: background105,
    backgroundPosition: [-2, -4],
  },
  '🔖': {
    emoji: '🔖',
    backgroundImage: background106,
    backgroundPosition: [0, -2],
  },
  '🧷': {
    emoji: '🧷',
    backgroundImage: background66,
    backgroundPosition: [-3, -2],
  },
  '🔗': {
    emoji: '🔗',
    backgroundImage: background106,
    backgroundPosition: [-1, -2],
  },
  '📎': {
    emoji: '📎',
    backgroundImage: background105,
    backgroundPosition: [-4, -2],
  },
  '🖇️': {
    emoji: '🖇️',
    backgroundImage: background46,
    backgroundPosition: [-2, -3],
  },
  '📐': {
    emoji: '📐',
    backgroundImage: background105,
    backgroundPosition: [-1, -3],
  },
  '📏': {
    emoji: '📏',
    backgroundImage: background105,
    backgroundPosition: [0, -3],
  },
  '🧮': {
    emoji: '🧮',
    backgroundImage: background66,
    backgroundPosition: [-4, 0],
  },
  '📌': {
    emoji: '📌',
    backgroundImage: background105,
    backgroundPosition: [-2, -2],
  },
  '📍': {
    emoji: '📍',
    backgroundImage: background105,
    backgroundPosition: [-3, -2],
  },
  '✂️': {
    emoji: '✂️',
    backgroundImage: background22,
    backgroundPosition: [0, -1],
  },
  '🖊️': {
    emoji: '🖊️',
    backgroundImage: background46,
    backgroundPosition: [-3, -3],
  },
  '🖋️': {
    emoji: '🖋️',
    backgroundImage: background46,
    backgroundPosition: [-4, -3],
  },
  '✒️': {
    emoji: '✒️',
    backgroundImage: background23,
    backgroundPosition: [-4, -1],
  },
  '🖌️': {
    emoji: '🖌️',
    backgroundImage: background46,
    backgroundPosition: [0, -4],
  },
  '🖍️': {
    emoji: '🖍️',
    backgroundImage: background46,
    backgroundPosition: [-1, -4],
  },
  '📝': {
    emoji: '📝',
    backgroundImage: background103,
    backgroundPosition: [-4, 0],
  },
  '✏️': {
    emoji: '✏️',
    backgroundImage: background23,
    backgroundPosition: [-3, -1],
  },
  '🔍': {
    emoji: '🔍',
    backgroundImage: background106,
    backgroundPosition: [-1, 0],
  },
  '🔎': {
    emoji: '🔎',
    backgroundImage: background106,
    backgroundPosition: [-2, 0],
  },
  '🔏': {
    emoji: '🔏',
    backgroundImage: background106,
    backgroundPosition: [-3, 0],
  },
  '🔐': {
    emoji: '🔐',
    backgroundImage: background106,
    backgroundPosition: [-4, 0],
  },
  '🔒': {
    emoji: '🔒',
    backgroundImage: background106,
    backgroundPosition: [-1, -1],
  },
  '🔓': {
    emoji: '🔓',
    backgroundImage: background106,
    backgroundPosition: [-2, -1],
  },
  '❤️': {
    emoji: '❤️',
    backgroundImage: background83,
    backgroundPosition: [-1, 0],
  },
  '🧡': {
    emoji: '🧡',
    backgroundImage: background33,
    backgroundPosition: [-1, -3],
  },
  '💛': {
    emoji: '💛',
    backgroundImage: background13,
    backgroundPosition: [-3, -1],
  },
  '💚': {
    emoji: '💚',
    backgroundImage: background13,
    backgroundPosition: [-2, -1],
  },
  '💙': {
    emoji: '💙',
    backgroundImage: background13,
    backgroundPosition: [-1, -1],
  },
  '💜': {
    emoji: '💜',
    backgroundImage: background13,
    backgroundPosition: [-4, -1],
  },
  '🖤': {
    emoji: '🖤',
    backgroundImage: background25,
    backgroundPosition: [0, -3],
  },
  '🤍': {
    emoji: '🤍',
    backgroundImage: background8,
    backgroundPosition: [-2, -2],
  },
  '🤎': {
    emoji: '🤎',
    backgroundImage: background8,
    backgroundPosition: [-3, -2],
  },
  '💔': {
    emoji: '💔',
    backgroundImage: background13,
    backgroundPosition: [-1, 0],
  },
  '❤️‍🔥': {
    emoji: '❤️‍🔥',
    backgroundImage: background83,
    backgroundPosition: [-2, 0],
  },
  '❤️‍🩹': {
    emoji: '❤️‍🩹',
    backgroundImage: background83,
    backgroundPosition: [-3, 0],
  },
  '❣️': {
    emoji: '❣️',
    backgroundImage: background83,
    backgroundPosition: [0, 0],
  },
  '💕': {
    emoji: '💕',
    backgroundImage: background13,
    backgroundPosition: [-2, 0],
  },
  '💞': {
    emoji: '💞',
    backgroundImage: background13,
    backgroundPosition: [-1, -2],
  },
  '💓': {
    emoji: '💓',
    backgroundImage: background13,
    backgroundPosition: [0, 0],
  },
  '💗': {
    emoji: '💗',
    backgroundImage: background13,
    backgroundPosition: [-4, 0],
  },
  '💖': {
    emoji: '💖',
    backgroundImage: background13,
    backgroundPosition: [-3, 0],
  },
  '💘': {
    emoji: '💘',
    backgroundImage: background13,
    backgroundPosition: [0, -1],
  },
  '💝': {
    emoji: '💝',
    backgroundImage: background13,
    backgroundPosition: [0, -2],
  },
  '💟': {
    emoji: '💟',
    backgroundImage: background13,
    backgroundPosition: [-2, -2],
  },
  '☮️': {
    emoji: '☮️',
    backgroundImage: background14,
    backgroundPosition: [-4, -4],
  },
  '✝️': {
    emoji: '✝️',
    backgroundImage: background23,
    backgroundPosition: [-2, -2],
  },
  '☪️': {
    emoji: '☪️',
    backgroundImage: background14,
    backgroundPosition: [-3, -4],
  },
  '🕉️': {
    emoji: '🕉️',
    backgroundImage: background78,
    backgroundPosition: [0, 0],
  },
  '☸️': {
    emoji: '☸️',
    backgroundImage: background3,
    backgroundPosition: [-1, 0],
  },
  '✡️': {
    emoji: '✡️',
    backgroundImage: background23,
    backgroundPosition: [-3, -2],
  },
  '🔯': {
    emoji: '🔯',
    backgroundImage: background84,
    backgroundPosition: [0, -2],
  },
  '🕎': {
    emoji: '🕎',
    backgroundImage: background78,
    backgroundPosition: [0, -1],
  },
  '☯️': {
    emoji: '☯️',
    backgroundImage: background3,
    backgroundPosition: [0, 0],
  },
  '☦️': {
    emoji: '☦️',
    backgroundImage: background14,
    backgroundPosition: [-2, -4],
  },
  '🛐': {
    emoji: '🛐',
    backgroundImage: background90,
    backgroundPosition: [-4, -2],
  },
  '⛎': {
    emoji: '⛎',
    backgroundImage: background71,
    backgroundPosition: [0, -4],
  },
  '♈': {
    emoji: '♈',
    backgroundImage: background3,
    backgroundPosition: [-4, 0],
  },
  '♉': {
    emoji: '♉',
    backgroundImage: background3,
    backgroundPosition: [0, -1],
  },
  '♊': {
    emoji: '♊',
    backgroundImage: background3,
    backgroundPosition: [-1, -1],
  },
  '♋': {
    emoji: '♋',
    backgroundImage: background3,
    backgroundPosition: [-2, -1],
  },
  '♌': {
    emoji: '♌',
    backgroundImage: background3,
    backgroundPosition: [-3, -1],
  },
  '♍': {
    emoji: '♍',
    backgroundImage: background3,
    backgroundPosition: [-4, -1],
  },
  '♎': {
    emoji: '♎',
    backgroundImage: background3,
    backgroundPosition: [0, -2],
  },
  '♏': {
    emoji: '♏',
    backgroundImage: background3,
    backgroundPosition: [-1, -2],
  },
  '♐': {
    emoji: '♐',
    backgroundImage: background3,
    backgroundPosition: [-2, -2],
  },
  '♑': {
    emoji: '♑',
    backgroundImage: background3,
    backgroundPosition: [-3, -2],
  },
  '♒': {
    emoji: '♒',
    backgroundImage: background3,
    backgroundPosition: [-4, -2],
  },
  '♓': {
    emoji: '♓',
    backgroundImage: background3,
    backgroundPosition: [0, -3],
  },
  '🆔': {
    emoji: '🆔',
    backgroundImage: background108,
    backgroundPosition: [-3, -1],
  },
  '⚛️': {
    emoji: '⚛️',
    backgroundImage: background71,
    backgroundPosition: [-1, -1],
  },
  '🉑': {
    emoji: '🉑',
    backgroundImage: background73,
    backgroundPosition: [-2, -2],
  },
  '☢️': {
    emoji: '☢️',
    backgroundImage: background14,
    backgroundPosition: [0, -4],
  },
  '☣️': {
    emoji: '☣️',
    backgroundImage: background14,
    backgroundPosition: [-1, -4],
  },
  '📴': {
    emoji: '📴',
    backgroundImage: background104,
    backgroundPosition: [-2, 0],
  },
  '📳': {
    emoji: '📳',
    backgroundImage: background104,
    backgroundPosition: [-1, 0],
  },
  '🈶': {
    emoji: '🈶',
    backgroundImage: background73,
    backgroundPosition: [-1, -1],
  },
  '🈚': {
    emoji: '🈚',
    backgroundImage: background73,
    backgroundPosition: [0, 0],
  },
  '🈸': {
    emoji: '🈸',
    backgroundImage: background73,
    backgroundPosition: [-3, -1],
  },
  '🈺': {
    emoji: '🈺',
    backgroundImage: background73,
    backgroundPosition: [0, -2],
  },
  '🈷️': {
    emoji: '🈷️',
    backgroundImage: background73,
    backgroundPosition: [-2, -1],
  },
  '✴️': {
    emoji: '✴️',
    backgroundImage: background23,
    backgroundPosition: [-1, -3],
  },
  '🆚': {
    emoji: '🆚',
    backgroundImage: background108,
    backgroundPosition: [-4, -2],
  },
  '💮': {
    emoji: '💮',
    backgroundImage: background72,
    backgroundPosition: [-2, -1],
  },
  '🉐': {
    emoji: '🉐',
    backgroundImage: background73,
    backgroundPosition: [-1, -2],
  },
  '㊙️': {
    emoji: '㊙️',
    backgroundImage: background83,
    backgroundPosition: [-2, -4],
  },
  '㊗️': {
    emoji: '㊗️',
    backgroundImage: background83,
    backgroundPosition: [-1, -4],
  },
  '🈴': {
    emoji: '🈴',
    backgroundImage: background73,
    backgroundPosition: [-4, 0],
  },
  '🈵': {
    emoji: '🈵',
    backgroundImage: background73,
    backgroundPosition: [0, -1],
  },
  '🈹': {
    emoji: '🈹',
    backgroundImage: background73,
    backgroundPosition: [-4, -1],
  },
  '🈲': {
    emoji: '🈲',
    backgroundImage: background73,
    backgroundPosition: [-2, 0],
  },
  '🅰️': {
    emoji: '🅰️',
    backgroundImage: background108,
    backgroundPosition: [0, 0],
  },
  '🅱️': {
    emoji: '🅱️',
    backgroundImage: background108,
    backgroundPosition: [-1, 0],
  },
  '🆎': {
    emoji: '🆎',
    backgroundImage: background108,
    backgroundPosition: [-4, 0],
  },
  '🆑': {
    emoji: '🆑',
    backgroundImage: background108,
    backgroundPosition: [0, -1],
  },
  '🅾️': {
    emoji: '🅾️',
    backgroundImage: background108,
    backgroundPosition: [-2, 0],
  },
  '🆘': {
    emoji: '🆘',
    backgroundImage: background108,
    backgroundPosition: [-2, -2],
  },
  '❌': {
    emoji: '❌',
    backgroundImage: background23,
    backgroundPosition: [-4, -3],
  },
  '⭕': {
    emoji: '⭕',
    backgroundImage: background83,
    backgroundPosition: [-3, -3],
  },
  '🛑': {
    emoji: '🛑',
    backgroundImage: background90,
    backgroundPosition: [0, -3],
  },
  '⛔': {
    emoji: '⛔',
    backgroundImage: background71,
    backgroundPosition: [-4, -4],
  },
  '📛': {
    emoji: '📛',
    backgroundImage: background103,
    backgroundPosition: [-2, 0],
  },
  '🚫': {
    emoji: '🚫',
    backgroundImage: background100,
    backgroundPosition: [-1, -4],
  },
  '💯': {
    emoji: '💯',
    backgroundImage: background72,
    backgroundPosition: [-3, -1],
  },
  '💢': {
    emoji: '💢',
    backgroundImage: background13,
    backgroundPosition: [0, -3],
  },
  '♨️': {
    emoji: '♨️',
    backgroundImage: background3,
    backgroundPosition: [-1, -4],
  },
  '🚷': {
    emoji: '🚷',
    backgroundImage: background107,
    backgroundPosition: [-4, -1],
  },
  '🚯': {
    emoji: '🚯',
    backgroundImage: background99,
    backgroundPosition: [0, 0],
  },
  '🚳': {
    emoji: '🚳',
    backgroundImage: background99,
    backgroundPosition: [-4, 0],
  },
  '🚱': {
    emoji: '🚱',
    backgroundImage: background99,
    backgroundPosition: [-2, 0],
  },
  '🔞': {
    emoji: '🔞',
    backgroundImage: background106,
    backgroundPosition: [-3, -3],
  },
  '📵': {
    emoji: '📵',
    backgroundImage: background104,
    backgroundPosition: [-3, 0],
  },
  '🚭': {
    emoji: '🚭',
    backgroundImage: background100,
    backgroundPosition: [-3, -4],
  },
  '❗': {
    emoji: '❗',
    backgroundImage: background23,
    backgroundPosition: [-4, -4],
  },
  '❕': {
    emoji: '❕',
    backgroundImage: background23,
    backgroundPosition: [-3, -4],
  },
  '❓': {
    emoji: '❓',
    backgroundImage: background23,
    backgroundPosition: [-1, -4],
  },
  '❔': {
    emoji: '❔',
    backgroundImage: background23,
    backgroundPosition: [-2, -4],
  },
  '‼️': {
    emoji: '‼️',
    backgroundImage: background109,
    backgroundPosition: [-4, -2],
  },
  '⁉️': {
    emoji: '⁉️',
    backgroundImage: background109,
    backgroundPosition: [0, -3],
  },
  '🔅': {
    emoji: '🔅',
    backgroundImage: background104,
    backgroundPosition: [-3, -3],
  },
  '🔆': {
    emoji: '🔆',
    backgroundImage: background104,
    backgroundPosition: [-4, -3],
  },
  '〽️': {
    emoji: '〽️',
    backgroundImage: background83,
    backgroundPosition: [0, -4],
  },
  '⚠️': {
    emoji: '⚠️',
    backgroundImage: background71,
    backgroundPosition: [-3, -1],
  },
  '🚸': {
    emoji: '🚸',
    backgroundImage: background107,
    backgroundPosition: [0, -2],
  },
  '🔱': {
    emoji: '🔱',
    backgroundImage: background84,
    backgroundPosition: [-2, -2],
  },
  '⚜️': {
    emoji: '⚜️',
    backgroundImage: background71,
    backgroundPosition: [-2, -1],
  },
  '🔰': {
    emoji: '🔰',
    backgroundImage: background84,
    backgroundPosition: [-1, -2],
  },
  '♻️': {
    emoji: '♻️',
    backgroundImage: background3,
    backgroundPosition: [-2, -4],
  },
  '✅': {
    emoji: '✅',
    backgroundImage: background22,
    backgroundPosition: [-1, -1],
  },
  '🈯': {
    emoji: '🈯',
    backgroundImage: background73,
    backgroundPosition: [-1, 0],
  },
  '💹': {
    emoji: '💹',
    backgroundImage: background72,
    backgroundPosition: [-3, -3],
  },
  '❇️': {
    emoji: '❇️',
    backgroundImage: background23,
    backgroundPosition: [-3, -3],
  },
  '✳️': {
    emoji: '✳️',
    backgroundImage: background23,
    backgroundPosition: [0, -3],
  },
  '❎': {
    emoji: '❎',
    backgroundImage: background23,
    backgroundPosition: [0, -4],
  },
  '🌐': {
    emoji: '🌐',
    backgroundImage: background82,
    backgroundPosition: [-4, 0],
  },
  '💠': {
    emoji: '💠',
    backgroundImage: background13,
    backgroundPosition: [-3, -2],
  },
  'Ⓜ️': {
    emoji: 'Ⓜ️',
    backgroundImage: background102,
    backgroundPosition: [-4, -3],
  },
  '🌀': {
    emoji: '🌀',
    backgroundImage: background73,
    backgroundPosition: [-3, -2],
  },
  '💤': {
    emoji: '💤',
    backgroundImage: background13,
    backgroundPosition: [-2, -3],
  },
  '🏧': {
    emoji: '🏧',
    backgroundImage: background101,
    backgroundPosition: [-2, -2],
  },
  '🚾': {
    emoji: '🚾',
    backgroundImage: background107,
    backgroundPosition: [-1, -3],
  },
  '♿': {
    emoji: '♿',
    backgroundImage: background3,
    backgroundPosition: [-4, -4],
  },
  '🅿️': {
    emoji: '🅿️',
    backgroundImage: background108,
    backgroundPosition: [-3, 0],
  },
  '🛗': {
    emoji: '🛗',
    backgroundImage: background90,
    backgroundPosition: [-4, -3],
  },
  '🈳': {
    emoji: '🈳',
    backgroundImage: background73,
    backgroundPosition: [-3, 0],
  },
  '🈂️': {
    emoji: '🈂️',
    backgroundImage: background110,
    backgroundPosition: [-4, -4],
  },
  '🛂': {
    emoji: '🛂',
    backgroundImage: background90,
    backgroundPosition: [0, 0],
  },
  '🛃': {
    emoji: '🛃',
    backgroundImage: background90,
    backgroundPosition: [-1, 0],
  },
  '🛄': {
    emoji: '🛄',
    backgroundImage: background90,
    backgroundPosition: [-2, 0],
  },
  '🛅': {
    emoji: '🛅',
    backgroundImage: background90,
    backgroundPosition: [-3, 0],
  },
  '🚹': {
    emoji: '🚹',
    backgroundImage: background107,
    backgroundPosition: [-1, -2],
  },
  '🚺': {
    emoji: '🚺',
    backgroundImage: background107,
    backgroundPosition: [-2, -2],
  },
  '🚼': {
    emoji: '🚼',
    backgroundImage: background107,
    backgroundPosition: [-4, -2],
  },
  '⚧️': {
    emoji: '⚧️',
    backgroundImage: background71,
    backgroundPosition: [0, -2],
  },
  '🚻': {
    emoji: '🚻',
    backgroundImage: background107,
    backgroundPosition: [-3, -2],
  },
  '🚮': {
    emoji: '🚮',
    backgroundImage: background100,
    backgroundPosition: [-4, -4],
  },
  '🎦': {
    emoji: '🎦',
    backgroundImage: background69,
    backgroundPosition: [-2, 0],
  },
  '📶': {
    emoji: '📶',
    backgroundImage: background104,
    backgroundPosition: [-4, 0],
  },
  '🈁': {
    emoji: '🈁',
    backgroundImage: background110,
    backgroundPosition: [-3, -4],
  },
  '🔣': {
    emoji: '🔣',
    backgroundImage: background106,
    backgroundPosition: [-3, -4],
  },
  ℹ️: {
    emoji: 'ℹ️',
    backgroundImage: background109,
    backgroundPosition: [-2, -3],
  },
  '🔤': {
    emoji: '🔤',
    backgroundImage: background106,
    backgroundPosition: [-4, -4],
  },
  '🔡': {
    emoji: '🔡',
    backgroundImage: background106,
    backgroundPosition: [-1, -4],
  },
  '🔠': {
    emoji: '🔠',
    backgroundImage: background106,
    backgroundPosition: [0, -4],
  },
  '🆖': {
    emoji: '🆖',
    backgroundImage: background108,
    backgroundPosition: [0, -2],
  },
  '🆗': {
    emoji: '🆗',
    backgroundImage: background108,
    backgroundPosition: [-1, -2],
  },
  '🆙': {
    emoji: '🆙',
    backgroundImage: background108,
    backgroundPosition: [-3, -2],
  },
  '🆒': {
    emoji: '🆒',
    backgroundImage: background108,
    backgroundPosition: [-1, -1],
  },
  '🆕': {
    emoji: '🆕',
    backgroundImage: background108,
    backgroundPosition: [-4, -1],
  },
  '🆓': {
    emoji: '🆓',
    backgroundImage: background108,
    backgroundPosition: [-2, -1],
  },
  '0️⃣': {
    emoji: '0️⃣',
    backgroundImage: background109,
    backgroundPosition: [-2, 0],
  },
  '1️⃣': {
    emoji: '1️⃣',
    backgroundImage: background109,
    backgroundPosition: [-3, 0],
  },
  '2️⃣': {
    emoji: '2️⃣',
    backgroundImage: background109,
    backgroundPosition: [-4, 0],
  },
  '3️⃣': {
    emoji: '3️⃣',
    backgroundImage: background109,
    backgroundPosition: [0, -1],
  },
  '4️⃣': {
    emoji: '4️⃣',
    backgroundImage: background109,
    backgroundPosition: [-1, -1],
  },
  '5️⃣': {
    emoji: '5️⃣',
    backgroundImage: background109,
    backgroundPosition: [-2, -1],
  },
  '6️⃣': {
    emoji: '6️⃣',
    backgroundImage: background109,
    backgroundPosition: [-3, -1],
  },
  '7️⃣': {
    emoji: '7️⃣',
    backgroundImage: background109,
    backgroundPosition: [-4, -1],
  },
  '8️⃣': {
    emoji: '8️⃣',
    backgroundImage: background109,
    backgroundPosition: [0, -2],
  },
  '9️⃣': {
    emoji: '9️⃣',
    backgroundImage: background109,
    backgroundPosition: [-1, -2],
  },
  '🔟': {
    emoji: '🔟',
    backgroundImage: background106,
    backgroundPosition: [-4, -3],
  },
  '🔢': {
    emoji: '🔢',
    backgroundImage: background106,
    backgroundPosition: [-2, -4],
  },
  '#️⃣': {
    emoji: '#️⃣',
    backgroundImage: background109,
    backgroundPosition: [0, 0],
  },
  '*️⃣': {
    emoji: '*️⃣',
    backgroundImage: background109,
    backgroundPosition: [-1, 0],
  },
  '⏏️': {
    emoji: '⏏️',
    backgroundImage: background102,
    backgroundPosition: [-4, 0],
  },
  '▶️': {
    emoji: '▶️',
    backgroundImage: background102,
    backgroundPosition: [-2, -4],
  },
  '⏸️': {
    emoji: '⏸️',
    backgroundImage: background102,
    backgroundPosition: [-1, -3],
  },
  '⏯️': {
    emoji: '⏯️',
    backgroundImage: background102,
    backgroundPosition: [-1, -2],
  },
  '⏹️': {
    emoji: '⏹️',
    backgroundImage: background102,
    backgroundPosition: [-2, -3],
  },
  '⏺️': {
    emoji: '⏺️',
    backgroundImage: background102,
    backgroundPosition: [-3, -3],
  },
  '⏭️': {
    emoji: '⏭️',
    backgroundImage: background102,
    backgroundPosition: [-4, -1],
  },
  '⏮️': {
    emoji: '⏮️',
    backgroundImage: background102,
    backgroundPosition: [0, -2],
  },
  '⏩': {
    emoji: '⏩',
    backgroundImage: background102,
    backgroundPosition: [0, -1],
  },
  '⏪': {
    emoji: '⏪',
    backgroundImage: background102,
    backgroundPosition: [-1, -1],
  },
  '⏫': {
    emoji: '⏫',
    backgroundImage: background102,
    backgroundPosition: [-2, -1],
  },
  '⏬': {
    emoji: '⏬',
    backgroundImage: background102,
    backgroundPosition: [-3, -1],
  },
  '◀️': {
    emoji: '◀️',
    backgroundImage: background102,
    backgroundPosition: [-3, -4],
  },
  '🔼': {
    emoji: '🔼',
    backgroundImage: background84,
    backgroundPosition: [-3, -4],
  },
  '🔽': {
    emoji: '🔽',
    backgroundImage: background84,
    backgroundPosition: [-4, -4],
  },
  '➡️': {
    emoji: '➡️',
    backgroundImage: background83,
    backgroundPosition: [-2, -1],
  },
  '⬅️': {
    emoji: '⬅️',
    backgroundImage: background83,
    backgroundPosition: [-2, -2],
  },
  '⬆️': {
    emoji: '⬆️',
    backgroundImage: background83,
    backgroundPosition: [-3, -2],
  },
  '⬇️': {
    emoji: '⬇️',
    backgroundImage: background83,
    backgroundPosition: [-4, -2],
  },
  '↗️': {
    emoji: '↗️',
    backgroundImage: background109,
    backgroundPosition: [-1, -4],
  },
  '↘️': {
    emoji: '↘️',
    backgroundImage: background109,
    backgroundPosition: [-2, -4],
  },
  '↙️': {
    emoji: '↙️',
    backgroundImage: background109,
    backgroundPosition: [-3, -4],
  },
  '↖️': {
    emoji: '↖️',
    backgroundImage: background109,
    backgroundPosition: [0, -4],
  },
  '↕️': {
    emoji: '↕️',
    backgroundImage: background109,
    backgroundPosition: [-4, -3],
  },
  '↔️': {
    emoji: '↔️',
    backgroundImage: background109,
    backgroundPosition: [-3, -3],
  },
  '↪️': {
    emoji: '↪️',
    backgroundImage: background102,
    backgroundPosition: [0, 0],
  },
  '↩️': {
    emoji: '↩️',
    backgroundImage: background109,
    backgroundPosition: [-4, -4],
  },
  '⤴️': {
    emoji: '⤴️',
    backgroundImage: background83,
    backgroundPosition: [0, -2],
  },
  '⤵️': {
    emoji: '⤵️',
    backgroundImage: background83,
    backgroundPosition: [-1, -2],
  },
  '🔀': {
    emoji: '🔀',
    backgroundImage: background104,
    backgroundPosition: [-3, -2],
  },
  '🔁': {
    emoji: '🔁',
    backgroundImage: background104,
    backgroundPosition: [-4, -2],
  },
  '🔂': {
    emoji: '🔂',
    backgroundImage: background104,
    backgroundPosition: [0, -3],
  },
  '🔄': {
    emoji: '🔄',
    backgroundImage: background104,
    backgroundPosition: [-2, -3],
  },
  '🔃': {
    emoji: '🔃',
    backgroundImage: background104,
    backgroundPosition: [-1, -3],
  },
  '🎵': {
    emoji: '🎵',
    backgroundImage: background69,
    backgroundPosition: [-2, -3],
  },
  '🎶': {
    emoji: '🎶',
    backgroundImage: background69,
    backgroundPosition: [-3, -3],
  },
  '➕': {
    emoji: '➕',
    backgroundImage: background83,
    backgroundPosition: [-4, 0],
  },
  '➖': {
    emoji: '➖',
    backgroundImage: background83,
    backgroundPosition: [0, -1],
  },
  '➗': {
    emoji: '➗',
    backgroundImage: background83,
    backgroundPosition: [-1, -1],
  },
  '✖️': {
    emoji: '✖️',
    backgroundImage: background23,
    backgroundPosition: [-1, -2],
  },
  '🟰': {
    emoji: '🟰',
    backgroundImage: background8,
    backgroundPosition: [0, -1],
  },
  '♾️': {
    emoji: '♾️',
    backgroundImage: background3,
    backgroundPosition: [-3, -4],
  },
  '💲': {
    emoji: '💲',
    backgroundImage: background72,
    backgroundPosition: [-1, -2],
  },
  '💱': {
    emoji: '💱',
    backgroundImage: background72,
    backgroundPosition: [0, -2],
  },
  '™️': {
    emoji: '™️',
    backgroundImage: background109,
    backgroundPosition: [-1, -3],
  },
  '©️': {
    emoji: '©️',
    backgroundImage: background109,
    backgroundPosition: [-2, -2],
  },
  '®️': {
    emoji: '®️',
    backgroundImage: background109,
    backgroundPosition: [-3, -2],
  },
  '👁️‍🗨️': {
    emoji: '👁️‍🗨️',
    backgroundImage: background24,
    backgroundPosition: [-4, -1],
  },
  '🔚': {
    emoji: '🔚',
    backgroundImage: background106,
    backgroundPosition: [-4, -2],
  },
  '🔙': {
    emoji: '🔙',
    backgroundImage: background106,
    backgroundPosition: [-3, -2],
  },
  '🔛': {
    emoji: '🔛',
    backgroundImage: background106,
    backgroundPosition: [0, -3],
  },
  '🔝': {
    emoji: '🔝',
    backgroundImage: background106,
    backgroundPosition: [-2, -3],
  },
  '🔜': {
    emoji: '🔜',
    backgroundImage: background106,
    backgroundPosition: [-1, -3],
  },
  '〰️': {
    emoji: '〰️',
    backgroundImage: background83,
    backgroundPosition: [-4, -3],
  },
  '➰': {
    emoji: '➰',
    backgroundImage: background83,
    backgroundPosition: [-3, -1],
  },
  '➿': {
    emoji: '➿',
    backgroundImage: background83,
    backgroundPosition: [-4, -1],
  },
  '✔️': {
    emoji: '✔️',
    backgroundImage: background23,
    backgroundPosition: [0, -2],
  },
  '☑️': {
    emoji: '☑️',
    backgroundImage: background14,
    backgroundPosition: [-4, -1],
  },
  '🔘': {
    emoji: '🔘',
    backgroundImage: background106,
    backgroundPosition: [-2, -2],
  },
  '🔴': {
    emoji: '🔴',
    backgroundImage: background84,
    backgroundPosition: [0, -3],
  },
  '🟠': {
    emoji: '🟠',
    backgroundImage: background91,
    backgroundPosition: [-3, -3],
  },
  '🟡': {
    emoji: '🟡',
    backgroundImage: background91,
    backgroundPosition: [-4, -3],
  },
  '🟢': {
    emoji: '🟢',
    backgroundImage: background91,
    backgroundPosition: [0, -4],
  },
  '🔵': {
    emoji: '🔵',
    backgroundImage: background84,
    backgroundPosition: [-1, -3],
  },
  '🟣': {
    emoji: '🟣',
    backgroundImage: background91,
    backgroundPosition: [-1, -4],
  },
  '⚫': {
    emoji: '⚫',
    backgroundImage: background71,
    backgroundPosition: [-2, -2],
  },
  '⚪': {
    emoji: '⚪',
    backgroundImage: background71,
    backgroundPosition: [-1, -2],
  },
  '🟤': {
    emoji: '🟤',
    backgroundImage: background91,
    backgroundPosition: [-2, -4],
  },
  '🔺': {
    emoji: '🔺',
    backgroundImage: background84,
    backgroundPosition: [-1, -4],
  },
  '🔻': {
    emoji: '🔻',
    backgroundImage: background84,
    backgroundPosition: [-2, -4],
  },
  '🔸': {
    emoji: '🔸',
    backgroundImage: background84,
    backgroundPosition: [-4, -3],
  },
  '🔹': {
    emoji: '🔹',
    backgroundImage: background84,
    backgroundPosition: [0, -4],
  },
  '🔶': {
    emoji: '🔶',
    backgroundImage: background84,
    backgroundPosition: [-2, -3],
  },
  '🔷': {
    emoji: '🔷',
    backgroundImage: background84,
    backgroundPosition: [-3, -3],
  },
  '🔳': {
    emoji: '🔳',
    backgroundImage: background84,
    backgroundPosition: [-4, -2],
  },
  '🔲': {
    emoji: '🔲',
    backgroundImage: background84,
    backgroundPosition: [-3, -2],
  },
  '▪️': {
    emoji: '▪️',
    backgroundImage: background102,
    backgroundPosition: [0, -4],
  },
  '▫️': {
    emoji: '▫️',
    backgroundImage: background102,
    backgroundPosition: [-1, -4],
  },
  '◾': {
    emoji: '◾',
    backgroundImage: background14,
    backgroundPosition: [-2, 0],
  },
  '◽': {
    emoji: '◽',
    backgroundImage: background14,
    backgroundPosition: [-1, 0],
  },
  '◼️': {
    emoji: '◼️',
    backgroundImage: background14,
    backgroundPosition: [0, 0],
  },
  '◻️': {
    emoji: '◻️',
    backgroundImage: background102,
    backgroundPosition: [-4, -4],
  },
  '🟥': {
    emoji: '🟥',
    backgroundImage: background91,
    backgroundPosition: [-3, -4],
  },
  '🟧': {
    emoji: '🟧',
    backgroundImage: background8,
    backgroundPosition: [0, 0],
  },
  '🟨': {
    emoji: '🟨',
    backgroundImage: background8,
    backgroundPosition: [-1, 0],
  },
  '🟩': {
    emoji: '🟩',
    backgroundImage: background8,
    backgroundPosition: [-2, 0],
  },
  '🟦': {
    emoji: '🟦',
    backgroundImage: background91,
    backgroundPosition: [-4, -4],
  },
  '🟪': {
    emoji: '🟪',
    backgroundImage: background8,
    backgroundPosition: [-3, 0],
  },
  '⬛': {
    emoji: '⬛',
    backgroundImage: background83,
    backgroundPosition: [0, -3],
  },
  '⬜': {
    emoji: '⬜',
    backgroundImage: background83,
    backgroundPosition: [-1, -3],
  },
  '🟫': {
    emoji: '🟫',
    backgroundImage: background8,
    backgroundPosition: [-4, 0],
  },
  '🔈': {
    emoji: '🔈',
    backgroundImage: background104,
    backgroundPosition: [-1, -4],
  },
  '🔇': {
    emoji: '🔇',
    backgroundImage: background104,
    backgroundPosition: [0, -4],
  },
  '🔉': {
    emoji: '🔉',
    backgroundImage: background104,
    backgroundPosition: [-2, -4],
  },
  '🔊': {
    emoji: '🔊',
    backgroundImage: background104,
    backgroundPosition: [-3, -4],
  },
  '🔔': {
    emoji: '🔔',
    backgroundImage: background106,
    backgroundPosition: [-3, -1],
  },
  '🔕': {
    emoji: '🔕',
    backgroundImage: background106,
    backgroundPosition: [-4, -1],
  },
  '📣': {
    emoji: '📣',
    backgroundImage: background103,
    backgroundPosition: [0, -2],
  },
  '📢': {
    emoji: '📢',
    backgroundImage: background103,
    backgroundPosition: [-4, -1],
  },
  '💬': {
    emoji: '💬',
    backgroundImage: background72,
    backgroundPosition: [0, -1],
  },
  '💭': {
    emoji: '💭',
    backgroundImage: background72,
    backgroundPosition: [-1, -1],
  },
  '🗯️': {
    emoji: '🗯️',
    backgroundImage: background0,
    backgroundPosition: [-3, -1],
  },
  '♠️': {
    emoji: '♠️',
    backgroundImage: background3,
    backgroundPosition: [-2, -3],
  },
  '♣️': {
    emoji: '♣️',
    backgroundImage: background3,
    backgroundPosition: [-3, -3],
  },
  '♥️': {
    emoji: '♥️',
    backgroundImage: background3,
    backgroundPosition: [-4, -3],
  },
  '♦️': {
    emoji: '♦️',
    backgroundImage: background3,
    backgroundPosition: [0, -4],
  },
  '🃏': {
    emoji: '🃏',
    backgroundImage: background83,
    backgroundPosition: [-4, -4],
  },
  '🎴': {
    emoji: '🎴',
    backgroundImage: background69,
    backgroundPosition: [-1, -3],
  },
  '🀄': {
    emoji: '🀄',
    backgroundImage: background83,
    backgroundPosition: [-3, -4],
  },
  '🕐': {
    emoji: '🕐',
    backgroundImage: background78,
    backgroundPosition: [-1, -1],
  },
  '🕑': {
    emoji: '🕑',
    backgroundImage: background78,
    backgroundPosition: [-2, -1],
  },
  '🕒': {
    emoji: '🕒',
    backgroundImage: background78,
    backgroundPosition: [-3, -1],
  },
  '🕓': {
    emoji: '🕓',
    backgroundImage: background78,
    backgroundPosition: [-4, -1],
  },
  '🕔': {
    emoji: '🕔',
    backgroundImage: background78,
    backgroundPosition: [0, -2],
  },
  '🕕': {
    emoji: '🕕',
    backgroundImage: background78,
    backgroundPosition: [-1, -2],
  },
  '🕖': {
    emoji: '🕖',
    backgroundImage: background78,
    backgroundPosition: [-2, -2],
  },
  '🕗': {
    emoji: '🕗',
    backgroundImage: background78,
    backgroundPosition: [-3, -2],
  },
  '🕘': {
    emoji: '🕘',
    backgroundImage: background78,
    backgroundPosition: [-4, -2],
  },
  '🕙': {
    emoji: '🕙',
    backgroundImage: background78,
    backgroundPosition: [0, -3],
  },
  '🕚': {
    emoji: '🕚',
    backgroundImage: background78,
    backgroundPosition: [-1, -3],
  },
  '🕛': {
    emoji: '🕛',
    backgroundImage: background78,
    backgroundPosition: [-2, -3],
  },
  '🕜': {
    emoji: '🕜',
    backgroundImage: background78,
    backgroundPosition: [-3, -3],
  },
  '🕝': {
    emoji: '🕝',
    backgroundImage: background78,
    backgroundPosition: [-4, -3],
  },
  '🕞': {
    emoji: '🕞',
    backgroundImage: background78,
    backgroundPosition: [0, -4],
  },
  '🕟': {
    emoji: '🕟',
    backgroundImage: background78,
    backgroundPosition: [-1, -4],
  },
  '🕠': {
    emoji: '🕠',
    backgroundImage: background78,
    backgroundPosition: [-2, -4],
  },
  '🕡': {
    emoji: '🕡',
    backgroundImage: background78,
    backgroundPosition: [-3, -4],
  },
  '🕢': {
    emoji: '🕢',
    backgroundImage: background78,
    backgroundPosition: [-4, -4],
  },
  '🕣': {
    emoji: '🕣',
    backgroundImage: background61,
    backgroundPosition: [0, 0],
  },
  '🕤': {
    emoji: '🕤',
    backgroundImage: background61,
    backgroundPosition: [-1, 0],
  },
  '🕥': {
    emoji: '🕥',
    backgroundImage: background61,
    backgroundPosition: [-2, 0],
  },
  '🕦': {
    emoji: '🕦',
    backgroundImage: background61,
    backgroundPosition: [-3, 0],
  },
  '🕧': {
    emoji: '🕧',
    backgroundImage: background61,
    backgroundPosition: [-4, 0],
  },
  '🏳️': {
    emoji: '🏳️',
    backgroundImage: background101,
    backgroundPosition: [-2, -4],
  },
  '🏴': {
    emoji: '🏴',
    backgroundImage: background77,
    backgroundPosition: [0, 0],
  },
  '🏴‍☠️': {
    emoji: '🏴‍☠️',
    backgroundImage: background77,
    backgroundPosition: [-1, 0],
  },
  '🏁': {
    emoji: '🏁',
    backgroundImage: background63,
    backgroundPosition: [-4, 0],
  },
  '🚩': {
    emoji: '🚩',
    backgroundImage: background100,
    backgroundPosition: [-4, -3],
  },
  '🏳️‍🌈': {
    emoji: '🏳️‍🌈',
    backgroundImage: background101,
    backgroundPosition: [-4, -4],
  },
  '🏳️‍⚧️': {
    emoji: '🏳️‍⚧️',
    backgroundImage: background101,
    backgroundPosition: [-3, -4],
  },
  '🇺🇳': {
    emoji: '🇺🇳',
    backgroundImage: background110,
    backgroundPosition: [-4, 0],
  },
  '🇦🇫': {
    emoji: '🇦🇫',
    backgroundImage: background108,
    backgroundPosition: [-3, -3],
  },
  '🇦🇽': {
    emoji: '🇦🇽',
    backgroundImage: background111,
    backgroundPosition: [0, -1],
  },
  '🇦🇱': {
    emoji: '🇦🇱',
    backgroundImage: background108,
    backgroundPosition: [-1, -4],
  },
  '🇩🇿': {
    emoji: '🇩🇿',
    backgroundImage: background112,
    backgroundPosition: [-4, 0],
  },
  '🇦🇸': {
    emoji: '🇦🇸',
    backgroundImage: background111,
    backgroundPosition: [-1, 0],
  },
  '🇦🇩': {
    emoji: '🇦🇩',
    backgroundImage: background108,
    backgroundPosition: [-1, -3],
  },
  '🇦🇴': {
    emoji: '🇦🇴',
    backgroundImage: background108,
    backgroundPosition: [-3, -4],
  },
  '🇦🇮': {
    emoji: '🇦🇮',
    backgroundImage: background108,
    backgroundPosition: [0, -4],
  },
  '🇦🇶': {
    emoji: '🇦🇶',
    backgroundImage: background108,
    backgroundPosition: [-4, -4],
  },
  '🇦🇬': {
    emoji: '🇦🇬',
    backgroundImage: background108,
    backgroundPosition: [-4, -3],
  },
  '🇦🇷': {
    emoji: '🇦🇷',
    backgroundImage: background111,
    backgroundPosition: [0, 0],
  },
  '🇦🇲': {
    emoji: '🇦🇲',
    backgroundImage: background108,
    backgroundPosition: [-2, -4],
  },
  '🇦🇼': {
    emoji: '🇦🇼',
    backgroundImage: background111,
    backgroundPosition: [-4, 0],
  },
  '🇦🇺': {
    emoji: '🇦🇺',
    backgroundImage: background111,
    backgroundPosition: [-3, 0],
  },
  '🇦🇹': {
    emoji: '🇦🇹',
    backgroundImage: background111,
    backgroundPosition: [-2, 0],
  },
  '🇦🇿': {
    emoji: '🇦🇿',
    backgroundImage: background111,
    backgroundPosition: [-1, -1],
  },
  '🇧🇸': {
    emoji: '🇧🇸',
    backgroundImage: background111,
    backgroundPosition: [-2, -4],
  },
  '🇧🇭': {
    emoji: '🇧🇭',
    backgroundImage: background111,
    backgroundPosition: [-3, -2],
  },
  '🇧🇩': {
    emoji: '🇧🇩',
    backgroundImage: background111,
    backgroundPosition: [-4, -1],
  },
  '🇧🇧': {
    emoji: '🇧🇧',
    backgroundImage: background111,
    backgroundPosition: [-3, -1],
  },
  '🇧🇾': {
    emoji: '🇧🇾',
    backgroundImage: background113,
    backgroundPosition: [-1, 0],
  },
  '🇧🇪': {
    emoji: '🇧🇪',
    backgroundImage: background111,
    backgroundPosition: [0, -2],
  },
  '🇧🇿': {
    emoji: '🇧🇿',
    backgroundImage: background113,
    backgroundPosition: [-2, 0],
  },
  '🇧🇯': {
    emoji: '🇧🇯',
    backgroundImage: background111,
    backgroundPosition: [0, -3],
  },
  '🇧🇲': {
    emoji: '🇧🇲',
    backgroundImage: background111,
    backgroundPosition: [-2, -3],
  },
  '🇧🇹': {
    emoji: '🇧🇹',
    backgroundImage: background111,
    backgroundPosition: [-3, -4],
  },
  '🇧🇴': {
    emoji: '🇧🇴',
    backgroundImage: background111,
    backgroundPosition: [-4, -3],
  },
  '🇧🇦': {
    emoji: '🇧🇦',
    backgroundImage: background111,
    backgroundPosition: [-2, -1],
  },
  '🇧🇼': {
    emoji: '🇧🇼',
    backgroundImage: background113,
    backgroundPosition: [0, 0],
  },
  '🇧🇷': {
    emoji: '🇧🇷',
    backgroundImage: background111,
    backgroundPosition: [-1, -4],
  },
  '🇻🇬': {
    emoji: '🇻🇬',
    backgroundImage: background110,
    backgroundPosition: [-1, -2],
  },
  '🇧🇳': {
    emoji: '🇧🇳',
    backgroundImage: background111,
    backgroundPosition: [-3, -3],
  },
  '🇧🇬': {
    emoji: '🇧🇬',
    backgroundImage: background111,
    backgroundPosition: [-2, -2],
  },
  '🇧🇫': {
    emoji: '🇧🇫',
    backgroundImage: background111,
    backgroundPosition: [-1, -2],
  },
  '🇧🇮': {
    emoji: '🇧🇮',
    backgroundImage: background111,
    backgroundPosition: [-4, -2],
  },
  '🇰🇭': {
    emoji: '🇰🇭',
    backgroundImage: background114,
    backgroundPosition: [-2, -2],
  },
  '🇨🇲': {
    emoji: '🇨🇲',
    backgroundImage: background113,
    backgroundPosition: [-2, -2],
  },
  '🇨🇦': {
    emoji: '🇨🇦',
    backgroundImage: background113,
    backgroundPosition: [-3, 0],
  },
  '🇮🇨': {
    emoji: '🇮🇨',
    backgroundImage: background115,
    backgroundPosition: [0, -4],
  },
  '🇨🇻': {
    emoji: '🇨🇻',
    backgroundImage: background113,
    backgroundPosition: [-3, -3],
  },
  '🇧🇶': {
    emoji: '🇧🇶',
    backgroundImage: background111,
    backgroundPosition: [0, -4],
  },
  '🇰🇾': {
    emoji: '🇰🇾',
    backgroundImage: background114,
    backgroundPosition: [-4, -3],
  },
  '🇨🇫': {
    emoji: '🇨🇫',
    backgroundImage: background113,
    backgroundPosition: [-1, -1],
  },
  '🇹🇩': {
    emoji: '🇹🇩',
    backgroundImage: background116,
    backgroundPosition: [-1, -2],
  },
  '🇮🇴': {
    emoji: '🇮🇴',
    backgroundImage: background114,
    backgroundPosition: [-1, 0],
  },
  '🇨🇱': {
    emoji: '🇨🇱',
    backgroundImage: background113,
    backgroundPosition: [-1, -2],
  },
  '🇨🇳': {
    emoji: '🇨🇳',
    backgroundImage: background113,
    backgroundPosition: [-3, -2],
  },
  '🇨🇽': {
    emoji: '🇨🇽',
    backgroundImage: background113,
    backgroundPosition: [0, -4],
  },
  '🇨🇨': {
    emoji: '🇨🇨',
    backgroundImage: background113,
    backgroundPosition: [-4, 0],
  },
  '🇨🇴': {
    emoji: '🇨🇴',
    backgroundImage: background113,
    backgroundPosition: [-4, -2],
  },
  '🇰🇲': {
    emoji: '🇰🇲',
    backgroundImage: background114,
    backgroundPosition: [-4, -2],
  },
  '🇨🇬': {
    emoji: '🇨🇬',
    backgroundImage: background113,
    backgroundPosition: [-2, -1],
  },
  '🇨🇩': {
    emoji: '🇨🇩',
    backgroundImage: background113,
    backgroundPosition: [0, -1],
  },
  '🇨🇰': {
    emoji: '🇨🇰',
    backgroundImage: background113,
    backgroundPosition: [0, -2],
  },
  '🇨🇷': {
    emoji: '🇨🇷',
    backgroundImage: background113,
    backgroundPosition: [-1, -3],
  },
  '🇨🇮': {
    emoji: '🇨🇮',
    backgroundImage: background113,
    backgroundPosition: [-4, -1],
  },
  '🇭🇷': {
    emoji: '🇭🇷',
    backgroundImage: background115,
    backgroundPosition: [-2, -3],
  },
  '🇨🇺': {
    emoji: '🇨🇺',
    backgroundImage: background113,
    backgroundPosition: [-2, -3],
  },
  '🇨🇼': {
    emoji: '🇨🇼',
    backgroundImage: background113,
    backgroundPosition: [-4, -3],
  },
  '🇨🇾': {
    emoji: '🇨🇾',
    backgroundImage: background113,
    backgroundPosition: [-1, -4],
  },
  '🇨🇿': {
    emoji: '🇨🇿',
    backgroundImage: background113,
    backgroundPosition: [-2, -4],
  },
  '🇩🇰': {
    emoji: '🇩🇰',
    backgroundImage: background112,
    backgroundPosition: [-1, 0],
  },
  '🇩🇯': {
    emoji: '🇩🇯',
    backgroundImage: background112,
    backgroundPosition: [0, 0],
  },
  '🇩🇲': {
    emoji: '🇩🇲',
    backgroundImage: background112,
    backgroundPosition: [-2, 0],
  },
  '🇩🇴': {
    emoji: '🇩🇴',
    backgroundImage: background112,
    backgroundPosition: [-3, 0],
  },
  '🇪🇨': {
    emoji: '🇪🇨',
    backgroundImage: background112,
    backgroundPosition: [-1, -1],
  },
  '🇪🇬': {
    emoji: '🇪🇬',
    backgroundImage: background112,
    backgroundPosition: [-3, -1],
  },
  '🇸🇻': {
    emoji: '🇸🇻',
    backgroundImage: background116,
    backgroundPosition: [0, -1],
  },
  '🇬🇶': {
    emoji: '🇬🇶',
    backgroundImage: background115,
    backgroundPosition: [-2, -1],
  },
  '🇪🇷': {
    emoji: '🇪🇷',
    backgroundImage: background112,
    backgroundPosition: [0, -2],
  },
  '🇪🇪': {
    emoji: '🇪🇪',
    backgroundImage: background112,
    backgroundPosition: [-2, -1],
  },
  '🇸🇿': {
    emoji: '🇸🇿',
    backgroundImage: background116,
    backgroundPosition: [-3, -1],
  },
  '🇪🇹': {
    emoji: '🇪🇹',
    backgroundImage: background112,
    backgroundPosition: [-2, -2],
  },
  '🇪🇺': {
    emoji: '🇪🇺',
    backgroundImage: background112,
    backgroundPosition: [-3, -2],
  },
  '🇫🇰': {
    emoji: '🇫🇰',
    backgroundImage: background112,
    backgroundPosition: [-1, -3],
  },
  '🇫🇴': {
    emoji: '🇫🇴',
    backgroundImage: background112,
    backgroundPosition: [-3, -3],
  },
  '🇫🇯': {
    emoji: '🇫🇯',
    backgroundImage: background112,
    backgroundPosition: [0, -3],
  },
  '🇫🇮': {
    emoji: '🇫🇮',
    backgroundImage: background112,
    backgroundPosition: [-4, -2],
  },
  '🇫🇷': {
    emoji: '🇫🇷',
    backgroundImage: background112,
    backgroundPosition: [-4, -3],
  },
  '🇬🇫': {
    emoji: '🇬🇫',
    backgroundImage: background112,
    backgroundPosition: [-4, -4],
  },
  '🇵🇫': {
    emoji: '🇵🇫',
    backgroundImage: background117,
    backgroundPosition: [0, -4],
  },
  '🇹🇫': {
    emoji: '🇹🇫',
    backgroundImage: background116,
    backgroundPosition: [-2, -2],
  },
  '🇬🇦': {
    emoji: '🇬🇦',
    backgroundImage: background112,
    backgroundPosition: [0, -4],
  },
  '🇬🇲': {
    emoji: '🇬🇲',
    backgroundImage: background115,
    backgroundPosition: [-4, 0],
  },
  '🇬🇪': {
    emoji: '🇬🇪',
    backgroundImage: background112,
    backgroundPosition: [-3, -4],
  },
  '🇩🇪': {
    emoji: '🇩🇪',
    backgroundImage: background113,
    backgroundPosition: [-3, -4],
  },
  '🇬🇭': {
    emoji: '🇬🇭',
    backgroundImage: background115,
    backgroundPosition: [-1, 0],
  },
  '🇬🇮': {
    emoji: '🇬🇮',
    backgroundImage: background115,
    backgroundPosition: [-2, 0],
  },
  '🇬🇷': {
    emoji: '🇬🇷',
    backgroundImage: background115,
    backgroundPosition: [-3, -1],
  },
  '🇬🇱': {
    emoji: '🇬🇱',
    backgroundImage: background115,
    backgroundPosition: [-3, 0],
  },
  '🇬🇩': {
    emoji: '🇬🇩',
    backgroundImage: background112,
    backgroundPosition: [-2, -4],
  },
  '🇬🇵': {
    emoji: '🇬🇵',
    backgroundImage: background115,
    backgroundPosition: [-1, -1],
  },
  '🇬🇺': {
    emoji: '🇬🇺',
    backgroundImage: background115,
    backgroundPosition: [-1, -2],
  },
  '🇬🇹': {
    emoji: '🇬🇹',
    backgroundImage: background115,
    backgroundPosition: [0, -2],
  },
  '🇬🇬': {
    emoji: '🇬🇬',
    backgroundImage: background115,
    backgroundPosition: [0, 0],
  },
  '🇬🇳': {
    emoji: '🇬🇳',
    backgroundImage: background115,
    backgroundPosition: [0, -1],
  },
  '🇬🇼': {
    emoji: '🇬🇼',
    backgroundImage: background115,
    backgroundPosition: [-2, -2],
  },
  '🇬🇾': {
    emoji: '🇬🇾',
    backgroundImage: background115,
    backgroundPosition: [-3, -2],
  },
  '🇭🇹': {
    emoji: '🇭🇹',
    backgroundImage: background115,
    backgroundPosition: [-3, -3],
  },
  '🇭🇳': {
    emoji: '🇭🇳',
    backgroundImage: background115,
    backgroundPosition: [-1, -3],
  },
  '🇭🇰': {
    emoji: '🇭🇰',
    backgroundImage: background115,
    backgroundPosition: [-4, -2],
  },
  '🇭🇺': {
    emoji: '🇭🇺',
    backgroundImage: background115,
    backgroundPosition: [-4, -3],
  },
  '🇮🇸': {
    emoji: '🇮🇸',
    backgroundImage: background114,
    backgroundPosition: [-4, 0],
  },
  '🇮🇳': {
    emoji: '🇮🇳',
    backgroundImage: background114,
    backgroundPosition: [0, 0],
  },
  '🇮🇩': {
    emoji: '🇮🇩',
    backgroundImage: background115,
    backgroundPosition: [-1, -4],
  },
  '🇮🇷': {
    emoji: '🇮🇷',
    backgroundImage: background114,
    backgroundPosition: [-3, 0],
  },
  '🇮🇶': {
    emoji: '🇮🇶',
    backgroundImage: background114,
    backgroundPosition: [-2, 0],
  },
  '🇮🇪': {
    emoji: '🇮🇪',
    backgroundImage: background115,
    backgroundPosition: [-2, -4],
  },
  '🇮🇲': {
    emoji: '🇮🇲',
    backgroundImage: background115,
    backgroundPosition: [-4, -4],
  },
  '🇮🇱': {
    emoji: '🇮🇱',
    backgroundImage: background115,
    backgroundPosition: [-3, -4],
  },
  '🇮🇹': {
    emoji: '🇮🇹',
    backgroundImage: background114,
    backgroundPosition: [0, -1],
  },
  '🇯🇲': {
    emoji: '🇯🇲',
    backgroundImage: background114,
    backgroundPosition: [-2, -1],
  },
  '🇯🇵': {
    emoji: '🇯🇵',
    backgroundImage: background114,
    backgroundPosition: [-4, -1],
  },
  '🎌': {
    emoji: '🎌',
    backgroundImage: background70,
    backgroundPosition: [-1, -1],
  },
  '🇯🇪': {
    emoji: '🇯🇪',
    backgroundImage: background114,
    backgroundPosition: [-1, -1],
  },
  '🇯🇴': {
    emoji: '🇯🇴',
    backgroundImage: background114,
    backgroundPosition: [-3, -1],
  },
  '🇰🇿': {
    emoji: '🇰🇿',
    backgroundImage: background114,
    backgroundPosition: [0, -4],
  },
  '🇰🇪': {
    emoji: '🇰🇪',
    backgroundImage: background114,
    backgroundPosition: [0, -2],
  },
  '🇰🇮': {
    emoji: '🇰🇮',
    backgroundImage: background114,
    backgroundPosition: [-3, -2],
  },
  '🇽🇰': {
    emoji: '🇽🇰',
    backgroundImage: background110,
    backgroundPosition: [-2, -3],
  },
  '🇰🇼': {
    emoji: '🇰🇼',
    backgroundImage: background114,
    backgroundPosition: [-3, -3],
  },
  '🇰🇬': {
    emoji: '🇰🇬',
    backgroundImage: background114,
    backgroundPosition: [-1, -2],
  },
  '🇱🇦': {
    emoji: '🇱🇦',
    backgroundImage: background114,
    backgroundPosition: [-1, -4],
  },
  '🇱🇻': {
    emoji: '🇱🇻',
    backgroundImage: background118,
    backgroundPosition: [0, -1],
  },
  '🇱🇧': {
    emoji: '🇱🇧',
    backgroundImage: background114,
    backgroundPosition: [-2, -4],
  },
  '🇱🇸': {
    emoji: '🇱🇸',
    backgroundImage: background118,
    backgroundPosition: [-2, 0],
  },
  '🇱🇷': {
    emoji: '🇱🇷',
    backgroundImage: background118,
    backgroundPosition: [-1, 0],
  },
  '🇱🇾': {
    emoji: '🇱🇾',
    backgroundImage: background118,
    backgroundPosition: [-1, -1],
  },
  '🇱🇮': {
    emoji: '🇱🇮',
    backgroundImage: background114,
    backgroundPosition: [-4, -4],
  },
  '🇱🇹': {
    emoji: '🇱🇹',
    backgroundImage: background118,
    backgroundPosition: [-3, 0],
  },
  '🇱🇺': {
    emoji: '🇱🇺',
    backgroundImage: background118,
    backgroundPosition: [-4, 0],
  },
  '🇲🇴': {
    emoji: '🇲🇴',
    backgroundImage: background118,
    backgroundPosition: [-3, -3],
  },
  '🇲🇬': {
    emoji: '🇲🇬',
    backgroundImage: background118,
    backgroundPosition: [-2, -2],
  },
  '🇲🇼': {
    emoji: '🇲🇼',
    backgroundImage: background117,
    backgroundPosition: [-1, 0],
  },
  '🇲🇾': {
    emoji: '🇲🇾',
    backgroundImage: background117,
    backgroundPosition: [-3, 0],
  },
  '🇲🇻': {
    emoji: '🇲🇻',
    backgroundImage: background117,
    backgroundPosition: [0, 0],
  },
  '🇲🇱': {
    emoji: '🇲🇱',
    backgroundImage: background118,
    backgroundPosition: [0, -3],
  },
  '🇲🇹': {
    emoji: '🇲🇹',
    backgroundImage: background118,
    backgroundPosition: [-3, -4],
  },
  '🇲🇭': {
    emoji: '🇲🇭',
    backgroundImage: background118,
    backgroundPosition: [-3, -2],
  },
  '🇲🇶': {
    emoji: '🇲🇶',
    backgroundImage: background118,
    backgroundPosition: [0, -4],
  },
  '🇲🇷': {
    emoji: '🇲🇷',
    backgroundImage: background118,
    backgroundPosition: [-1, -4],
  },
  '🇲🇺': {
    emoji: '🇲🇺',
    backgroundImage: background118,
    backgroundPosition: [-4, -4],
  },
  '🇾🇹': {
    emoji: '🇾🇹',
    backgroundImage: background110,
    backgroundPosition: [-4, -3],
  },
  '🇲🇽': {
    emoji: '🇲🇽',
    backgroundImage: background117,
    backgroundPosition: [-2, 0],
  },
  '🇫🇲': {
    emoji: '🇫🇲',
    backgroundImage: background112,
    backgroundPosition: [-2, -3],
  },
  '🇲🇩': {
    emoji: '🇲🇩',
    backgroundImage: background118,
    backgroundPosition: [-4, -1],
  },
  '🇲🇨': {
    emoji: '🇲🇨',
    backgroundImage: background118,
    backgroundPosition: [-3, -1],
  },
  '🇲🇳': {
    emoji: '🇲🇳',
    backgroundImage: background118,
    backgroundPosition: [-2, -3],
  },
  '🇲🇪': {
    emoji: '🇲🇪',
    backgroundImage: background118,
    backgroundPosition: [0, -2],
  },
  '🇲🇸': {
    emoji: '🇲🇸',
    backgroundImage: background118,
    backgroundPosition: [-2, -4],
  },
  '🇲🇦': {
    emoji: '🇲🇦',
    backgroundImage: background118,
    backgroundPosition: [-2, -1],
  },
  '🇲🇿': {
    emoji: '🇲🇿',
    backgroundImage: background117,
    backgroundPosition: [-4, 0],
  },
  '🇲🇲': {
    emoji: '🇲🇲',
    backgroundImage: background118,
    backgroundPosition: [-1, -3],
  },
  '🇳🇦': {
    emoji: '🇳🇦',
    backgroundImage: background117,
    backgroundPosition: [0, -1],
  },
  '🇳🇷': {
    emoji: '🇳🇷',
    backgroundImage: background117,
    backgroundPosition: [-4, -2],
  },
  '🇳🇵': {
    emoji: '🇳🇵',
    backgroundImage: background117,
    backgroundPosition: [-3, -2],
  },
  '🇳🇱': {
    emoji: '🇳🇱',
    backgroundImage: background117,
    backgroundPosition: [-1, -2],
  },
  '🇳🇨': {
    emoji: '🇳🇨',
    backgroundImage: background117,
    backgroundPosition: [-1, -1],
  },
  '🇳🇿': {
    emoji: '🇳🇿',
    backgroundImage: background117,
    backgroundPosition: [-1, -3],
  },
  '🇳🇮': {
    emoji: '🇳🇮',
    backgroundImage: background117,
    backgroundPosition: [0, -2],
  },
  '🇳🇪': {
    emoji: '🇳🇪',
    backgroundImage: background117,
    backgroundPosition: [-2, -1],
  },
  '🇳🇬': {
    emoji: '🇳🇬',
    backgroundImage: background117,
    backgroundPosition: [-4, -1],
  },
  '🇳🇺': {
    emoji: '🇳🇺',
    backgroundImage: background117,
    backgroundPosition: [0, -3],
  },
  '🇳🇫': {
    emoji: '🇳🇫',
    backgroundImage: background117,
    backgroundPosition: [-3, -1],
  },
  '🇰🇵': {
    emoji: '🇰🇵',
    backgroundImage: background114,
    backgroundPosition: [-1, -3],
  },
  '🇲🇰': {
    emoji: '🇲🇰',
    backgroundImage: background118,
    backgroundPosition: [-4, -2],
  },
  '🇲🇵': {
    emoji: '🇲🇵',
    backgroundImage: background118,
    backgroundPosition: [-4, -3],
  },
  '🇳🇴': {
    emoji: '🇳🇴',
    backgroundImage: background117,
    backgroundPosition: [-2, -2],
  },
  '🇴🇲': {
    emoji: '🇴🇲',
    backgroundImage: background117,
    backgroundPosition: [-2, -3],
  },
  '🇵🇰': {
    emoji: '🇵🇰',
    backgroundImage: background117,
    backgroundPosition: [-3, -4],
  },
  '🇵🇼': {
    emoji: '🇵🇼',
    backgroundImage: background119,
    backgroundPosition: [0, -1],
  },
  '🇵🇸': {
    emoji: '🇵🇸',
    backgroundImage: background119,
    backgroundPosition: [-3, 0],
  },
  '🇵🇦': {
    emoji: '🇵🇦',
    backgroundImage: background117,
    backgroundPosition: [-3, -3],
  },
  '🇵🇬': {
    emoji: '🇵🇬',
    backgroundImage: background117,
    backgroundPosition: [-1, -4],
  },
  '🇵🇾': {
    emoji: '🇵🇾',
    backgroundImage: background119,
    backgroundPosition: [-1, -1],
  },
  '🇵🇪': {
    emoji: '🇵🇪',
    backgroundImage: background117,
    backgroundPosition: [-4, -3],
  },
  '🇵🇭': {
    emoji: '🇵🇭',
    backgroundImage: background117,
    backgroundPosition: [-2, -4],
  },
  '🇵🇳': {
    emoji: '🇵🇳',
    backgroundImage: background119,
    backgroundPosition: [-1, 0],
  },
  '🇵🇱': {
    emoji: '🇵🇱',
    backgroundImage: background117,
    backgroundPosition: [-4, -4],
  },
  '🇵🇹': {
    emoji: '🇵🇹',
    backgroundImage: background119,
    backgroundPosition: [-4, 0],
  },
  '🇵🇷': {
    emoji: '🇵🇷',
    backgroundImage: background119,
    backgroundPosition: [-2, 0],
  },
  '🇶🇦': {
    emoji: '🇶🇦',
    backgroundImage: background119,
    backgroundPosition: [-2, -1],
  },
  '🇷🇪': {
    emoji: '🇷🇪',
    backgroundImage: background119,
    backgroundPosition: [-3, -1],
  },
  '🇷🇴': {
    emoji: '🇷🇴',
    backgroundImage: background119,
    backgroundPosition: [-4, -1],
  },
  '🇷🇺': {
    emoji: '🇷🇺',
    backgroundImage: background119,
    backgroundPosition: [-1, -2],
  },
  '🇷🇼': {
    emoji: '🇷🇼',
    backgroundImage: background119,
    backgroundPosition: [-2, -2],
  },
  '🇼🇸': {
    emoji: '🇼🇸',
    backgroundImage: background110,
    backgroundPosition: [-1, -3],
  },
  '🇸🇲': {
    emoji: '🇸🇲',
    backgroundImage: background119,
    backgroundPosition: [-4, -4],
  },
  '🇸🇹': {
    emoji: '🇸🇹',
    backgroundImage: background116,
    backgroundPosition: [-4, 0],
  },
  '🇸🇦': {
    emoji: '🇸🇦',
    backgroundImage: background119,
    backgroundPosition: [-3, -2],
  },
  '🇸🇳': {
    emoji: '🇸🇳',
    backgroundImage: background116,
    backgroundPosition: [0, 0],
  },
  '🇷🇸': {
    emoji: '🇷🇸',
    backgroundImage: background119,
    backgroundPosition: [0, -2],
  },
  '🇸🇨': {
    emoji: '🇸🇨',
    backgroundImage: background119,
    backgroundPosition: [0, -3],
  },
  '🇸🇱': {
    emoji: '🇸🇱',
    backgroundImage: background119,
    backgroundPosition: [-3, -4],
  },
  '🇸🇬': {
    emoji: '🇸🇬',
    backgroundImage: background119,
    backgroundPosition: [-3, -3],
  },
  '🇸🇽': {
    emoji: '🇸🇽',
    backgroundImage: background116,
    backgroundPosition: [-1, -1],
  },
  '🇸🇰': {
    emoji: '🇸🇰',
    backgroundImage: background119,
    backgroundPosition: [-2, -4],
  },
  '🇸🇮': {
    emoji: '🇸🇮',
    backgroundImage: background119,
    backgroundPosition: [0, -4],
  },
  '🇬🇸': {
    emoji: '🇬🇸',
    backgroundImage: background115,
    backgroundPosition: [-4, -1],
  },
  '🇸🇧': {
    emoji: '🇸🇧',
    backgroundImage: background119,
    backgroundPosition: [-4, -2],
  },
  '🇸🇴': {
    emoji: '🇸🇴',
    backgroundImage: background116,
    backgroundPosition: [-1, 0],
  },
  '🇿🇦': {
    emoji: '🇿🇦',
    backgroundImage: background110,
    backgroundPosition: [0, -4],
  },
  '🇰🇷': {
    emoji: '🇰🇷',
    backgroundImage: background114,
    backgroundPosition: [-2, -3],
  },
  '🇸🇸': {
    emoji: '🇸🇸',
    backgroundImage: background116,
    backgroundPosition: [-3, 0],
  },
  '🇪🇸': {
    emoji: '🇪🇸',
    backgroundImage: background112,
    backgroundPosition: [-1, -2],
  },
  '🇱🇰': {
    emoji: '🇱🇰',
    backgroundImage: background118,
    backgroundPosition: [0, 0],
  },
  '🇧🇱': {
    emoji: '🇧🇱',
    backgroundImage: background111,
    backgroundPosition: [-1, -3],
  },
  '🇸🇭': {
    emoji: '🇸🇭',
    backgroundImage: background119,
    backgroundPosition: [-4, -3],
  },
  '🇰🇳': {
    emoji: '🇰🇳',
    backgroundImage: background114,
    backgroundPosition: [0, -3],
  },
  '🇱🇨': {
    emoji: '🇱🇨',
    backgroundImage: background114,
    backgroundPosition: [-3, -4],
  },
  '🇵🇲': {
    emoji: '🇵🇲',
    backgroundImage: background119,
    backgroundPosition: [0, 0],
  },
  '🇻🇨': {
    emoji: '🇻🇨',
    backgroundImage: background110,
    backgroundPosition: [-4, -1],
  },
  '🇸🇩': {
    emoji: '🇸🇩',
    backgroundImage: background119,
    backgroundPosition: [-1, -3],
  },
  '🇸🇷': {
    emoji: '🇸🇷',
    backgroundImage: background116,
    backgroundPosition: [-2, 0],
  },
  '🇸🇪': {
    emoji: '🇸🇪',
    backgroundImage: background119,
    backgroundPosition: [-2, -3],
  },
  '🇨🇭': {
    emoji: '🇨🇭',
    backgroundImage: background113,
    backgroundPosition: [-3, -1],
  },
  '🇸🇾': {
    emoji: '🇸🇾',
    backgroundImage: background116,
    backgroundPosition: [-2, -1],
  },
  '🇹🇼': {
    emoji: '🇹🇼',
    backgroundImage: background116,
    backgroundPosition: [-4, -4],
  },
  '🇹🇯': {
    emoji: '🇹🇯',
    backgroundImage: background116,
    backgroundPosition: [0, -3],
  },
  '🇹🇿': {
    emoji: '🇹🇿',
    backgroundImage: background110,
    backgroundPosition: [0, 0],
  },
  '🇹🇭': {
    emoji: '🇹🇭',
    backgroundImage: background116,
    backgroundPosition: [-4, -2],
  },
  '🇹🇱': {
    emoji: '🇹🇱',
    backgroundImage: background116,
    backgroundPosition: [-2, -3],
  },
  '🇹🇬': {
    emoji: '🇹🇬',
    backgroundImage: background116,
    backgroundPosition: [-3, -2],
  },
  '🇹🇰': {
    emoji: '🇹🇰',
    backgroundImage: background116,
    backgroundPosition: [-1, -3],
  },
  '🇹🇴': {
    emoji: '🇹🇴',
    backgroundImage: background116,
    backgroundPosition: [0, -4],
  },
  '🇹🇹': {
    emoji: '🇹🇹',
    backgroundImage: background116,
    backgroundPosition: [-2, -4],
  },
  '🇹🇳': {
    emoji: '🇹🇳',
    backgroundImage: background116,
    backgroundPosition: [-4, -3],
  },
  '🇹🇷': {
    emoji: '🇹🇷',
    backgroundImage: background116,
    backgroundPosition: [-1, -4],
  },
  '🇹🇲': {
    emoji: '🇹🇲',
    backgroundImage: background116,
    backgroundPosition: [-3, -3],
  },
  '🇹🇨': {
    emoji: '🇹🇨',
    backgroundImage: background116,
    backgroundPosition: [0, -2],
  },
  '🇹🇻': {
    emoji: '🇹🇻',
    backgroundImage: background116,
    backgroundPosition: [-3, -4],
  },
  '🇻🇮': {
    emoji: '🇻🇮',
    backgroundImage: background110,
    backgroundPosition: [-2, -2],
  },
  '🇺🇬': {
    emoji: '🇺🇬',
    backgroundImage: background110,
    backgroundPosition: [-2, 0],
  },
  '🇺🇦': {
    emoji: '🇺🇦',
    backgroundImage: background110,
    backgroundPosition: [-1, 0],
  },
  '🇦🇪': {
    emoji: '🇦🇪',
    backgroundImage: background108,
    backgroundPosition: [-2, -3],
  },
  '🇬🇧': {
    emoji: '🇬🇧',
    backgroundImage: background112,
    backgroundPosition: [-1, -4],
  },
  '🏴󠁧󠁢󠁥󠁮󠁧󠁿': {
    emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    backgroundImage: background77,
    backgroundPosition: [-2, 0],
  },
  '🏴󠁧󠁢󠁳󠁣󠁴󠁿': {
    emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    backgroundImage: background77,
    backgroundPosition: [-3, 0],
  },
  '🏴󠁧󠁢󠁷󠁬󠁳󠁿': {
    emoji: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    backgroundImage: background77,
    backgroundPosition: [-4, 0],
  },
  '🇺🇸': {
    emoji: '🇺🇸',
    backgroundImage: background110,
    backgroundPosition: [0, -1],
  },
  '🇺🇾': {
    emoji: '🇺🇾',
    backgroundImage: background110,
    backgroundPosition: [-1, -1],
  },
  '🇺🇿': {
    emoji: '🇺🇿',
    backgroundImage: background110,
    backgroundPosition: [-2, -1],
  },
  '🇻🇺': {
    emoji: '🇻🇺',
    backgroundImage: background110,
    backgroundPosition: [-4, -2],
  },
  '🇻🇦': {
    emoji: '🇻🇦',
    backgroundImage: background110,
    backgroundPosition: [-3, -1],
  },
  '🇻🇪': {
    emoji: '🇻🇪',
    backgroundImage: background110,
    backgroundPosition: [0, -2],
  },
  '🇻🇳': {
    emoji: '🇻🇳',
    backgroundImage: background110,
    backgroundPosition: [-3, -2],
  },
  '🇼🇫': {
    emoji: '🇼🇫',
    backgroundImage: background110,
    backgroundPosition: [0, -3],
  },
  '🇪🇭': {
    emoji: '🇪🇭',
    backgroundImage: background112,
    backgroundPosition: [-4, -1],
  },
  '🇾🇪': {
    emoji: '🇾🇪',
    backgroundImage: background110,
    backgroundPosition: [-3, -3],
  },
  '🇿🇲': {
    emoji: '🇿🇲',
    backgroundImage: background110,
    backgroundPosition: [-1, -4],
  },
  '🇿🇼': {
    emoji: '🇿🇼',
    backgroundImage: background110,
    backgroundPosition: [-2, -4],
  },
} as const;

export const emojiInfoMap: Record<EmojiChar, EmojiInfo> = emojiInfoMapType;

export type EmojiChar = keyof typeof emojiInfoMapType;

export interface EmojiInfo {
  emoji: EmojiChar;
  backgroundImage: string;
  backgroundPosition: readonly [number, number];
}

export const packList: EmojiChar[][] = [
  [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '🥹',
    '😅',
    '😂',
    '🤣',
    '🥲',
    '☺️',
    '😊',
    '😇',
    '🙂',
    '🙃',
    '😉',
    '😌',
    '😍',
    '🥰',
    '😘',
    '😗',
    '😙',
    '😚',
    '😋',
    '😛',
    '😝',
    '😜',
    '🤪',
    '🤨',
    '🧐',
    '🤓',
    '😎',
    '🥸',
    '🤩',
    '🥳',
    '😏',
    '😒',
    '😞',
    '😔',
    '😟',
    '😕',
    '🙁',
    '☹️',
    '😣',
    '😖',
    '😫',
    '😩',
    '🥺',
    '😢',
    '😭',
    '😤',
    '😠',
    '😡',
    '🤬',
    '🤯',
    '😳',
    '🥵',
    '🥶',
    '😶‍🌫️',
    '😱',
    '😨',
    '😰',
    '😥',
    '😓',
    '🤗',
    '🤔',
    '🫣',
    '🤭',
    '🫢',
    '🫡',
    '🤫',
    '🫠',
    '🤥',
    '😶',
    '🫥',
    '😐',
    '🫤',
    '😑',
    '😬',
    '🙄',
    '😯',
    '😦',
    '😧',
    '😮',
    '😲',
    '🥱',
    '😴',
    '🤤',
    '😪',
    '😮‍💨',
    '😵',
    '😵‍💫',
    '🤐',
    '🥴',
    '🤢',
    '🤮',
    '🤧',
    '😷',
    '🤒',
    '🤕',
    '🤑',
    '🤠',
    '😈',
    '👿',
    '👹',
    '👺',
    '🤡',
    '💩',
    '👻',
    '💀',
    '☠️',
    '👽',
    '👾',
    '🤖',
    '🎃',
    '😺',
    '😸',
    '😹',
    '😻',
    '😼',
    '😽',
    '🙀',
    '😿',
    '😾',
    '🫶',
    '🤲',
    '👐',
    '🙌',
    '👏',
    '🤝',
    '👍',
    '👎',
    '👊',
    '✊',
    '🤛',
    '🤜',
    '🤞',
    '✌️',
    '🫰',
    '🤟',
    '🤘',
    '👌',
    '🤌',
    '🤏',
    '🫳',
    '🫴',
    '👈',
    '👉',
    '👆',
    '👇',
    '☝️',
    '✋',
    '🤚',
    '🖐️',
    '🖖',
    '👋',
    '🤙',
    '🫲',
    '🫱',
    '💪',
    '🦾',
    '🖕',
    '✍️',
    '🙏',
    '🫵',
    '🦶',
    '🦵',
    '🦿',
    '💄',
    '💋',
    '👄',
    '🫦',
    '🦷',
    '👅',
    '👂',
    '🦻',
    '👃',
    '👣',
    '👁️',
    '👀',
    '🫀',
    '🫁',
    '🧠',
    '🗣️',
    '👤',
    '👥',
    '🫂',
    '👶',
    '👧',
    '🧒',
    '👦',
    '👩',
    '🧑',
    '👨',
    '👩‍🦱',
    '🧑‍🦱',
    '👨‍🦱',
    '👩‍🦰',
    '🧑‍🦰',
    '👨‍🦰',
    '👱‍♀️',
    '👱',
    '👱‍♂️',
    '👩‍🦳',
    '🧑‍🦳',
    '👨‍🦳',
    '👩‍🦲',
    '🧑‍🦲',
    '👨‍🦲',
    '🧔‍♀️',
    '🧔',
    '🧔‍♂️',
    '👵',
    '🧓',
    '👴',
    '👲',
    '👳‍♀️',
    '👳',
    '👳‍♂️',
    '🧕',
    '👮‍♀️',
    '👮',
    '👮‍♂️',
    '👷‍♀️',
    '👷',
    '👷‍♂️',
    '💂‍♀️',
    '💂',
    '💂‍♂️',
    '🕵️‍♀️',
    '🕵️',
    '🕵️‍♂️',
    '👩‍⚕️',
    '🧑‍⚕️',
    '👨‍⚕️',
    '👩‍🌾',
    '🧑‍🌾',
    '👨‍🌾',
    '👩‍🍳',
    '🧑‍🍳',
    '👨‍🍳',
    '👩‍🎓',
    '🧑‍🎓',
    '👨‍🎓',
    '👩‍🎤',
    '🧑‍🎤',
    '👨‍🎤',
    '👩‍🏫',
    '🧑‍🏫',
    '👨‍🏫',
    '👩‍🏭',
    '🧑‍🏭',
    '👨‍🏭',
    '👩‍💻',
    '🧑‍💻',
    '👨‍💻',
    '👩‍💼',
    '🧑‍💼',
    '👨‍💼',
    '👩‍🔧',
    '🧑‍🔧',
    '👨‍🔧',
    '👩‍🔬',
    '🧑‍🔬',
    '👨‍🔬',
    '👩‍🎨',
    '🧑‍🎨',
    '👨‍🎨',
    '👩‍🚒',
    '🧑‍🚒',
    '👨‍🚒',
    '👩‍✈️',
    '🧑‍✈️',
    '👨‍✈️',
    '👩‍🚀',
    '🧑‍🚀',
    '👨‍🚀',
    '👩‍⚖️',
    '🧑‍⚖️',
    '👨‍⚖️',
    '👰‍♀️',
    '👰',
    '👰‍♂️',
    '🤵‍♀️',
    '🤵',
    '🤵‍♂️',
    '👸',
    '🫅',
    '🤴',
    '🥷',
    '🦸‍♀️',
    '🦸',
    '🦸‍♂️',
    '🦹‍♀️',
    '🦹',
    '🦹‍♂️',
    '🤶',
    '🧑‍🎄',
    '🎅',
    '🧙‍♀️',
    '🧙',
    '🧙‍♂️',
    '🧝‍♀️',
    '🧝',
    '🧝‍♂️',
    '🧌',
    '🧛‍♀️',
    '🧛',
    '🧛‍♂️',
    '🧟‍♀️',
    '🧟',
    '🧟‍♂️',
    '🧞‍♀️',
    '🧞',
    '🧞‍♂️',
    '🧜‍♀️',
    '🧜',
    '🧜‍♂️',
    '🧚‍♀️',
    '🧚',
    '🧚‍♂️',
    '👼',
    '🤰',
    '🫄',
    '🫃',
    '🤱',
    '👩‍🍼',
    '🧑‍🍼',
    '👨‍🍼',
    '🙇‍♀️',
    '🙇',
    '🙇‍♂️',
    '💁‍♀️',
    '💁',
    '💁‍♂️',
    '🙅‍♀️',
    '🙅',
    '🙅‍♂️',
    '🙆‍♀️',
    '🙆',
    '🙆‍♂️',
    '🙋‍♀️',
    '🙋',
    '🙋‍♂️',
    '🧏‍♀️',
    '🧏',
    '🧏‍♂️',
    '🤦‍♀️',
    '🤦',
    '🤦‍♂️',
    '🤷‍♀️',
    '🤷',
    '🤷‍♂️',
    '🙎‍♀️',
    '🙎',
    '🙎‍♂️',
    '🙍‍♀️',
    '🙍',
    '🙍‍♂️',
    '💇‍♀️',
    '💇',
    '💇‍♂️',
    '💆‍♀️',
    '💆',
    '💆‍♂️',
    '🧖‍♀️',
    '🧖',
    '🧖‍♂️',
    '💅',
    '🤳',
    '💃',
    '🕺',
    '👯‍♀️',
    '👯',
    '👯‍♂️',
    '🕴️',
    '👩‍🦽',
    '🧑‍🦽',
    '👨‍🦽',
    '👩‍🦼',
    '🧑‍🦼',
    '👨‍🦼',
    '🚶‍♀️',
    '🚶',
    '🚶‍♂️',
    '👩‍🦯',
    '🧑‍🦯',
    '👨‍🦯',
    '🧎‍♀️',
    '🧎',
    '🧎‍♂️',
    '🏃‍♀️',
    '🏃',
    '🏃‍♂️',
    '🧍‍♀️',
    '🧍',
    '🧍‍♂️',
    '👫',
    '👭',
    '👬',
    '👩‍❤️‍👨',
    '👩‍❤️‍👩',
    '💑',
    '👨‍❤️‍👨',
    '👩‍❤️‍💋‍👨',
    '👩‍❤️‍💋‍👩',
    '💏',
    '👨‍❤️‍💋‍👨',
    '👨‍👩‍👦',
    '👨‍👩‍👧',
    '👨‍👩‍👧‍👦',
    '👨‍👩‍👦‍👦',
    '👨‍👩‍👧‍👧',
    '👩‍👩‍👦',
    '👩‍👩‍👧',
    '👩‍👩‍👧‍👦',
    '👩‍👩‍👦‍👦',
    '👩‍👩‍👧‍👧',
    '👨‍👨‍👦',
    '👨‍👨‍👧',
    '👨‍👨‍👧‍👦',
    '👨‍👨‍👦‍👦',
    '👨‍👨‍👧‍👧',
    '👩‍👦',
    '👩‍👧',
    '👩‍👧‍👦',
    '👩‍👦‍👦',
    '👩‍👧‍👧',
    '👨‍👦',
    '👨‍👧',
    '👨‍👧‍👦',
    '👨‍👦‍👦',
    '👨‍👧‍👧',
    '🪢',
    '🧶',
    '🧵',
    '🪡',
    '🧥',
    '🥼',
    '🦺',
    '👚',
    '👕',
    '👖',
    '🩲',
    '🩳',
    '👔',
    '👗',
    '👙',
    '🩱',
    '👘',
    '🥻',
    '🩴',
    '🥿',
    '👠',
    '👡',
    '👢',
    '👞',
    '👟',
    '🥾',
    '🧦',
    '🧤',
    '🧣',
    '🎩',
    '🧢',
    '👒',
    '🎓',
    '⛑️',
    '🪖',
    '👑',
    '💍',
    '👝',
    '👛',
    '👜',
    '💼',
    '🎒',
    '🧳',
    '👓',
    '🕶️',
    '🥽',
    '🌂',
  ],
  [
    '🐶',
    '🐱',
    '🐭',
    '🐹',
    '🐰',
    '🦊',
    '🐻',
    '🐼',
    '🐻‍❄️',
    '🐨',
    '🐯',
    '🦁',
    '🐮',
    '🐷',
    '🐽',
    '🐸',
    '🐵',
    '🙈',
    '🙉',
    '🙊',
    '🐒',
    '🐔',
    '🐧',
    '🐦',
    '🐤',
    '🐣',
    '🐥',
    '🦆',
    '🦅',
    '🦉',
    '🦇',
    '🐺',
    '🐗',
    '🐴',
    '🦄',
    '🐝',
    '🪱',
    '🐛',
    '🦋',
    '🐌',
    '🐞',
    '🐜',
    '🪰',
    '🪲',
    '🪳',
    '🦟',
    '🦗',
    '🕷️',
    '🕸️',
    '🦂',
    '🐢',
    '🐍',
    '🦎',
    '🦖',
    '🦕',
    '🐙',
    '🦑',
    '🦐',
    '🦞',
    '🦀',
    '🐡',
    '🐠',
    '🐟',
    '🐬',
    '🐳',
    '🐋',
    '🦈',
    '🦭',
    '🐊',
    '🐅',
    '🐆',
    '🦓',
    '🦍',
    '🦧',
    '🦣',
    '🐘',
    '🦛',
    '🦏',
    '🐪',
    '🐫',
    '🦒',
    '🦘',
    '🦬',
    '🐃',
    '🐂',
    '🐄',
    '🐎',
    '🐖',
    '🐏',
    '🐑',
    '🦙',
    '🐐',
    '🦌',
    '🐕',
    '🐩',
    '🦮',
    '🐕‍🦺',
    '🐈',
    '🐈‍⬛',
    '🪶',
    '🐓',
    '🦃',
    '🦤',
    '🦚',
    '🦜',
    '🦢',
    '🦩',
    '🕊️',
    '🐇',
    '🦝',
    '🦨',
    '🦡',
    '🦫',
    '🦦',
    '🦥',
    '🐁',
    '🐀',
    '🐿️',
    '🦔',
    '🐾',
    '🐉',
    '🐲',
    '🌵',
    '🎄',
    '🌲',
    '🌳',
    '🌴',
    '🪵',
    '🌱',
    '🌿',
    '☘️',
    '🍀',
    '🎍',
    '🪴',
    '🎋',
    '🍃',
    '🍂',
    '🍁',
    '🪺',
    '🪹',
    '🍄',
    '🐚',
    '🪸',
    '🪨',
    '🌾',
    '💐',
    '🌷',
    '🌹',
    '🥀',
    '🪷',
    '🌺',
    '🌸',
    '🌼',
    '🌻',
    '🌞',
    '🌝',
    '🌛',
    '🌜',
    '🌚',
    '🌕',
    '🌖',
    '🌗',
    '🌘',
    '🌑',
    '🌒',
    '🌓',
    '🌔',
    '🌙',
    '🌎',
    '🌍',
    '🌏',
    '🪐',
    '💫',
    '⭐',
    '🌟',
    '✨',
    '⚡',
    '☄️',
    '💥',
    '🔥',
    '🌪️',
    '🌈',
    '☀️',
    '🌤️',
    '⛅',
    '🌥️',
    '☁️',
    '🌦️',
    '🌧️',
    '⛈️',
    '🌩️',
    '🌨️',
    '❄️',
    '☃️',
    '⛄',
    '🌬️',
    '💨',
    '💧',
    '💦',
    '🫧',
    '☔',
    '☂️',
    '🌊',
    '🌫️',
  ],
  [
    '🍏',
    '🍎',
    '🍐',
    '🍊',
    '🍋',
    '🍌',
    '🍉',
    '🍇',
    '🍓',
    '🫐',
    '🍈',
    '🍒',
    '🍑',
    '🥭',
    '🍍',
    '🥥',
    '🥝',
    '🍅',
    '🍆',
    '🥑',
    '🥦',
    '🥬',
    '🥒',
    '🌶️',
    '🫑',
    '🌽',
    '🥕',
    '🫒',
    '🧄',
    '🧅',
    '🥔',
    '🍠',
    '🥐',
    '🥯',
    '🍞',
    '🥖',
    '🥨',
    '🧀',
    '🥚',
    '🍳',
    '🧈',
    '🥞',
    '🧇',
    '🥓',
    '🥩',
    '🍗',
    '🍖',
    '🦴',
    '🌭',
    '🍔',
    '🍟',
    '🍕',
    '🫓',
    '🥪',
    '🥙',
    '🧆',
    '🌮',
    '🌯',
    '🫔',
    '🥗',
    '🥘',
    '🫕',
    '🥫',
    '🫙',
    '🍝',
    '🍜',
    '🍲',
    '🍛',
    '🍣',
    '🍱',
    '🥟',
    '🦪',
    '🍤',
    '🍙',
    '🍚',
    '🍘',
    '🍥',
    '🥠',
    '🥮',
    '🍢',
    '🍡',
    '🍧',
    '🍨',
    '🍦',
    '🥧',
    '🧁',
    '🍰',
    '🎂',
    '🍮',
    '🍭',
    '🍬',
    '🍫',
    '🍿',
    '🍩',
    '🍪',
    '🌰',
    '🥜',
    '🫘',
    '🍯',
    '🥛',
    '🫗',
    '🍼',
    '🫖',
    '☕',
    '🍵',
    '🧃',
    '🥤',
    '🧋',
    '🍶',
    '🍺',
    '🍻',
    '🥂',
    '🍷',
    '🥃',
    '🍸',
    '🍹',
    '🧉',
    '🍾',
    '🧊',
    '🥄',
    '🍴',
    '🍽️',
    '🥣',
    '🥡',
    '🥢',
    '🧂',
  ],
  [
    '⚽',
    '🏀',
    '🏈',
    '⚾',
    '🥎',
    '🎾',
    '🏐',
    '🏉',
    '🥏',
    '🎱',
    '🪀',
    '🏓',
    '🏸',
    '🏒',
    '🏑',
    '🥍',
    '🏏',
    '🪃',
    '🥅',
    '⛳',
    '🪁',
    '🛝',
    '🏹',
    '🎣',
    '🤿',
    '🥊',
    '🥋',
    '🎽',
    '🛹',
    '🛼',
    '🛷',
    '⛸️',
    '🥌',
    '🎿',
    '⛷️',
    '🏂',
    '🪂',
    '🏋️‍♀️',
    '🏋️',
    '🏋️‍♂️',
    '🤼‍♀️',
    '🤼‍♂️',
    '🤸‍♀️',
    '🤸',
    '🤸‍♂️',
    '⛹️‍♀️',
    '⛹️',
    '⛹️‍♂️',
    '🤺',
    '🤾‍♀️',
    '🤾',
    '🤾‍♂️',
    '🏌️‍♀️',
    '🏌️',
    '🏌️‍♂️',
    '🏇',
    '🧘‍♀️',
    '🧘',
    '🧘‍♂️',
    '🏄‍♀️',
    '🏄',
    '🏄‍♂️',
    '🏊‍♀️',
    '🏊',
    '🏊‍♂️',
    '🤽‍♀️',
    '🤽',
    '🤽‍♂️',
    '🚣‍♀️',
    '🚣',
    '🚣‍♂️',
    '🧗‍♀️',
    '🧗',
    '🧗‍♂️',
    '🚵‍♀️',
    '🚵',
    '🚵‍♂️',
    '🚴‍♀️',
    '🚴',
    '🚴‍♂️',
    '🏆',
    '🥇',
    '🥈',
    '🥉',
    '🏅',
    '🎖️',
    '🏵️',
    '🎗️',
    '🎫',
    '🎟️',
    '🎪',
    '🤹‍♀️',
    '🤹',
    '🤹‍♂️',
    '🎭',
    '🩰',
    '🎨',
    '🎬',
    '🎤',
    '🎧',
    '🎼',
    '🎹',
    '🥁',
    '🪘',
    '🎷',
    '🎺',
    '🪗',
    '🎸',
    '🪕',
    '🎻',
    '🎲',
    '♟️',
    '🎯',
    '🎳',
    '🎮',
    '🎰',
    '🧩',
  ],
  [
    '🚗',
    '🚕',
    '🚙',
    '🚌',
    '🚎',
    '🏎️',
    '🚓',
    '🚑',
    '🚒',
    '🚐',
    '🛻',
    '🚚',
    '🚛',
    '🚜',
    '🦯',
    '🦽',
    '🦼',
    '🩼',
    '🛴',
    '🚲',
    '🛵',
    '🏍️',
    '🛺',
    '🛞',
    '🚨',
    '🚔',
    '🚍',
    '🚘',
    '🚖',
    '🚡',
    '🚠',
    '🚟',
    '🚃',
    '🚋',
    '🚞',
    '🚝',
    '🚄',
    '🚅',
    '🚈',
    '🚂',
    '🚆',
    '🚇',
    '🚊',
    '🚉',
    '✈️',
    '🛫',
    '🛬',
    '🛩️',
    '💺',
    '🛰️',
    '🚀',
    '🛸',
    '🚁',
    '🛶',
    '⛵',
    '🚤',
    '🛥️',
    '🛳️',
    '⛴️',
    '🚢',
    '🛟',
    '⚓',
    '🪝',
    '⛽',
    '🚧',
    '🚦',
    '🚥',
    '🚏',
    '🗺️',
    '🗿',
    '🗽',
    '🗼',
    '🏰',
    '🏯',
    '🏟️',
    '🎡',
    '🎢',
    '🎠',
    '⛲',
    '⛱️',
    '🏖️',
    '🏝️',
    '🏜️',
    '🌋',
    '⛰️',
    '🏔️',
    '🗻',
    '🏕️',
    '⛺',
    '🛖',
    '🏠',
    '🏡',
    '🏘️',
    '🏚️',
    '🏗️',
    '🏭',
    '🏢',
    '🏬',
    '🏣',
    '🏤',
    '🏥',
    '🏦',
    '🏨',
    '🏪',
    '🏫',
    '🏩',
    '💒',
    '🏛️',
    '⛪',
    '🕌',
    '🕍',
    '🛕',
    '🕋',
    '⛩️',
    '🛤️',
    '🛣️',
    '🗾',
    '🎑',
    '🏞️',
    '🌅',
    '🌄',
    '🌠',
    '🎇',
    '🎆',
    '🌇',
    '🌆',
    '🏙️',
    '🌃',
    '🌌',
    '🌉',
    '🌁',
  ],
  [
    '⌚',
    '📱',
    '📲',
    '💻',
    '⌨️',
    '🖥️',
    '🖨️',
    '🖱️',
    '🖲️',
    '🕹️',
    '🗜️',
    '💽',
    '💾',
    '💿',
    '📀',
    '📼',
    '📷',
    '📸',
    '📹',
    '🎥',
    '📽️',
    '🎞️',
    '📞',
    '☎️',
    '📟',
    '📠',
    '📺',
    '📻',
    '🎙️',
    '🎚️',
    '🎛️',
    '🧭',
    '⏱️',
    '⏲️',
    '⏰',
    '🕰️',
    '⌛',
    '⏳',
    '📡',
    '🔋',
    '🪫',
    '🔌',
    '💡',
    '🔦',
    '🕯️',
    '🪔',
    '🧯',
    '🛢️',
    '💸',
    '💵',
    '💴',
    '💶',
    '💷',
    '🪙',
    '💰',
    '💳',
    '🪪',
    '💎',
    '⚖️',
    '🪜',
    '🧰',
    '🪛',
    '🔧',
    '🔨',
    '⚒️',
    '🛠️',
    '⛏️',
    '🪚',
    '🔩',
    '⚙️',
    '🪤',
    '🧱',
    '⛓️',
    '🧲',
    '🔫',
    '💣',
    '🧨',
    '🪓',
    '🔪',
    '🗡️',
    '⚔️',
    '🛡️',
    '🚬',
    '⚰️',
    '🪦',
    '⚱️',
    '🏺',
    '🔮',
    '📿',
    '🧿',
    '🪬',
    '💈',
    '⚗️',
    '🔭',
    '🔬',
    '🕳️',
    '🩻',
    '🩹',
    '🩺',
    '💊',
    '💉',
    '🩸',
    '🧬',
    '🦠',
    '🧫',
    '🧪',
    '🌡️',
    '🧹',
    '🪠',
    '🧺',
    '🧻',
    '🚽',
    '🚰',
    '🚿',
    '🛁',
    '🛀',
    '🧼',
    '🪥',
    '🪒',
    '🧽',
    '🪣',
    '🧴',
    '🛎️',
    '🔑',
    '🗝️',
    '🚪',
    '🪑',
    '🛋️',
    '🛏️',
    '🛌',
    '🧸',
    '🪆',
    '🖼️',
    '🪞',
    '🪟',
    '🛍️',
    '🛒',
    '🎁',
    '🎈',
    '🎏',
    '🎀',
    '🪄',
    '🪅',
    '🎊',
    '🎉',
    '🎎',
    '🏮',
    '🎐',
    '🪩',
    '🧧',
    '✉️',
    '📩',
    '📨',
    '📧',
    '💌',
    '📥',
    '📤',
    '📦',
    '🏷️',
    '🪧',
    '📪',
    '📫',
    '📬',
    '📭',
    '📮',
    '📯',
    '📜',
    '📃',
    '📄',
    '📑',
    '🧾',
    '📊',
    '📈',
    '📉',
    '🗒️',
    '🗓️',
    '📆',
    '📅',
    '🗑️',
    '📇',
    '🗃️',
    '🗳️',
    '🗄️',
    '📋',
    '📁',
    '📂',
    '🗂️',
    '🗞️',
    '📰',
    '📓',
    '📔',
    '📒',
    '📕',
    '📗',
    '📘',
    '📙',
    '📚',
    '📖',
    '🔖',
    '🧷',
    '🔗',
    '📎',
    '🖇️',
    '📐',
    '📏',
    '🧮',
    '📌',
    '📍',
    '✂️',
    '🖊️',
    '🖋️',
    '✒️',
    '🖌️',
    '🖍️',
    '📝',
    '✏️',
    '🔍',
    '🔎',
    '🔏',
    '🔐',
    '🔒',
    '🔓',
  ],
  [
    '❤️',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🖤',
    '🤍',
    '🤎',
    '💔',
    '❤️‍🔥',
    '❤️‍🩹',
    '❣️',
    '💕',
    '💞',
    '💓',
    '💗',
    '💖',
    '💘',
    '💝',
    '💟',
    '☮️',
    '✝️',
    '☪️',
    '🕉️',
    '☸️',
    '✡️',
    '🔯',
    '🕎',
    '☯️',
    '☦️',
    '🛐',
    '⛎',
    '♈',
    '♉',
    '♊',
    '♋',
    '♌',
    '♍',
    '♎',
    '♏',
    '♐',
    '♑',
    '♒',
    '♓',
    '🆔',
    '⚛️',
    '🉑',
    '☢️',
    '☣️',
    '📴',
    '📳',
    '🈶',
    '🈚',
    '🈸',
    '🈺',
    '🈷️',
    '✴️',
    '🆚',
    '💮',
    '🉐',
    '㊙️',
    '㊗️',
    '🈴',
    '🈵',
    '🈹',
    '🈲',
    '🅰️',
    '🅱️',
    '🆎',
    '🆑',
    '🅾️',
    '🆘',
    '❌',
    '⭕',
    '🛑',
    '⛔',
    '📛',
    '🚫',
    '💯',
    '💢',
    '♨️',
    '🚷',
    '🚯',
    '🚳',
    '🚱',
    '🔞',
    '📵',
    '🚭',
    '❗',
    '❕',
    '❓',
    '❔',
    '‼️',
    '⁉️',
    '🔅',
    '🔆',
    '〽️',
    '⚠️',
    '🚸',
    '🔱',
    '⚜️',
    '🔰',
    '♻️',
    '✅',
    '🈯',
    '💹',
    '❇️',
    '✳️',
    '❎',
    '🌐',
    '💠',
    'Ⓜ️',
    '🌀',
    '💤',
    '🏧',
    '🚾',
    '♿',
    '🅿️',
    '🛗',
    '🈳',
    '🈂️',
    '🛂',
    '🛃',
    '🛄',
    '🛅',
    '🚹',
    '🚺',
    '🚼',
    '⚧️',
    '🚻',
    '🚮',
    '🎦',
    '📶',
    '🈁',
    '🔣',
    'ℹ️',
    '🔤',
    '🔡',
    '🔠',
    '🆖',
    '🆗',
    '🆙',
    '🆒',
    '🆕',
    '🆓',
    '0️⃣',
    '1️⃣',
    '2️⃣',
    '3️⃣',
    '4️⃣',
    '5️⃣',
    '6️⃣',
    '7️⃣',
    '8️⃣',
    '9️⃣',
    '🔟',
    '🔢',
    '#️⃣',
    '*️⃣',
    '⏏️',
    '▶️',
    '⏸️',
    '⏯️',
    '⏹️',
    '⏺️',
    '⏭️',
    '⏮️',
    '⏩',
    '⏪',
    '⏫',
    '⏬',
    '◀️',
    '🔼',
    '🔽',
    '➡️',
    '⬅️',
    '⬆️',
    '⬇️',
    '↗️',
    '↘️',
    '↙️',
    '↖️',
    '↕️',
    '↔️',
    '↪️',
    '↩️',
    '⤴️',
    '⤵️',
    '🔀',
    '🔁',
    '🔂',
    '🔄',
    '🔃',
    '🎵',
    '🎶',
    '➕',
    '➖',
    '➗',
    '✖️',
    '🟰',
    '♾️',
    '💲',
    '💱',
    '™️',
    '©️',
    '®️',
    '👁️‍🗨️',
    '🔚',
    '🔙',
    '🔛',
    '🔝',
    '🔜',
    '〰️',
    '➰',
    '➿',
    '✔️',
    '☑️',
    '🔘',
    '🔴',
    '🟠',
    '🟡',
    '🟢',
    '🔵',
    '🟣',
    '⚫',
    '⚪',
    '🟤',
    '🔺',
    '🔻',
    '🔸',
    '🔹',
    '🔶',
    '🔷',
    '🔳',
    '🔲',
    '▪️',
    '▫️',
    '◾',
    '◽',
    '◼️',
    '◻️',
    '🟥',
    '🟧',
    '🟨',
    '🟩',
    '🟦',
    '🟪',
    '⬛',
    '⬜',
    '🟫',
    '🔈',
    '🔇',
    '🔉',
    '🔊',
    '🔔',
    '🔕',
    '📣',
    '📢',
    '💬',
    '💭',
    '🗯️',
    '♠️',
    '♣️',
    '♥️',
    '♦️',
    '🃏',
    '🎴',
    '🀄',
    '🕐',
    '🕑',
    '🕒',
    '🕓',
    '🕔',
    '🕕',
    '🕖',
    '🕗',
    '🕘',
    '🕙',
    '🕚',
    '🕛',
    '🕜',
    '🕝',
    '🕞',
    '🕟',
    '🕠',
    '🕡',
    '🕢',
    '🕣',
    '🕤',
    '🕥',
    '🕦',
    '🕧',
  ],
  [
    '🏳️',
    '🏴',
    '🏴‍☠️',
    '🏁',
    '🚩',
    '🏳️‍🌈',
    '🏳️‍⚧️',
    '🇺🇳',
    '🇦🇫',
    '🇦🇽',
    '🇦🇱',
    '🇩🇿',
    '🇦🇸',
    '🇦🇩',
    '🇦🇴',
    '🇦🇮',
    '🇦🇶',
    '🇦🇬',
    '🇦🇷',
    '🇦🇲',
    '🇦🇼',
    '🇦🇺',
    '🇦🇹',
    '🇦🇿',
    '🇧🇸',
    '🇧🇭',
    '🇧🇩',
    '🇧🇧',
    '🇧🇾',
    '🇧🇪',
    '🇧🇿',
    '🇧🇯',
    '🇧🇲',
    '🇧🇹',
    '🇧🇴',
    '🇧🇦',
    '🇧🇼',
    '🇧🇷',
    '🇻🇬',
    '🇧🇳',
    '🇧🇬',
    '🇧🇫',
    '🇧🇮',
    '🇰🇭',
    '🇨🇲',
    '🇨🇦',
    '🇮🇨',
    '🇨🇻',
    '🇧🇶',
    '🇰🇾',
    '🇨🇫',
    '🇹🇩',
    '🇮🇴',
    '🇨🇱',
    '🇨🇳',
    '🇨🇽',
    '🇨🇨',
    '🇨🇴',
    '🇰🇲',
    '🇨🇬',
    '🇨🇩',
    '🇨🇰',
    '🇨🇷',
    '🇨🇮',
    '🇭🇷',
    '🇨🇺',
    '🇨🇼',
    '🇨🇾',
    '🇨🇿',
    '🇩🇰',
    '🇩🇯',
    '🇩🇲',
    '🇩🇴',
    '🇪🇨',
    '🇪🇬',
    '🇸🇻',
    '🇬🇶',
    '🇪🇷',
    '🇪🇪',
    '🇸🇿',
    '🇪🇹',
    '🇪🇺',
    '🇫🇰',
    '🇫🇴',
    '🇫🇯',
    '🇫🇮',
    '🇫🇷',
    '🇬🇫',
    '🇵🇫',
    '🇹🇫',
    '🇬🇦',
    '🇬🇲',
    '🇬🇪',
    '🇩🇪',
    '🇬🇭',
    '🇬🇮',
    '🇬🇷',
    '🇬🇱',
    '🇬🇩',
    '🇬🇵',
    '🇬🇺',
    '🇬🇹',
    '🇬🇬',
    '🇬🇳',
    '🇬🇼',
    '🇬🇾',
    '🇭🇹',
    '🇭🇳',
    '🇭🇰',
    '🇭🇺',
    '🇮🇸',
    '🇮🇳',
    '🇮🇩',
    '🇮🇷',
    '🇮🇶',
    '🇮🇪',
    '🇮🇲',
    '🇮🇱',
    '🇮🇹',
    '🇯🇲',
    '🇯🇵',
    '🎌',
    '🇯🇪',
    '🇯🇴',
    '🇰🇿',
    '🇰🇪',
    '🇰🇮',
    '🇽🇰',
    '🇰🇼',
    '🇰🇬',
    '🇱🇦',
    '🇱🇻',
    '🇱🇧',
    '🇱🇸',
    '🇱🇷',
    '🇱🇾',
    '🇱🇮',
    '🇱🇹',
    '🇱🇺',
    '🇲🇴',
    '🇲🇬',
    '🇲🇼',
    '🇲🇾',
    '🇲🇻',
    '🇲🇱',
    '🇲🇹',
    '🇲🇭',
    '🇲🇶',
    '🇲🇷',
    '🇲🇺',
    '🇾🇹',
    '🇲🇽',
    '🇫🇲',
    '🇲🇩',
    '🇲🇨',
    '🇲🇳',
    '🇲🇪',
    '🇲🇸',
    '🇲🇦',
    '🇲🇿',
    '🇲🇲',
    '🇳🇦',
    '🇳🇷',
    '🇳🇵',
    '🇳🇱',
    '🇳🇨',
    '🇳🇿',
    '🇳🇮',
    '🇳🇪',
    '🇳🇬',
    '🇳🇺',
    '🇳🇫',
    '🇰🇵',
    '🇲🇰',
    '🇲🇵',
    '🇳🇴',
    '🇴🇲',
    '🇵🇰',
    '🇵🇼',
    '🇵🇸',
    '🇵🇦',
    '🇵🇬',
    '🇵🇾',
    '🇵🇪',
    '🇵🇭',
    '🇵🇳',
    '🇵🇱',
    '🇵🇹',
    '🇵🇷',
    '🇶🇦',
    '🇷🇪',
    '🇷🇴',
    '🇷🇺',
    '🇷🇼',
    '🇼🇸',
    '🇸🇲',
    '🇸🇹',
    '🇸🇦',
    '🇸🇳',
    '🇷🇸',
    '🇸🇨',
    '🇸🇱',
    '🇸🇬',
    '🇸🇽',
    '🇸🇰',
    '🇸🇮',
    '🇬🇸',
    '🇸🇧',
    '🇸🇴',
    '🇿🇦',
    '🇰🇷',
    '🇸🇸',
    '🇪🇸',
    '🇱🇰',
    '🇧🇱',
    '🇸🇭',
    '🇰🇳',
    '🇱🇨',
    '🇵🇲',
    '🇻🇨',
    '🇸🇩',
    '🇸🇷',
    '🇸🇪',
    '🇨🇭',
    '🇸🇾',
    '🇹🇼',
    '🇹🇯',
    '🇹🇿',
    '🇹🇭',
    '🇹🇱',
    '🇹🇬',
    '🇹🇰',
    '🇹🇴',
    '🇹🇹',
    '🇹🇳',
    '🇹🇷',
    '🇹🇲',
    '🇹🇨',
    '🇹🇻',
    '🇻🇮',
    '🇺🇬',
    '🇺🇦',
    '🇦🇪',
    '🇬🇧',
    '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    '🇺🇸',
    '🇺🇾',
    '🇺🇿',
    '🇻🇺',
    '🇻🇦',
    '🇻🇪',
    '🇻🇳',
    '🇼🇫',
    '🇪🇭',
    '🇾🇪',
    '🇿🇲',
    '🇿🇼',
  ],
];
